// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fonts */
/* colors */
/* miscellaneous */
.str-chat {
  box-sizing: border-box;
}
.str-chat *,
.str-chat *::after,
.str-chat *::before {
  box-sizing: inherit;
}
.clearfix {
  clear: both;
}
.messenger-chat.str-chat {
  height: 100vh;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  flex: 1 0 100%;
}
.messenger-chat.str-chat .str-chat__container {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
}
.messenger-chat.str-chat .str-chat__main-panel {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 0 10px;
}
.str-chat {
  max-height: calc(100vh - 205px);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.str-chat.messaging,
.str-chat.commerce {
  background-color: #f1f1f3;
}
.str-chat.messaging.dark,
.str-chat.commerce.dark {
  background-color: #212326;
}
.str-chat.team.dark {
  background: #212326;
}
.str-chat.livestream.dark {
  background: #1a1a1a;
}
.str-chat-channel-list {
  float: left;
}
.str-chat__channel-list-empty {
  display: none;
}
.str-chat-channel {
  max-height: 100vh;
}
.str-chat-channel .str-chat__container {
  height: 100%;
  display: flex;
}
.str-chat-channel .str-chat__container .str-chat__main-panel {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.str-chat-channel.messaging .str-chat__main-panel {
  padding: 20px 10px 0 0px;
}
@media screen and (max-width: 960px) {
  .str-chat-channel.messaging .str-chat__main-panel {
    padding: 5px 5px 0;
  }
}
.str-chat-channel.team .str-chat__container {
  display: flex;
}
.str-chat-channel.commerce .str-chat__main-panel {
  width: 100%;
}
.str-chat-channel.commerce .str-chat__container {
  background: rgba(255, 255, 255, 0.97);
}
.str-chat-channel.commerce.dark .str-chat__container {
  background: rgba(29, 32, 36, 0.9);
  box-shadow: 0 10px 31px 0 rgba(0, 0, 0, 0.5);
}
.str-chat.dark .emoji-mart {
  background: #1a1a1a;
  border: #343434;
}
.str-chat.dark .emoji-mart-category-label span {
  background: #1f1f1f;
  color: white;
}
.str-chat.dark .emoji-mart-search input {
  background: #1f1f1f;
  color: white;
}
.str-chat.dark .emoji-mart-search button svg {
  fill: white;
}
/* fonts */
/* colors */
/* miscellaneous */
.str-chat__actions-box {
  background: #fff;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08), 0 1px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  position: absolute;
  min-width: 150px;
}
.str-chat__actions-box--right {
  right: 0;
  top: calc(100% + 2px);
}
.str-chat__actions-box--left {
  left: 0;
  top: calc(100% + 2px);
}
.str-chat__actions-box > button {
  text-align: left;
  width: 100%;
  border: none;
  margin: 0;
  padding: 10px;
  font-size: 12px;
  background: none;
  cursor: pointer;
}
.str-chat__actions-box > button:not(:last-of-type) {
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.08);
}
.str-chat__actions-box > button:hover {
  color: #006cff;
}
.dark.str-chat .str-chat__message-actions-box {
  background: #67686a;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08), 0 1px 8px 0 rgba(0, 0, 0, 0.05);
}
.dark.str-chat .str-chat__message-actions-box button {
  color: white;
}
.dark.str-chat .str-chat__message-actions-box button:hover {
  color: #006cff;
}
[class*=' rfu-'],
[class^='rfu-'] {
  font-family: Avenir, Arial, Helvetica, sans-serif;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.rfu-file-icon--small.svg-inline--fa {
  color: #414d54;
}
.rfu-file-icon--small.fa-file-excel {
  color: #207245;
}
.rfu-file-icon--small.fa-file-powerpoint {
  color: #cb4a32;
}
.rfu-file-icon--small.fa-file-word {
  color: #2c599d;
}
.rfu-file-icon--small.fa-file-pdf {
  color: #f82903;
}
.rfu-file-previewer {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  margin: 8px 0;
  position: relative;
}
.rfu-file-previewer ol {
  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}
.rfu-file-previewer ol li {
  position: relative;
  padding: 8px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.rfu-file-previewer ol li:last-child {
  border-color: transparent;
}
.rfu-file-previewer__file {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
}
.rfu-file-previewer__file:hover {
  background: #fafafa;
}
.rfu-file-previewer__file a {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0 8px;
  color: #414d54;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rfu-file-previewer__file svg {
  min-width: 25px;
}
.rfu-file-previewer__file--uploading {
  opacity: 0.4;
}
.rfu-file-previewer__file--failed a {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #8b9297;
}
.rfu-file-previewer__file--failed a:after {
  text-decoration: none;
}
.rfu-file-previewer__image {
  min-width: 25px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.rfu-file-previewer__loading-indicator {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  z-index: 1000;
}
.rfu-file-previewer__close-button {
  position: relative;
  z-index: 10000;
}
.rfu-file-previewer__failed {
  background: #ff6363;
}
.rfu-file-previewer__failed,
.rfu-file-previewer__retry {
  padding: 3px 6px;
  margin-left: 8px;
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
}
.rfu-file-previewer__retry {
  text-decoration: none;
  background: #63e5a4;
}
.rfu-file-upload-button {
  cursor: pointer;
}
.rfu-file-upload-button svg {
  fill: #a0b2b8;
}
.rfu-file-upload-button:hover svg {
  fill: #88979c;
}
.rfu-file-upload-button label {
  cursor: pointer;
}
.rfu-file-upload-button .rfu-file-input {
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.rfu-icon-button {
  cursor: pointer;
  position: relative;
  padding: 4px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.rfu-icon-button svg {
  margin: 4px;
  position: relative;
  z-index: 50;
  fill: #a0b2b8;
}
.rfu-icon-button:hover svg {
  fill: #88979c;
}
.rfu-dropzone .rfu-dropzone__notifier {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 30px;
  z-index: 90;
  display: none;
  border-radius: 4px;
}
.rfu-dropzone--accept .rfu-dropzone__notifier {
  background: rgba(0, 212, 106, 0.83);
  display: block;
}
.rfu-dropzone--reject .rfu-dropzone__notifier {
  background: rgba(255, 0, 0, 0.83);
  display: block;
}
.rfu-dropzone__inner {
  width: 100%;
  height: 100%;
  padding: 30px;
  border: 1px dashed #fff;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  text-align: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  color: #fff;
  font-weight: 800;
  font-size: 12px;
}
.rfu-dropzone--reject .rfu-dropzone__inner {
  display: none;
}
.rfu-image-previewer {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 8px 0;
}
.rfu-image-previewer,
.rfu-image-previewer__image {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.rfu-image-previewer__image {
  width: 100px;
  height: 100px;
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.rfu-image-previewer__image--loaded .rfu-thumbnail__overlay {
  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.4)), to(transparent));
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0, transparent);
}
.rfu-image-previewer__image .rfu-thumbnail__wrapper {
  position: absolute;
}
.rfu-image-previewer__image .rfu-loading-indicator {
  position: absolute;
  z-index: 90;
}
.rfu-image-previewer__retry {
  z-index: 90;
}
.rfu-image-upload-button {
  cursor: pointer;
}
.rfu-image-upload-button svg {
  fill: #a0b2b8;
}
.rfu-image-upload-button:hover svg {
  fill: #88979c;
}
.rfu-image-upload-button label {
  cursor: pointer;
}
.rfu-image-upload-button .rfu-image-input {
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.rfu-loading-indicator {
  margin: 0 auto;
  width: 70px;
  text-align: center;
}
.rfu-loading-indicator > div {
  width: 18px;
  height: 18px;
  background-color: #ccc;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s ease-in-out infinite both;
  animation: sk-bouncedelay 1.4s ease-in-out infinite both;
}
.rfu-loading-indicator .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.rfu-loading-indicator .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  to {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes sk-bouncedelay {
  0%,
  80%,
  to {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@-webkit-keyframes spinner {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes spinner {
  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
.rfu-loading-indicator__spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #eee;
  border-top-color: #00d46a;
  border-radius: 50%;
  -webkit-animation: spinner 0.6s linear infinite;
  animation: spinner 0.6s linear infinite;
}
.rfu-thumbnail__wrapper {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.rfu-thumbnail__overlay {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 5px;
}
.rfu-thumbnail__image {
  width: inherit;
  height: inherit;
  -o-object-fit: cover;
  object-fit: cover;
}
.rfu-thumbnail-placeholder {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border: 1px dashed #bfbfbf;
  border-radius: 4px;
  cursor: pointer;
}
.rfu-thumbnail-placeholder:hover {
  background: #f2f2f2;
}
.str-chat__attachment {
  max-width: 450px;
}
.str-chat__player-wrapper {
  position: relative;
  padding-top: 56.25%;
  /* Player ratio: 100 / (1280 / 720) */
}
.str-chat__player-wrapper .react-player {
  position: absolute;
  top: 0;
  left: 0;
}
/* border radius for attachments */
.str-chat__message .str-chat__player-wrapper .react-player {
  border-radius: 16px 16px 16px 0;
  overflow: hidden;
}
.str-chat__message--me .str-chat__player-wrapper .react-player {
  border-radius: 16px 16px 0 16px;
  overflow: hidden;
}
.str-chat__message-attachment {
  width: 100%;
  max-width: 375px;
  border-radius: 16px;
  margin: 8px auto 8px 0;
  padding: 0;
}
.str-chat__message--me .str-chat__message-attachment {
  padding-left: 0;
  margin: 8px 0 8px auto;
}
.str-chat__message-team.thread-list .str-chat__message-attachment {
  max-width: 200px;
}
.str-chat__message-attachment {
  overflow: hidden;
}
.str-chat__message-attachment:hover {
  background: transparent;
}
.str-chat__message-attachment--card--no-image {
  height: 60px;
}
.str-chat__message-attachment--card--actions {
  height: auto;
}
.str-chat__message-attachment-file {
  width: 100%;
}
.str-chat__message-attachment-file--item {
  /* border: 3px solid #f7f7f7; */
  /* border-radius: 4px; */
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 22px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  width: auto;
  padding-left: 5px;
}
.str-chat__message-attachment-file--item:hover {
  background: #f7f7f7;
}
.str-chat__message-attachment-file--item img,
.str-chat__message-attachment-file--item svg {
  margin-right: 10px;
}
.str-chat__message-attachment-file--item-text {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.str-chat__message-attachment-file--item a {
  font-weight: 700;
  color: black;
  opacity: 0.8;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.str-chat__message-attachment-file--item a::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.str-chat__message-attachment-file--item span {
  line-height: 14px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  display: block;
  color: black;
  opacity: 0.5;
}
.str-chat__message-attachment--image {
  height: auto;
  max-height: 300px;
  max-width: 100%;
  border-radius: 0;
}
.str-chat__message-attachment--image:hover {
  background: transparent;
}
.str-chat__message-attachment--image img {
  height: inherit;
  width: auto;
  max-height: inherit;
  max-width: 100%;
  display: block;
  object-fit: cover;
  overflow: hidden;
}
.str-chat__message-attachment--image img:hover {
  background: transparent;
}
.str-chat__message-attachment--image--actions {
  height: 320px;
}
.str-chat__message-attachment--image--actions img {
  height: calc(320px - 40px);
}
.str-chat__message-attachment--media {
  width: 300px;
}
.str-chat__message-attachment-card {
  min-height: 60px;
}
.str-chat__message-attachment-card__giphy-logo {
  height: 20px;
  width: auto;
}
.messaging.str-chat .str-chat__message-attachment.str-chat__message-attachment--image--actions .str-chat__message-attachment--img {
  max-height: 254px;
}
.livestream.str-chat .str-chat__message-attachment.str-chat__message-attachment--file {
  max-width: 100%;
}
.livestream.str-chat .str-chat__message-attachment.str-chat__message-attachment--file .str-chat__message-attachment-file--item {
  border-left: none;
}
.livestream.str-chat .str-chat__message-attachment.str-chat__message-attachment--file .str-chat__message-attachment-file--item:hover {
  background: rgba(255, 255, 255, 0.29);
}
.livestream.str-chat.dark .str-chat__message-attachment-file--item a,
.livestream.str-chat.dark .str-chat__message-attachment-file--item span {
  color: white;
}
.livestream.str-chat.dark .str-chat__message-attachment-file--item:hover {
  background: transparent;
}
.str-chat__message-attachment-actions-form {
  width: 100%;
  margin: 8px 0;
  padding: 0;
  display: flex;
}
.str-chat__message-attachment-actions-button {
  flex: 1;
  border: none;
  background: none;
  margin: 0 4px;
  padding: 8px 8px;
  border-radius: 100px;
  outline: none;
}
.str-chat__message-attachment-actions-button:focus {
  border: 1px solid #006cff;
  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__message-attachment-actions-button--primary {
  background-color: #006cff;
  color: white;
}
.str-chat__message-attachment-actions-button--default {
  border: 2px solid rgba(0, 0, 0, 0.08);
}
.dark.str-chat .str-chat__message-attachment-actions-button {
  color: white;
}
.dark.str-chat .str-chat__message-attachment-actions-button--default {
  border-color: rgba(255, 255, 255, 0.1);
}
.str-chat__message-attachment-card {
  position: relative;
  background: white;
  border-radius: 16px 16px 16px 0;
  overflow: hidden;
  font-size: 13px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin: 32px 0 0 0;
}
.str-chat__message-attachment-card--header {
  width: 100%;
  height: 175px;
}
.str-chat__message-attachment-card--header img {
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.str-chat__message-attachment-card--title {
  font-weight: 700;
  flex: 1;
}
.str-chat__message-attachment-card--flex {
  min-width: 0px;
}
.str-chat__message-attachment-card--flex,
.str-chat__message-attachment-card--flex > * {
  overflow: hidden;
  text-overflow: ellipsis;
}
.str-chat__message-attachment-card--content {
  padding: 8px 16px;
  margin: -8px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.str-chat__message-attachment-card--content > * {
  margin: 8px 0;
}
.str-chat__message-attachment-card--url {
  text-decoration: none;
  display: block;
  color: black;
  text-transform: uppercase;
  opacity: 0.5;
}
.str-chat__message-attachment-card--url::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.str-chat__message-attachment-card--giphy .str-chat__message-attachment-card--header {
  height: unset;
}
.str-chat.commerce .str-chat__message-attachment-card {
  max-width: 375px;
  width: 100%;
}
.str-chat__message--me .str-chat__message-attachment-card {
  background: rgba(0, 0, 0, 0.08);
  border: 1px solid transparent;
  border-radius: 16px 16px 0 16px;
}
.dark.str-chat .str-chat__message-attachment-card__giphy-logo {
  filter: invert(100%);
}
.str-chat__avatar {
  flex: 0 0 32px !important;
  font-size: 16px !important;
  height: 32px !important;
  line-height: 32px !important;
  margin-right: 14px !important;
  width: 32px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-transform: uppercase;
  overflow: hidden;
}
.str-chat__avatar--circle {
  border-radius: 50%;
}
.str-chat__avatar--rounded {
  border-radius: 6px;
}
.str-chat__avatar--square {
  border-radius: 0;
}
.str-chat__avatar-image,
.str-chat__avatar-fallback {
  display: block;
  width: inherit;
  height: inherit;
  object-fit: cover;
  text-align: center;
}
.str-chat__avatar-image--loaded {
  background-color: none;
}
.str-chat__avatar-fallback {
  background-color: #006cff;
}
.str-chat__message--me > .str-chat__avatar {
  order: 1;
  margin: 0;
  margin-left: 10px;
}
.str-chat__li--top .str-chat__message > .str-chat__avatar,
.str-chat__li--middle .str-chat__message > .str-chat__avatar {
  visibility: hidden;
}
.str-chat__header {
  display: flex;
  padding: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__header-thread {
  display: flex;
  padding: 10px;
  min-height: 70px;
  align-items: center;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background: #fff;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.07);
  font-size: 14px;
}
.str-chat__header-thread__back-button {
  padding: 10px 10px 10px 10px;
  border: 0;
  background: none;
  transform: rotate(180deg);
}
.str-chat__header-livestream {
  padding: 10px 40px;
  min-height: 70px;
  display: flex;
  align-items: center;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background: #fff;
  /* box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.07); */
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);
}
.str-chat__header-livestream-left {
  font-size: 14px;
  flex: 1;
}
.str-chat__header-livestream-left--title {
  font-weight: 700;
  margin: 0;
}
.str-chat__header-livestream-left--members {
  font-weight: 400;
  margin: 0;
}
.str-chat__header-livestream-left--livelabel {
  position: relative;
  left: 5px;
  font-size: 13px;
  text-transform: uppercase;
  color: red;
  display: inline-block;
  animation: pulse 2s infinite;
}
.str-chat__header-livestream-left--livelabel::before {
  content: '';
  position: relative;
  top: -2px;
  left: -4px;
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background-color: red;
}
@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.str-chat__header-livestream-right {
  display: flex;
  margin: 0 -5px;
}
.str-chat__header-livestream-right-button-wrapper {
  position: relative;
}
.str-chat__header .str-chat__avatar {
  margin: 0 16px 0 0;
}
.str-chat__title {
  font-weight: 600;
}
.str-chat__meta {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.str-chat__info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
.str-chat__square-button {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  width: 30px;
  height: 30px;
  margin: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.str-chat__square-button svg {
  fill: rgba(0, 0, 0, 0.8);
}
.str-chat__square-button:active {
  background-color: rgba(0, 0, 0, 0.1);
}
.dark.str-chat .str-chat__square-button {
  background: rgba(255, 255, 255, 0.07);
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.69);
  border-radius: 3px;
}
.dark.str-chat .str-chat__square-button svg {
  fill: rgba(255, 255, 255, 0.7);
}
.messaging.str-chat .str-chat__header-livestream {
  position: relative;
  z-index: 1;
  border-radius: 10px 10px 0 0;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: none;
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);
}
@media screen and (max-width: 960px) {
  .messaging.str-chat .str-chat__header-livestream {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.messaging.str-chat.dark .str-chat__header-livestream {
  background: rgba(46, 48, 51, 0.98);
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px 10px 0 0;
  color: white;
}
.livestream.str-chat .str-chat__header-livestream {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.29);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
}
.livestream.str-chat.dark .str-chat__header-livestream {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.34);
}
.livestream.str-chat.dark .str-chat__header-livestream-left--title,
.livestream.str-chat.dark .str-chat__header-livestream-left--members {
  color: white;
}
.livestream.str-chat.dark .str-chat__header-livestream-left--title {
  font-size: 15px;
}
.commerce.str-chat .str-chat__header-livestream {
  background: rgba(255, 255, 255, 0.81);
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px 10px 0 0;
  padding: 25px;
}
.commerce.str-chat .str-chat__header-livestream-left--title {
  font-size: 25px;
  margin: 0;
  line-height: 1;
  font-weight: 400;
}
.commerce.str-chat .str-chat__header-livestream-left--subtitle {
  margin: 8px 0;
  font-size: 15px;
}
.commerce.str-chat .str-chat__header-livestream-left--members {
  display: none;
}
.commerce.str-chat .str-chat__header-livestream-right-button--info {
  display: none;
}
.commerce.str-chat.dark .str-chat__header-livestream {
  background: rgba(44, 47, 51, 0.81);
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);
  border-radius: 10px 10px 0 0;
  color: white;
}
.team.str-chat.dark .str-chat__header-livestream {
  background: rgba(38, 40, 43, 0.9);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);
}
.team.str-chat.dark .str-chat__header-livestream-left {
  color: white;
}
.team.str-chat.dark .str-chat__header-livestream-left--title {
  font-size: 18px;
}
.team.str-chat.dark .str-chat__header-livestream-left--members {
  font-size: 13px;
}
.str-chat__header-hamburger {
  width: 30px;
  height: 40px;
  padding: 10px 10px 10px 0px;
  margin-right: 10px;
  display: none;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
}
.str-chat__header-hamburger:hover .str-chat__header-hamburger--line {
  background: #006cff;
}
@media screen and (max-width: 960px) {
  .str-chat__header-hamburger {
    display: flex;
  }
}
.str-chat__header-hamburger--line {
  width: 100%;
  height: 2px;
  background: #bcd8ff;
  border-radius: 2px;
}
.str-chat__audio__wrapper {
  height: 80px;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
  margin: 0;
  display: flex;
  background: #f1f1f1;
}
.str-chat__audio__image {
  height: 80px;
  width: 80px;
  position: relative;
  z-index: 20;
}
.str-chat__audio__image--overlay {
  width: inherit;
  height: inherit;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 30;
  font-size: 3em;
  color: rgba(255, 255, 255, 0.69);
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.str-chat__audio__image--button {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
}
.str-chat__audio__image--button svg {
  fill: rgba(255, 255, 255, 0.69);
}
.str-chat__audio__image img {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.str-chat__audio__content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 8px 16px;
  margin-left: 16px;
  width: 100%;
}
.str-chat__audio__content--title {
  margin: 0;
  padding: 0;
  line-height: 1;
}
.str-chat__audio__content--subtitle {
  margin: 0;
  padding: 0;
  line-height: 1;
  font-size: 12px;
  opacity: 0.49;
}
.str-chat__audio__content--progress {
  height: 6px;
  width: 100%;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.1);
  padding: 1px;
  margin: 2px 0;
}
.str-chat__audio__content--progress > div {
  height: 4px;
  border-radius: 4px;
  width: 0%;
  background: #006cff;
  transition: width 0.5s linear;
}
.str-chat.dark .str-chat__audio__wrapper {
  background: #1a1a1a;
  color: white;
}
.str-chat.dark .str-chat__audio__content--progress {
  background: rgba(255, 255, 255, 0.1);
}
.str-chat__channel-list {
  /* min-height: 667px; */
  flex: 1;
  overflow-y: auto;
  max-width: 320px;
  background: #f2f3f5;
  display: flex;
  flex-direction: column;
}
.str-chat__channel-list--channels {
  flex: 1;
}
.str-chat__channel-list .channel_preview {
  padding: 8px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__button {
  background: #fff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09);
  font-size: 14px;
  padding: 14px 70px;
  color: #006cff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 10px);
  margin: 5px;
  border: 1px solid transparent;
}
.str-chat__button:active,
.str-chat__button:focus {
  outline: none;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09), 0 0 0 2px rgba(0, 108, 255, 0.36);
  border: 1px solid #006cff;
}
.str-chat__button > * {
  margin: 0 5px;
}
.str-chat__button--round {
  border-radius: 100px;
}
.str-chat-channel-checkbox {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100001;
}
.str-chat-channel-list-burger {
  width: 10px;
  height: 50px;
  background: white;
  border-radius: 0 4px 4px 0;
  padding: 3px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.09);
  position: fixed;
  top: 10px;
  left: 0;
  z-index: 10000;
  justify-content: center;
  cursor: pointer;
}
.str-chat-channel-list-burger div {
  width: 4px;
  height: 100%;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.08);
}
@media screen and (max-width: 960px) {
  .str-chat-channel-list-burger {
    display: flex;
  }
  .str-chat-channel-list.messaging,
  .str-chat-channel-list.team,
  .str-chat-channel-list.commerce {
    position: fixed;
    left: -380px;
    top: 0;
    z-index: 1001;
    min-height: 100vh;
    overflow-y: auto;
    box-shadow: 7px 0 9px 0 rgba(0, 0, 0, 0.03), 1px 0 0 0 rgba(0, 0, 0, 0.03);
    transition: left 200ms ease-in-out;
  }
  .str-chat-channel-list--open.messaging,
  .str-chat-channel-list--open.team,
  .str-chat-channel-list--open.commerce {
    left: 0px;
  }
}
.str-chat-channel-list .str-chat__channel-list-messenger {
  padding: 0;
}
.str-chat-channel-list .str-chat__channel-list-messenger__main {
  padding: 20px 10px 0 10px;
  height: 100%;
  overflow-y: auto;
}
.str-chat__channel-list-messenger {
  padding: 20px 10px 0 10px;
  min-width: 300px;
  height: 100%;
}
.str-chat__channel-list-messenger {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: flex;
  height: 100%;
  overflow-y: auto;
}
.str-chat__channel-list-messenger__sidebar {
  display: flex;
  flex-direction: column;
  width: 70px;
  padding: 45px 10px 10px;
  background: #dedfe2;
}
.str-chat__channel-list-messenger__sidebar--top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: -10px 0;
}
.str-chat__channel-list-messenger__sidebar--top > * {
  margin: 10px 0;
}
.str-chat__channel-list-messenger__sidebar--bottom {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.str-chat__channel-list-messenger__send-button,
.str-chat__channel-list-messenger__search-button {
  background: none;
  margin: none;
  border: none;
}
.str-chat__channel-list-messenger__main {
  min-width: 230px;
  background: #f1f1f3;
}
.str-chat__channel-list-messenger__header {
  padding: 15px 15px 15px 20px;
  max-height: 70px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.01);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  font-size: 14px;
  color: #000;
  letter-spacing: 0;
  position: relative;
}
.str-chat__channel-list-messenger__header--title {
  font-weight: 700;
  text-transform: capitalize;
}
.str-chat__channel-list-messenger__header--status {
  position: relative;
  padding: 0 0 0 10px;
}
.str-chat__channel-list-messenger__header--status::before {
  position: absolute;
  top: 5px;
  left: 0;
  content: ' ';
  width: 6px;
  height: 6px;
  border-radius: 10px;
}
.str-chat__channel-list-messenger__header--status.watcher_count::before {
  background: #28ca42;
}
.str-chat__channel-list-messenger__header--status.busy::before {
  background: #28ca42;
}
.str-chat__channel-list-messenger__header--status.away::before {
  background: #28ca42;
}
.str-chat__channel-list-messenger__header--left {
  width: 40px;
}
.str-chat__channel-list-messenger__header--middle {
  flex: 1;
  margin-left: 15px;
}
.str-chat__channel-list-messenger__header--button {
  margin: 0;
  padding: 15px 5px;
  border: 0;
  background: none;
}
.messenger-chat.str-chat .str-chat__channel-list-messenger {
  padding: 0 0 0 10px;
}
.messenger-chat.str-chat .str-chat__channel-list-messenger__header {
  background: none;
  box-shadow: none;
}
.messenger-chat.str-chat .str-chat__channel-list-messenger__main {
  background: none;
}
.dark.str-chat .str-chat__channel-list-messenger {
  background: #1d1f22;
}
.dark.str-chat .str-chat__channel-list-messenger__header--title {
  color: white;
}
.dark.str-chat .str-chat__channel-list-messenger__sidebar {
  background: rgba(0, 0, 0, 0.2);
}
.dark.str-chat .str-chat__channel-list-messenger__main {
  background: none;
}
.str-chat__down {
  display: flex;
  height: 100%;
}
.str-chat__down-main {
  flex: 1;
  padding: 30px;
}
.dark.str-chat .str-chat__down {
  color: rgba(255, 255, 255, 0.87);
}
.str-chat__channel-search {
  margin: 10px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
}
.str-chat__channel-search input {
  flex: 1;
  background: rgba(0, 0, 0, 0.05);
  margin-right: 20px;
  border: 1px solid transparent;
  outline: none;
  height: 30px;
  border-radius: 15px;
  color: black;
  font-size: 14px;
  padding: 0 10px;
}
.str-chat__channel-search input::placeholder {
  color: gray;
}
.str-chat__channel-search input:focus {
  background: white;
  border: 1px solid #006cff;
  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__channel-search button {
  margin: 0;
  padding: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09);
  cursor: pointer;
  outline: 0;
}
.str-chat__channel-search button:focus {
  background: white;
  border: 1px solid #006cff;
  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__channel-search button svg {
  fill: #006cff;
  transform: translateX(2px);
}
.dark.str-chat .str-chat__channel-search input {
  background: rgba(255, 255, 255, 0.04);
  color: white;
}
.dark.str-chat .str-chat__channel-search button {
  background: #006cff;
}
.dark.str-chat .str-chat__channel-search button svg {
  fill: white;
}
.str-chat.messaging .str-chat__event-component__channel-event {
  display: flex;
  margin-top: 20px;
}
.str-chat.messaging .str-chat__event-component__channel-event__content {
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 15px;
}
.str-chat.messaging .str-chat__event-component__channel-event__date {
  font-size: 11px;
  margin-top: 4px;
}
.str-chat.team .str-chat__event-component__channel-event {
  display: flex;
  margin: 20px 40px;
}
.str-chat.team .str-chat__event-component__channel-event__content {
  margin-right: 10px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 15px;
}
.str-chat.team .str-chat__event-component__channel-event__date {
  font-size: 11px;
  margin-top: 4px;
}
.str-chat.commerce .str-chat__event-component__channel-event,
.str-chat.livestream .str-chat__event-component__channel-event {
  display: none;
}
.vesta-preview button {
  align-items: center;
  background: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border: none;
  display: flex;
  flex-direction: row;
  font-size: 13px;
  margin: 0;
  outline: 0;
  overflow: hidden;
  padding: 10px 40px 10px 10px;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.vesta-preview button:focus {
  background: white;
  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__channel-preview-messenger--right {
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0 10px;
  max-width: 250px;
}
.str-chat__channel-preview-avatar {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 18px;
}
.str-chat__channel-preview-end-first-row {
  color: black;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.str-chat__channel-preview-unread-badge {
  position: absolute;
  right: 10px;
  width: 22px;
  height: 22px;
  color: black;
  font-size: 12px;
  background: lightgray;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
}
.str-chat__channel-preview-messenger--last-message p {
  color: gray;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  max-width: 120px;
}
.str-chat__channel-preview--active {
  background: #006cff;
  color: white;
}
.str-chat__channel-preview--active .str-chat__channel-preview-end-first-row {
  color: white;
}
.str-chat__channel-preview--active .str-chat__channel-preview-messenger--last-message p {
  color: rgba(255, 255, 255, 0.69);
}
.str-chat__channel-preview-messenger--unread {
  position: relative;
}
.str-chat__channel-preview-messenger--unread .str-chat__channel-preview-messenger--last-message p {
  font-weight: 700;
  color: black;
}
.str-chat__channel-preview--dot {
  width: 5px;
  height: 5px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  background-color: magenta;
}
.str-chat__channel-preview-compact {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: flex;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 40px;
  color: black;
  position: relative;
  border: none;
  background: none;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 0 40px 0 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  text-align: left;
  outline: 0;
}
.str-chat__channel-preview-compact:focus {
  background: white;
  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__channel-preview-compact--left {
  width: 22px;
  height: 22px;
}
.str-chat__channel-preview-compact--right {
  flex: 1;
  margin-left: 11px;
}
.str-chat__channel-preview-compact--unread {
  font-weight: 700;
}
.str-chat__channel-preview-compact--active {
  color: white;
  background: #004ab3;
}
.str-chat__channel-preview-messenger {
  display: flex;
  width: 100%;
  border: none;
  padding: 10px;
  align-items: center;
  background: rgba(255, 255, 255, 0);
  text-align: left;
  margin: 5px 0;
}
.str-chat__channel-preview-messenger--active {
  border: none;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: none;
}
.str-chat__channel-preview-messenger--last-message {
  font-size: 13px;
  line-height: 14px;
  opacity: 0.5;
}
.str-chat__channel-preview-messenger--name {
  font-size: 14px;
  line-height: 17px;
  font-weight: 600;
  max-width: 250px;
}
.str-chat__channel-preview-messenger--name span {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.str-chat__channel-preview-messenger--unread .str-chat__channel-preview-messenger--last-message {
  opacity: 1;
  font-weight: 600;
}
.dark.str-chat .str-chat__channel-preview--active {
  background: #132d50;
}
.dark.str-chat .str-chat__channel-preview-end-first-row {
  color: white;
}
.dark.str-chat .str-chat__channel-preview button:focus {
  background: #132d50;
  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.dark.str-chat .str-chat__channel-preview-messenger--active {
  background: rgba(255, 255, 255, 0.06);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.07);
}
.dark.str-chat .str-chat__channel-preview-messenger--last-message {
  color: rgba(255, 255, 255, 0.5);
}
.dark.str-chat .str-chat__channel-preview-messenger--name {
  color: white;
}
.str-chat__date-separator {
  display: flex;
  margin: 40px;
  align-items: center;
}
.str-chat__date-separator-date {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.7);
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.str-chat__date-separator-line {
  flex: 1;
  background-color: rgba(0, 0, 0, 0.1);
  height: 1px;
  border: none;
}
.str-chat__date-separator > *:not(:last-child) {
  margin-right: 20px;
}
.commerce.str-chat .str-chat__date-separator {
  margin: 40px 0;
}
.dark.str-chat .str-chat__date-separator-line {
  background-color: rgba(255, 255, 255, 0.1);
}
.dark.str-chat .str-chat__date-separator-date {
  color: rgba(255, 255, 255, 0.7);
}
.dark.str-chat.team .str-chat__date-separator-line {
  background-color: rgba(0, 0, 0, 0.4);
}
.str-chat__edit-message-form {
  width: 100%;
}
.str-chat__edit-message-form form {
  position: relative;
  width: 100%;
}
.str-chat__edit-message-form textarea {
  padding: 7px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #006cff;
  border: 1px solid transparent;
  resize: none;
  border-radius: 5px;
  width: 100%;
  font-size: 15px;
  line-height: 22px;
  /* color: \$fontColor; */
}
.str-chat__edit-message-form textarea:focus {
  box-shadow: inset 0 0 0 1px #006cff, 0 0 0 2px rgba(0, 108, 255, 0.36);
  outline: 0;
}
.str-chat__edit-message-form button {
  background: none;
  border: none;
  /* font-size: \$fontSize; */
  font-weight: 700;
  color: rgba(0, 0, 0, 0.4);
}
.str-chat__edit-message-form button[type='submit'] {
  color: #006cff;
}
.str-chat__edit-message-form .rfu-dropzone {
  width: 100%;
}
.str-chat__edit-message-form .rfu-file-upload-button,
.str-chat__edit-message-form .str-chat__input-emojiselect,
.str-chat__edit-message-form .str-chat__input-fileupload {
  position: unset;
  top: unset;
  right: unset;
  left: unset;
}
.str-chat__edit-message-form .rfu-file-upload-button svg,
.str-chat__edit-message-form .str-chat__input-emojiselect svg,
.str-chat__edit-message-form .str-chat__input-fileupload svg {
  fill: black;
  opacity: 0.5;
}
.str-chat__edit-message-form .rfu-file-upload-button:hover svg,
.str-chat__edit-message-form .str-chat__input-emojiselect:hover svg,
.str-chat__edit-message-form .str-chat__input-fileupload:hover svg {
  opacity: 1;
}
.str-chat__edit-message-form-options {
  display: flex;
}
.str-chat.dark .str-chat__edit-message-form .rfu-file-upload-button svg,
.str-chat.dark .str-chat__edit-message-form .str-chat__input-emojiselect svg {
  fill: white;
}
.str-chat.dark .str-chat__edit-message-form button {
  color: rgba(255, 255, 255, 0.4);
}
.str-chat.dark .str-chat__edit-message-form button[type='submit'] {
  color: #006cff;
}
.str-chat.dark .str-chat__edit-message-form textarea {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.21);
  border: 2px solid transparent;
  border-radius: 6px;
  color: white;
}
.str-chat.dark .str-chat__edit-message-form textarea:focus {
  box-shadow: inset 0 0 0 1px #006cff;
  border: 2px solid rgba(0, 108, 255, 0.36);
  border-radius: 6px;
}
.str-chat__gallery {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  overflow: hidden;
}
.str-chat__gallery-image {
  /* flex: 1; x */
  width: 150px;
  height: 150px;
  background: white;
  margin-bottom: 1px;
  margin-right: 1px;
}
.str-chat__gallery-image:hover {
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.str-chat__gallery-image img {
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.str-chat__gallery--square {
  max-width: 301px;
}
.str-chat__gallery--square .str-chat__gallery-image:nth-child(even) {
  margin-right: 0;
}
.livestream.str-chat .str-chat__gallery,
.messaging.str-chat .str-chat__gallery,
.commerce.str-chat .str-chat__gallery,
.team.str-chat .str-chat__gallery {
  margin: 5px 0;
}
.livestream.str-chat .str-chat__gallery-image,
.messaging.str-chat .str-chat__gallery-image,
.commerce.str-chat .str-chat__gallery-image,
.team.str-chat .str-chat__gallery-image {
  width: 150px;
  height: 150px;
}
.livestream.str-chat .str-chat__gallery-placeholder,
.messaging.str-chat .str-chat__gallery-placeholder,
.commerce.str-chat .str-chat__gallery-placeholder,
.team.str-chat .str-chat__gallery-placeholder {
  position: relative;
  width: 150px;
  height: 150px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.livestream.str-chat .str-chat__gallery-placeholder p,
.messaging.str-chat .str-chat__gallery-placeholder p,
.commerce.str-chat .str-chat__gallery-placeholder p,
.team.str-chat .str-chat__gallery-placeholder p {
  position: relative;
  z-index: 1;
}
.livestream.str-chat .str-chat__gallery-placeholder:after,
.messaging.str-chat .str-chat__gallery-placeholder:after,
.commerce.str-chat .str-chat__gallery-placeholder:after,
.team.str-chat .str-chat__gallery-placeholder:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.69);
  z-index: 0;
}
.commerce.str-chat .str-chat__gallery {
  width: calc(100% - 30px);
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 100px;
}
.commerce.str-chat .str-chat__gallery-image,
.commerce.str-chat .str-chat__gallery-placeholder {
  width: 100%;
  height: 100%;
}
.commerce.str-chat .str-chat__message-commerce .str-chat__gallery {
  border-radius: 16px 16px 16px 2px;
}
.commerce.str-chat .str-chat__message-commerce--right .str-chat__gallery {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__infinite-scroll-paginator {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}
.str-chat__loading-channels {
  width: 300px;
  height: 100%;
  padding: 20px;
  background: #fafafa;
}
.str-chat__loading-channels-meta {
  flex: 1;
}
.str-chat__loading-channels-avatar,
.str-chat__loading-channels-username,
.str-chat__loading-channels-status {
  background-image: linear-gradient(-90deg, #f2f2f2 0%, #e5e5e5 100%);
}
.str-chat__loading-channels-username,
.str-chat__loading-channels-status {
  border-radius: 2px;
  height: 14px;
}
.str-chat__loading-channels-avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 10px;
}
.str-chat__loading-channels-username {
  width: 40%;
  margin-bottom: 6px;
}
.str-chat__loading-channels-status {
  width: 80%;
}
.str-chat__loading-channels-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 3px;
  margin-bottom: 10px;
  animation: pulsate 1s linear 0s infinite alternate;
}
.str-chat__loading-channels-item:nth-of-type(2) {
  animation: pulsate 1s linear 0.3334 infinite alternate;
}
.str-chat__loading-channels-item:last-of-type {
  animation: pulsate 1s linear 0.6667s infinite alternate;
}
@keyframes pulsate {
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
}
.str-chat.messaging .str-chat__load-more-button {
  border: 0;
  width: 100%;
  height: 40px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: none;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.07);
  padding: 10px;
  font-size: 14px;
}
.str-chat.str-chat-channel-list .str-chat__load-more-button button {
  border: 0;
  background: transparent;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 14px;
}
.str-chat__loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.str-chat__message-input {
  background: #fff;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.05), 0 -1px 0 0 rgba(0, 0, 0, 0.07);
  display: flex;
  flex-wrap: wrap;
  padding: 10px !important;
  position: relative;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding-bottom: 0;
}
.str-chat__message-input-large {
  position: relative;
  z-index: 1;
  width: 100%;
}
.str-chat__message-input--emojipicker {
  position: absolute;
  bottom: 100%;
  right: 0;
}
.str-chat__message-input .rfu-dropzone {
  flex: 1 1 100%;
}
.str-chat__message-input--textarea-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex: 1 0;
  position: relative;
}
.str-chat__message-input--textarea-wrapper .str-chat__textarea textarea {
  padding-right: 70px;
}
.str-chat__message-input-emojiselect,
.str-chat__message-input .rfu-file-upload-button {
  position: absolute;
  cursor: pointer;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-size: 44px 44px;
  fill: rgba(0, 0, 0, 0.6);
}
.str-chat__message-input-emojiselect:hover,
.str-chat__message-input .rfu-file-upload-button:hover {
  fill: black;
}
.str-chat__message-input-emojiselect {
  right: 20px;
  top: calc(100% - 35px);
}
.str-chat__message-input .rfu-file-upload-button {
  right: 46px;
  top: calc(100% - 34px);
}
.str-chat__message-input-footer {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  background: white;
  padding: 0 10px 10px 10px;
  color: gray;
}
.str-chat__message-input-footer--typing {
  font-style: italic;
}
.str-chat__message-input-footer--count--hidden {
  visibility: hidden;
}
.str-chat__textarea {
  height: auto;
  flex: 1;
}
.str-chat__textarea textarea {
  width: 100%;
  outline: none;
  padding: 11px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-size: 15px;
  min-height: 42px;
  transition: height 100ms ease-in;
  resize: none;
}
.str-chat__textarea textarea:focus {
  background: #fff;
  border: 1px solid #006cff;
  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__textarea textarea:placeholder {
  color: rgba(0, 0, 0, 0.5);
}
.str-chat__emojisearch {
  bottom: calc(100%);
  left: 0;
  width: calc(100% - 20px);
  position: absolute;
  background: rgba(240, 240, 240, 0.95);
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.31), 0 0 6px 0 rgba(0, 0, 0, 0.12);
  z-index: -1;
  border-radius: 4px 4px 0 0;
  margin: 0 10px;
  max-height: 360px;
  overflow-y: auto;
}
.str-chat__emojisearch__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-radius: 4px 4px 0 0;
}
.dark.str-chat .str-chat__emojisearch {
  background: #35373a;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.31), 0 0 6px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px 4px 0 0;
}
.dark.str-chat .str-chat__emojisearch .rta__list-header {
  background: #1b1d20;
  border: 1px solid rgba(224, 224, 224, 0.03);
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);
  color: white;
}
.dark.str-chat .str-chat__emojisearch .rta__entity {
  color: white;
}
.dark.str-chat .rfu-file-previewer__file a {
  color: white;
}
.dark.str-chat .rfu-file-previewer__file:hover {
  background: transparent;
}
.dark.str-chat .rfu-file-previewer__close-button {
  color: white;
}
.rta {
  font-size: 14px;
}
.rta__entity--selected {
  background-color: #006cff;
  color: white;
}
.rta__list {
  border-radius: 4px 4px 0 0;
}
.rta__list-header {
  padding: 15px;
  font-size: 14px;
}
.str-chat__emoji-item {
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin: 0 -8px;
}
.str-chat__emoji-item span {
  display: block;
}
.str-chat__emoji-item--entity {
  min-width: 24px;
}
.str-chat__emoji-item--name {
  font-size: 12px;
}
.str-chat__slash-command {
  padding: 10px 15px;
  font-size: 14px;
}
.str-chat__slash-command-description {
  font-size: 12px;
}
.str-chat__user-item {
  padding: 10px 15px;
  display: flex;
}
.str-chat .rfu-dropzone .rfu-dropzone__notifier {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 5px;
  z-index: 1001;
  display: none;
}
.str-chat .rfu-dropzone--accept .rfu-dropzone__notifier {
  background: rgba(0, 108, 255, 0.7);
  display: block;
}
.str-chat .rfu-dropzone--reject .rfu-dropzone__notifier {
  background: rgba(255, 0, 0, 0.7);
  display: block;
}
.rfu-dropzone__inner {
  width: 100%;
  height: 100%;
  padding: 0 30px;
  border: 1px dashed transparent;
  box-sizing: border-box;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  font-weight: 800;
  font-size: 12px;
}
.rfu-dropzone__inner svg {
  display: none;
}
.rfu-dropzone--reject .rfu-dropzone__inner {
  display: none;
}
.team.str-chat .str-chat__input,
.livestream.str-chat .str-chat__input {
  padding: 10px 40px;
}
.team.str-chat .str-chat__input-footer,
.livestream.str-chat .str-chat__input-footer {
  padding: 0 40px 10px;
}
.livestream.str-chat .str-chat__input {
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.29);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 20px 5px;
}
.livestream.str-chat .str-chat__input textarea {
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.26);
  border: 1px solid rgba(0, 0, 0, 0.2);
  font-size: 13px;
  padding: 12px;
}
.livestream.str-chat .str-chat__input-footer {
  padding: 0 20px 10px;
  background: rgba(255, 255, 255, 0.29);
}
.str-chat__file-uploads {
  max-height: 300px;
  flex: 1 1 100%;
  overflow-y: auto;
}
.rfu-file-upload-button svg {
  fill: rgba(0, 0, 0, 0.6);
}
.dark.str-chat .str-chat__input {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.34);
}
.dark.str-chat .str-chat__input-footer {
  background: rgba(255, 255, 255, 0.03);
}
.dark.str-chat .str-chat__input textarea {
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  color: white;
}
.dark.str-chat .str-chat__input .str-chat__input-emojiselect svg {
  fill: white;
}
.dark.str-chat .str-chat__input .rfu-file-upload-button svg {
  fill: white;
}
.str-chat__fileupload-wrapper .str-chat__tooltip {
  display: none;
  bottom: 35px;
  right: 50px;
}
.str-chat__fileupload-wrapper:hover .str-chat__tooltip {
  display: block;
}
.str-chat__emojiselect-wrapper .str-chat__tooltip {
  display: none;
  bottom: 35px;
  right: 24px;
}
.str-chat__emojiselect-wrapper:hover .str-chat__tooltip {
  display: block;
}
.str-chat__small-message-input--textarea-wrapper .str-chat__fileupload-wrapper .str-chat__tooltip {
  bottom: 32px;
  right: 32px;
}
.str-chat__small-message-input--textarea-wrapper .str-chat__emojiselect-wrapper .str-chat__tooltip {
  bottom: 32px;
  right: 10px;
}
.str-chat__input-flat {
  background: white;
  padding: 10px 40px;
  position: relative;
  z-index: 1;
  width: 100%;
}
.str-chat__input-flat-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.str-chat__input-flat .str-chat__textarea {
  flex: 1;
}
.str-chat__input-flat .str-chat__textarea > textarea {
  min-height: 56px;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 20px 69px;
  font-size: 15px;
  line-height: 17px;
  border: none;
  margin: 0;
}
.str-chat__input-flat .str-chat__textarea > textarea:focus {
  border: none;
  border-radius: 8px;
  box-shadow: 0 0 0 3px #006cff;
}
.str-chat__input-flat-footer {
  padding: 10px 40px;
  background: white;
}
.str-chat__input-flat-emojiselect {
  position: absolute;
  top: calc(50% - 17px);
  left: 25px;
}
.str-chat__input-flat-emojiselect svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__input-flat-emojiselect svg:hover {
  opacity: 1;
}
.str-chat__input-flat--textarea-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex: 1 0;
  position: relative;
}
.str-chat__input-flat--textarea-wrapper .str-chat__fileupload-wrapper .str-chat__tooltip {
  bottom: 45px;
  right: 25px;
}
.str-chat__input-flat--textarea-wrapper .str-chat__emojiselect-wrapper .str-chat__tooltip {
  bottom: 50px;
  left: 32px;
  right: unset;
}
.str-chat__input-flat--textarea-wrapper .str-chat__emojiselect-wrapper .str-chat__tooltip:after {
  left: 5px;
  right: unset;
}
.str-chat__input--emojipicker {
  position: absolute;
  bottom: calc(100%);
}
.str-chat__input-flat .rfu-file-previewer {
  width: 100%;
}
.str-chat__input-flat .rfu-file-upload-button {
  position: absolute;
  top: calc(50% - 11px);
  right: 25px;
}
.str-chat__input-flat .rfu-file-upload-button svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__input-flat .rfu-file-upload-button svg:hover {
  opacity: 1;
}
.rfu-image-previewer {
  flex: 1 1 100%;
}
.rfu-image-previewer__image {
  width: 60px !important;
  height: 60px !important;
}
.rfu-image-previewer__image .rfu-thumbnail__wrapper {
  width: 60px !important;
  height: 60px !important;
  border-radius: 10px;
}
.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-thumbnail__overlay,
.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-icon-button {
  padding: 0;
}
.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-thumbnail__overlay svg,
.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-icon-button svg {
  opacity: 0.9;
  height: 25px;
  width: 25px;
}
.rfu-image-previewer .rfu-thumbnail-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}
.commerce.str-chat .str-chat__input-flat {
  padding: 10px 22px;
  background: transparent;
}
.dark.str-chat .str-chat__input-flat {
  background: rgba(255, 255, 255, 0.04);
}
.dark.str-chat .str-chat__input-flat textarea {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  color: white;
}
.dark.str-chat .str-chat__input-flat-emojiselect svg,
.dark.str-chat .str-chat__input-flat .rfu-file-upload-button svg {
  fill: #fff;
}
.dark.str-chat.commerce .str-chat__input-flat {
  background: none;
}
@media screen and (max-width: 960px) {
  .str-chat.messaging .str-chat__input-flat {
    padding: 10px 10px;
  }
}
.str-chat__list {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* enable smooth scrolling on ios */
  padding: 75px 0 0 0;
}
.str-chat__list-wrapper {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}
.str-chat__list--thread {
  padding: 15px 0 0 0;
  overflow: visible;
}
.str-chat__list__center {
  width: 100%;
  display: flex;
  justify-content: center;
}
.str-chat__ul {
  display: block;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.str-chat__custom-notification {
  border-radius: 4px;
  font-size: 12px;
  padding: 8px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-align: center;
}
.str-chat__custom-notification.notification-success {
  background: rgba(2, 208, 2, 0.1);
  border: 1px solid rgba(2, 208, 2, 0.1);
  color: green;
}
.str-chat__custom-notification.notification-error {
  background: rgba(208, 2, 27, 0.1);
  border: 1px solid rgba(208, 2, 27, 0.1);
  color: #f00;
}
.str-chat__connection-issue {
  background: rgba(208, 2, 27, 0.1);
  border: 1px solid rgba(208, 2, 27, 0.1);
  color: #f00;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-align: center;
}
.str-chat__list-notifications {
  padding: 0 40px;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
}
.messaging.str-chat .str-chat__list {
  padding: 55px 40px 0;
  background: white;
}
.messaging.str-chat .str-chat__list-notifications {
  background: white;
}
@media screen and (max-width: 960px) {
  .messaging.str-chat .str-chat__list {
    padding: 55px 10px 0;
  }
  .messaging.str-chat .str-chat__list-notifications {
    padding: 0 10px;
  }
}
.messaging.str-chat.dark .str-chat__list {
  background: rgba(255, 255, 255, 0.04);
}
.messaging.str-chat.dark .str-chat__list-notifications {
  background: rgba(255, 255, 255, 0.04);
}
.livestream.str-chat .str-chat__list {
  padding: 55px 10px;
}
.commerce.str-chat .str-chat__list {
  padding: 75px 20px 0;
}
.commerce.str-chat .str-chat__list-notifications {
  padding-left: 22px;
  padding-right: 22px;
}
.str-chat__message-notification {
  display: block;
  position: absolute;
  align-self: center;
  background: #006cff;
  border: none;
  color: white;
  border-radius: 50px;
  padding: 4px 10px;
  font-size: 12px;
  bottom: -10px;
  z-index: 101;
}
.str-chat__message-replies-count-button {
  display: block;
  border: none;
  background: none;
  padding: 0;
  margin-top: 8px;
  font-size: 12px;
  line-height: 15px;
  font-weight: 700;
  color: #006cff;
  cursor: pointer;
}
.str-chat__message-replies-count-button svg {
  fill: rgba(0, 0, 0, 0.1);
  margin-right: 5px;
}
.dark.str-chat .str-chat__message-replies-count-button svg {
  fill: rgba(255, 255, 255, 0.1);
}
.dark.str-chat.team .str-chat__message-replies-count-button svg {
  fill: rgba(0, 0, 0, 0.4);
}
.str-chat__message-livestream {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: flex;
  width: 100%;
  margin: 0 0;
  padding: 10px 10px;
  border: 1px solid rgba(0, 0, 0, 0);
  position: relative;
}
.str-chat__message-livestream-left {
  width: 30px;
}
.str-chat__message-livestream-left .str-chat__avatar {
  margin-right: 0;
}
.str-chat__message-livestream-right {
  flex: 1;
}
.str-chat__message-livestream-content {
  position: relative;
  padding: 5px 10px;
  border: 1px solid transparent;
}
.str-chat__message-livestream-content > * {
  font-size: 13px;
  line-height: 20px;
  margin: 0;
}
.str-chat__message-livestream-content .str-chat__message-mention {
  font-size: 13px;
  line-height: 20px;
  margin: 0;
}
.str-chat__message-livestream-content .str-chat__message-mention:focus {
  outline: 1;
}
.str-chat__message-livestream-content p {
  margin: 0;
  white-space: pre-line;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
.str-chat__message-livestream-content p:not(:first-of-type) {
  margin: 16px 0 0;
}
.str-chat__message-livestream-content p code {
  background-color: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(0, 108, 255, 0.1);
  border-radius: 3px;
  padding: 2px 4px;
}
.str-chat__message-livestream-content p a {
  color: #006cff;
  font-weight: bold;
  text-decoration: none;
}
.str-chat__message-livestream-content pre,
.str-chat__message-livestream-content code {
  font-family: Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console', 'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier, monospace;
  line-height: inherit;
  padding: 10px;
  font-size: 12px;
  font-weight: 700;
}
.str-chat__message-livestream-content pre {
  margin: 0 5px 0 0;
  border-radius: 4px;
  background-color: rgba(0, 108, 255, 0.1);
  border: 1px solid rgba(0, 108, 255, 0.2);
}
.str-chat__message-livestream-content code {
  width: inherit;
  word-break: break-all;
}
.str-chat__message-livestream:hover .str-chat__message-livestream-actions {
  display: flex;
}
.str-chat__message-livestream-actions {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.23);
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);
  width: 141px;
  height: 24px;
  padding: 0 4px;
  position: absolute;
  top: -12px;
  right: 0;
  border-radius: 24px;
  display: none;
  /* FFS display: none */
  align-items: center;
  justify-content: space-between;
}
.str-chat__message-livestream-actions > span {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.str-chat__message-livestream-actions > span:not(:last-of-type) {
  border-right: 1px solid #e0e0e0;
}
.str-chat__message-livestream-actions > span > span {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}
.str-chat__message-livestream-actions > span svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__message-livestream-actions > span:hover svg {
  opacity: 1;
}
.str-chat__message-livestream-actions .str-chat__message-actions-box {
  bottom: initial;
  left: initial;
  visibility: hidden;
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 7px;
}
.str-chat__message-livestream-actions .str-chat__message-actions-box--open {
  visibility: visible;
}
.str-chat__message-livestream-time {
  font-size: 10px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.5);
  flex: 2;
  padding: 0 4px;
}
.str-chat__message-livestream-text--is-emoji {
  font-size: 33px;
  line-height: 42px;
}
.str-chat__message-livestream-author {
  margin-bottom: 8px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.str-chat__message-livestream-author strong {
  margin-right: 8px;
}
.str-chat__message-livestream:hover {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}
.str-chat__message-livestream .str-chat__message-attachment--img {
  border-radius: 0;
}
.str-chat__message-livestream .str-chat__message-attachment-card {
  margin: 0;
  border-radius: 0;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__message-livestream .str-chat__message-attachment-card--content {
  background: rgba(255, 255, 255, 0.2);
}
.str-chat__message-livestream .str-chat__message-attachment-card--text {
  display: none;
}
.str-chat__message-livestream .str-chat__message-attachment-card--url {
  text-transform: lowercase;
}
.str-chat__message-livestream__thread-banner {
  text-align: center;
  font-size: 12px;
  padding: 8px;
  margin: 8px 10px 0 10px;
  background: rgba(0, 108, 255, 0.1);
  border-radius: 2px;
  color: #404040;
}
.str-chat__message-livestream--error .str-chat__message-livestream-content p,
.str-chat__message-livestream--failed .str-chat__message-livestream-content p {
  color: red;
}
.str-chat__message-livestream--error .str-chat__message-livestream-content p svg,
.str-chat__message-livestream--failed .str-chat__message-livestream-content p svg {
  position: relative;
  top: 2px;
  margin-right: 4px;
}
.str-chat__message-livestream--failed .str-chat__message-livestream-content p {
  cursor: pointer;
}
.str-chat__message-livestream--initial-message {
  margin: 20px 10px 0;
  width: auto;
}
.str-chat__list--thread .str-chat__message-livestream__actions {
  min-width: 30px;
}
.str-chat__list--thread .str-chat__message-livestream-actions {
  width: 110px;
  min-width: unset;
}
.str-chat__list--thread .str-chat__message-livestream-actions .str-chat__message-actions-box {
  top: initial;
  bottom: initial;
  bottom: -10px;
}
.livestream.dark.str-chat .str-chat__message-livestream {
  color: #e6e6e6;
}
.livestream.dark.str-chat .str-chat__message-livestream:hover {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}
.livestream.dark.str-chat .str-chat__message-livestream .str-chat__message-attachment-card {
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.livestream.dark.str-chat .str-chat__message-livestream .str-chat__message-attachment-card--content {
  background: rgba(0, 0, 0, 0.1);
}
.livestream.dark.str-chat .str-chat__message-livestream .str-chat__message-attachment-card--url {
  color: rgba(255, 255, 255, 0.79);
}
.livestream.dark.str-chat .str-chat__message-livestream-actions {
  background: #1b1d20;
  border: 1px solid rgba(224, 224, 224, 0.03);
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);
}
.livestream.dark.str-chat .str-chat__message-livestream-actions > span:not(:last-of-type) {
  border-color: rgba(255, 255, 255, 0.04);
}
.livestream.dark.str-chat .str-chat__message-livestream-actions svg {
  fill: #fff;
}
.livestream.dark.str-chat .str-chat__message-livestream-time {
  color: #fff;
  opacity: 0.5;
}
.str-chat__message-actions-box {
  position: absolute;
  display: none;
  bottom: 20px;
  left: 40px;
  width: 120px;
  border-radius: 16px 16px 16px 0;
  background: #fff;
  background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%);
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08), 0 1px 8px 0 rgba(0, 0, 0, 0.05);
  z-index: 999;
}
.str-chat__message-actions-box--open {
  display: block;
}
.str-chat__message-actions-list {
  height: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.str-chat__message-actions-list-item {
  padding: 8px 10px;
  width: 100%;
  margin: 0;
}
.str-chat__message-actions-list button {
  background: none;
  text-align: left;
  outline: none;
  border: none;
  cursor: pointer;
  display: block;
  width: 100%;
  font-size: 12px;
  color: black;
  text-decoration: none;
}
.str-chat__message-actions-list button:hover {
  color: #006cff;
}
.str-chat__message-actions-list button:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}
.str-chat__message-actions {
  position: relative;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 5px 10px;
  cursor: pointer;
}
.str-chat__message-actions {
  order: 2;
}
.str-chat__message--me .str-chat__message-actions {
  order: -1;
}
.str-chat__message-actions-reactions,
.str-chat__message-actions-options {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
}
.str-chat__message-actions-reactions,
.str-chat__message-actions-options svg {
  fill: grey;
  position: relative;
}
.str-chat__message-actions-reactions:hover,
.str-chat__message-actions-options:hover svg {
  fill: magenta;
}
.str-chat__message-reactions-box {
  position: absolute;
  visibility: hidden;
  bottom: 30px;
  left: -20px;
  background: rgba(0, 0, 0, 0.81);
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  border-radius: 50px;
  padding: 16px;
  z-index: 100;
}
.str-chat__message-reactions-box--open {
  visibility: visible;
}
.str-chat__message-reactions-box::after {
  top: 97%;
  left: 30px;
  content: url('data:image/svg+xml; utf8, <svg width="36" height="19" viewBox="0 0 36 19" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="b"><stop stop-opacity="0" offset="0%"/><stop stop-opacity=".5" offset="100%"/></linearGradient><path d="M35.284.378A15.125 15.125 0 0 0 22.81 6.946L14.55 19a14.422 14.422 0 0 0-2.223-12.786A14.456 14.456 0 0 0 .723.378h34.561z" id="a"/></defs><g fill-rule="nonzero" fill="none"><use fill="%231E1E1E" xlink:href="%23a"/><use fill="url(%23b)" xlink:href="%23a"/></g></svg>');
  position: absolute;
  z-index: 99;
}
.str-chat__modal {
  background: black;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  opacity: 0.89;
  display: none;
  align-items: center;
  justify-content: center;
}
.str-chat__modal--open {
  display: flex;
}
.str-chat__modal__inner {
  max-width: 667px;
  background: white;
  padding: 20px;
  border-radius: 10px;
}
.str-chat__modal__close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 20px;
  font-size: 14px;
  line-height: 10px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.str-chat__modal__close-button svg {
  position: relative;
  top: 1px;
  margin-left: 10px;
  fill: white;
}
.str-chat__modal__close-button:hover {
  opacity: 0.79;
}
.str-chat__modal .str-chat__edit-message-form {
  min-width: 300px;
}
.str-chat__modal .str-chat__input-emojiselect,
.str-chat__modal .str-chat__input-fileupload {
  position: relative;
  top: unset;
  right: unset;
}
.str-chat.dark.messaging .str-chat__modal__inner {
  border: 2px solid white;
  background: black;
}
.str-chat__new-channel--header {
  padding: 10px;
  display: flex;
  align-items: center;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__new-channel--header__title {
  flex: 1;
  text-align: center;
  color: #006cff;
  font-weight: 700;
  margin-right: 45px;
}
.str-chat__new-channel--name {
  padding: 0 0 0 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
}
.str-chat__new-channel--name label {
  font-size: 14px;
  margin-right: 5px;
}
.str-chat__new-channel--name input {
  font-size: 14px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  flex: 1;
  width: 100%;
  padding: 15px 0 15px 5px;
  background: #fff;
  border: none;
  outline: none;
}
.str-chat__new-channel--name input:focus {
  background: white;
  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);
}
.str-chat__modal-image__wrapper {
  line-height: 0;
  position: relative;
  text-align: center;
  box-sizing: border-box;
}
.str-chat__modal-image__image {
  max-height: 100vh;
  max-width: 100%;
}
.str-chat__message .str-chat__reaction-list,
.str-chat__message-commerce .str-chat__reaction-list {
  position: absolute;
  right: 15px;
  top: -28px;
  z-index: 99;
  height: 33px;
  width: initial;
  background-position: 0 -66px;
  background-repeat: repeat-x;
}
.str-chat__message .str-chat__reaction-list ul,
.str-chat__message-commerce .str-chat__reaction-list ul {
  position: relative;
  list-style-type: none;
  padding: 0;
  font-size: 15px;
  line-height: 26px;
  display: flex;
  justify-content: center;
  margin: -1px -15px 0 0;
  z-index: 888;
}
.str-chat__message .str-chat__reaction-list .emoji-mart-emoji,
.str-chat__message-commerce .str-chat__reaction-list .emoji-mart-emoji {
  display: flex;
}
.str-chat__message .str-chat__reaction-list::after,
.str-chat__message .str-chat__reaction-list::before,
.str-chat__message-commerce .str-chat__reaction-list::after,
.str-chat__message-commerce .str-chat__reaction-list::before {
  position: absolute;
  content: '';
  top: 0;
  height: 33px;
}
.str-chat__message .str-chat__reaction-list::after,
.str-chat__message-commerce .str-chat__reaction-list::after {
  right: -26px;
  width: 26px;
  background-position: -33px -33px;
}
.str-chat__message .str-chat__reaction-list::before,
.str-chat__message-commerce .str-chat__reaction-list::before {
  left: -13px;
  width: 13px;
  background-position: 0 -33px;
}
.str-chat__message .str-chat__reaction-list--reverse,
.str-chat__message-commerce .str-chat__reaction-list--reverse {
  right: initial;
  left: 15px;
  position: absolute;
}
.str-chat__message .str-chat__reaction-list--reverse ul,
.str-chat__message-commerce .str-chat__reaction-list--reverse ul {
  margin: -1px -5px 0 -15px;
}
.str-chat__message .str-chat__reaction-list--reverse::after,
.str-chat__message-commerce .str-chat__reaction-list--reverse::after {
  right: -13px;
  width: 13px;
  background-position: -46px 0;
}
.str-chat__message .str-chat__reaction-list--reverse::before,
.str-chat__message-commerce .str-chat__reaction-list--reverse::before {
  left: -26px;
  width: 26px;
  background-position: 0 0;
}
.str-chat__message .str-chat__reaction-list li,
.str-chat__message-commerce .str-chat__reaction-list li {
  display: flex;
  align-items: center;
}
.str-chat__message .str-chat__reaction-list li button,
.str-chat__message-commerce .str-chat__reaction-list li button {
  padding: 0;
}
.str-chat__message .str-chat__reaction-list--counter,
.str-chat__message-commerce .str-chat__reaction-list--counter {
  color: white;
  font-size: 12px;
}
.str-chat__message--me .str-chat__message-commerce-inner > .str-chat__reaction-list,
.str-chat__message--right .str-chat__message-commerce-inner > .str-chat__reaction-list,
.str-chat__message-commerce--me .str-chat__message-commerce-inner > .str-chat__reaction-list,
.str-chat__message-commerce--right .str-chat__message-commerce-inner > .str-chat__reaction-list {
  left: 46px;
}
.str-chat__message--me .str-chat__reaction-list,
.str-chat__message--right .str-chat__reaction-list,
.str-chat__message-commerce--me .str-chat__reaction-list,
.str-chat__message-commerce--right .str-chat__reaction-list {
  right: initial;
  left: 16px;
}
.str-chat__message--me .str-chat__reaction-list ul,
.str-chat__message--right .str-chat__reaction-list ul,
.str-chat__message-commerce--me .str-chat__reaction-list ul,
.str-chat__message-commerce--right .str-chat__reaction-list ul {
  margin: -1px 0 0 -15px;
}
.str-chat__message--me .str-chat__reaction-list::after,
.str-chat__message--right .str-chat__reaction-list::after,
.str-chat__message-commerce--me .str-chat__reaction-list::after,
.str-chat__message-commerce--right .str-chat__reaction-list::after {
  right: -13px;
  width: 13px;
  background-position: -46px 0;
}
.str-chat__message--me .str-chat__reaction-list::before,
.str-chat__message--right .str-chat__reaction-list::before,
.str-chat__message-commerce--me .str-chat__reaction-list::before,
.str-chat__message-commerce--right .str-chat__reaction-list::before {
  left: -26px;
  width: 26px;
  background-position: 0 0;
}
.str-chat__message--me .str-chat__reaction-list--reverse,
.str-chat__message--right .str-chat__reaction-list--reverse,
.str-chat__message-commerce--me .str-chat__reaction-list--reverse,
.str-chat__message-commerce--right .str-chat__reaction-list--reverse {
  right: 15px;
  left: initial;
}
.str-chat__message--me .str-chat__reaction-list--reverse ul,
.str-chat__message--right .str-chat__reaction-list--reverse ul,
.str-chat__message-commerce--me .str-chat__reaction-list--reverse ul,
.str-chat__message-commerce--right .str-chat__reaction-list--reverse ul {
  margin: -1px -15px 0 0;
}
.str-chat__message--me .str-chat__reaction-list--reverse::after,
.str-chat__message--right .str-chat__reaction-list--reverse::after,
.str-chat__message-commerce--me .str-chat__reaction-list--reverse::after,
.str-chat__message-commerce--right .str-chat__reaction-list--reverse::after {
  right: -26px;
  width: 26px;
  background-position: -33px -33px;
}
.str-chat__message--me .str-chat__reaction-list--reverse::before,
.str-chat__message--right .str-chat__reaction-list--reverse::before,
.str-chat__message-commerce--me .str-chat__reaction-list--reverse::before,
.str-chat__message-commerce--right .str-chat__reaction-list--reverse::before {
  left: -13px;
  width: 13px;
  background-position: 0 -33px;
}
.str-chat__message-commerce-inner > .str-chat__reaction-list {
  left: unset;
  right: 46px;
}
.str-chat__message-commerce--right .str-chat__message-commerce-inner > .str-chat__reaction-list {
  right: unset;
  left: 46px;
}
.str-chat__read-state {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: 100%;
  margin: -56px 10px 0 40px;
}
.str-chat__message-reactions-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
}
.str-chat__message-reactions-list-item {
  font-size: 20px;
  margin: 0 5px;
  position: relative;
  line-height: 0;
}
.str-chat__message-reactions-list-item button {
  padding: 0;
}
.str-chat__message-reactions-list-item span[role='img'] {
  position: relative;
  display: block;
  top: -2px;
  transform: scalce(1);
  transition: transform 100ms ease;
}
.str-chat__message-reactions-list-item span[role='img']:hover {
  transform: scale(1.4);
}
.str-chat__message-reactions-list-item__count {
  position: absolute;
  top: 28px;
  font-size: 10px;
  color: #fff;
  font-weight: 700;
  left: 6px;
}
.str-chat__message-reactions-list-item .str-chat__avarar {
  margin: 0;
  visibility: visible;
}
.str-chat__message-reactions-list-item .latest-user {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -24px;
  left: 0;
}
.str-chat__message-reactions-list-item .latest-user-tooltip {
  display: none;
  text-align: center;
  position: absolute;
  bottom: calc(100% + 5px);
  left: 50%;
  transform: translate(-50%, 0);
  background: rgba(0, 0, 0, 0.81);
  border-radius: 5px;
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  max-width: 237px;
  padding: 4px 8px;
  font-size: 13px;
  color: white;
}
.str-chat__message-reactions-list-item .latest-user-tooltip::after {
  content: '';
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  transform: translate(-50%, 0) rotate(45deg);
  width: 7px;
  height: 7px;
  background-color: #1a1a1a;
}
.str-chat__message-reactions-list-item .latest-user-not-found {
  border: 1.5px solid #fff;
  border-radius: 50%;
  background-color: magenta;
  width: inherit;
  height: inherit;
}
.str-chat__message-reactions-list-item .latest-user img {
  border: 1.5px solid #fff;
  border-radius: 50%;
  object-fit: cover;
  width: inherit;
  height: inherit;
}
.str-chat__message-reactions-list-item .latest-user:hover .latest-user-tooltip {
  display: block;
}
.str-chat__reaction-selector {
  z-index: 999;
  height: 60px;
  position: absolute;
  width: initial;
  background: rgba(24, 25, 28, 0.98);
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.05) 100%);
  border: 1px solid rgba(224, 224, 224, 0.03);
  box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.07), 0 11px 8px 0 rgba(0, 0, 0, 0.15);
  border-radius: 30px;
  display: flex;
  align-items: center;
}
.str-chat__reaction-selector ul {
  position: relative;
  z-index: 1000;
  margin: 0 16px;
}
.str-chat__reaction-selector-tooltip {
  position: absolute;
  bottom: calc(100% + 15px);
  background: rgba(0, 0, 0, 0.81);
  border-radius: 5px;
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  min-width: 85px;
  min-height: 24px;
  max-width: 100%;
  padding: 4px 8px;
  font-size: 13px;
  color: white;
  text-align: center;
}
.str-chat__reaction-selector-tooltip .arrow {
  position: absolute;
  top: calc(100% - 4px);
  left: 50%;
  transform: translate(-50%, 0) rotate(45deg);
  width: 7px;
  height: 7px;
  background-color: #1a1a1a;
}
.str-chat__reaction-selector .emoji-mart-emoji:hover {
  transition: 0.1s;
  transform: scale(1.2);
  cursor: pointer;
}
.str-chat__message .str-chat__reaction-selector,
.str-chat__message-team .str-chat__reaction-selector,
.str-chat__message-simple .str-chat__reaction-selector,
.str-chat__message-commerce .str-chat__reaction-selector,
.str-chat__message-livestream .str-chat__reaction-selector {
  top: -65px;
  left: 0;
}
.str-chat__message-commerce--right .str-chat__reaction-selector {
  left: unset;
  right: 0;
}
.str-chat__message-livestream .str-chat__reaction-selector {
  left: unset;
  top: -70px;
  right: 0;
}
.str-chat__message-team .str-chat__reaction-selector {
  left: unset;
  top: -60px;
  right: 0;
}
.str-chat__message-simple .str-chat__reaction-selector {
  right: unset;
  left: 0;
}
.str-chat__message-simple .str-chat__reaction-selector--reverse {
  right: 0;
  left: unset;
}
.str-chat__message-simple--me .str-chat__reaction-selector {
  left: unset;
  right: 0;
}
.str-chat__message-simple--me .str-chat__reaction-selector--reverse {
  right: unset;
  left: 0;
}
.str-chat__send-button {
  margin-left: 10px;
  border: 0;
  background: 0;
  outline: 0;
}
@media screen and (min-width: 768px) {
  .str-chat__send-button {
    display: none;
  }
}
.str-chat__simple-reactions-list {
  list-style-type: none;
  padding: 4px 4px 2px 4px;
  display: inline-flex;
  margin: 8px 0 0 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  line-height: 1;
  position: relative;
}
.str-chat__simple-reactions-list-tooltip {
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translate(-50%, 0);
  background: rgba(0, 0, 0, 0.81);
  border-radius: 5px;
  background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  min-height: 24px;
  width: auto;
  max-width: 275px;
  padding: 4px 8px;
  font-size: 13px;
  color: white;
  text-align: center;
}
.str-chat__simple-reactions-list-tooltip > .arrow {
  position: absolute;
  top: calc(100%);
  left: 50%;
  transform: translate(-50%, 0);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(0, 0, 0, 0.81);
}
.str-chat__simple-reactions-list-item {
  margin: 0 0;
  cursor: pointer;
}
.str-chat__simple-reactions-list-item > span {
  line-height: 1;
}
.str-chat__simple-reactions-list-item .emoji-mart-emoji:hover {
  transition: transform 0.2s ease-in-out;
  transform: scale(1.2);
}
.str-chat__simple-reactions-list-item--last-number {
  font-size: 11px;
  display: flex;
  align-items: center;
  color: black;
}
.dark.str-chat .str-chat__simple-reactions-list {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
.dark.str-chat .str-chat__simple-reactions-list-item--last-number {
  color: #fff;
}
.str-chat__thread {
  background: #f1f1f3;
  flex: 1 0 300px;
  min-width: 300px;
  max-width: 300px;
  overflow-y: hidden;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  overflow: hidden;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
}
.str-chat__thread--full {
  max-width: 100%;
}
.str-chat__thread-header {
  position: relative;
  width: 100%;
  background: #f1f1f3;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  height: 70px;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}
.str-chat__thread-header-details {
  font-size: 14px;
}
.str-chat__thread-header-details small {
  display: block;
  font-size: 12px;
}
.str-chat__thread-start {
  border-radius: 4px;
  margin: 10px 10px 0 10px;
  padding: 8px;
  background: rgba(153, 196, 255, 0.1);
  text-align: center;
  font-size: 12px;
}
.str-chat__thread-list {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
}
.str-chat__thread-list .str-chat__list {
  padding: 0;
}
.messaging.str-chat .str-chat__thread {
  margin-right: 10px;
  margin-top: 20px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  background: white;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 0px;
}
.messaging.str-chat .str-chat__thread.str-chat__thread--full {
  margin: 0;
}
.messaging.str-chat .str-chat__thread .str-chat__gallery {
  justify-content: flex-end;
  border-radius: 0;
}
.messaging.str-chat .str-chat__thread .str-chat__gallery-image,
.messaging.str-chat .str-chat__thread .str-chat__gallery-placeholder {
  width: 100px;
  height: 100px;
}
.messaging.str-chat .str-chat__thread-list {
  padding: 20px 10px 0 10px;
}
.messaging.str-chat .str-chat__thread-list > .str-chat__list {
  background: transparent;
  padding: 0;
}
.messaging.str-chat .str-chat__thread-list > .str-chat__list .str-chat__list--thread {
  padding: 0;
}
.messaging.str-chat .str-chat__thread-header {
  border: none;
  box-shadow: none;
  background: white;
}
.messaging.str-chat .str-chat__thread-start {
  margin-top: 20px;
}
@media screen and (max-width: 960px) {
  .messaging.str-chat .str-chat__thread {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    background: white;
    z-index: 1000;
    margin: 0;
    width: 100vw;
    max-width: 100%;
  }
}
.messaging.str-chat.dark .str-chat__thread {
  background: rgba(255, 255, 255, 0.04);
}
.messaging.str-chat.dark .str-chat__thread-header {
  background: rgba(46, 48, 51, 0.98);
  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);
  color: white;
}
.messaging.str-chat.dark .str-chat__thread-start {
  color: white;
}
@media screen and (max-width: 960px) {
  .messaging.str-chat.dark .str-chat__thread {
    background: #282a2d;
  }
}
.team.str-chat .str-chat__thread {
  background: white;
}
@media screen and (max-width: 960px) {
  .team.str-chat .str-chat__thread {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    background: white;
    z-index: 1000;
    margin: 0;
    width: 100vw;
    max-width: 100%;
  }
}
.team.str-chat .str-chat__thread-header {
  height: 80px;
}
.team.str-chat.dark .str-chat__thread {
  background: #1d1f22;
}
.livestream.str-chat .str-chat__thread,
.str-chat .str-chat__thread {
  background: transparent;
}
.livestream.str-chat .str-chat__thread-header,
.str-chat .str-chat__thread-header {
  background: rgba(255, 255, 255, 0.29);
}
.livestream.str-chat .str-chat__list--thread,
.str-chat .str-chat__list--thread {
  padding: 0 10px;
}
.livestream.str-chat.dark .str-chat__thread,
.str-chat.dark .str-chat__thread {
  background: #1a1a1a;
}
.livestream.str-chat.dark .str-chat__thread-header,
.str-chat.dark .str-chat__thread-header {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.34);
  color: white;
}
.livestream.str-chat.dark .str-chat__thread-start,
.str-chat.dark .str-chat__thread-start {
  background: rgba(153, 196, 255, 0.1);
  border-radius: 4px;
  color: white;
}
.str-chat__small-message-input {
  display: flex;
  flex-wrap: wrap;
  margin: 10px;
  position: relative;
  z-index: 1000;
}
.str-chat__small-message-input .rfu-file-previewer {
  flex: 1 1 100%;
}
.str-chat__small-message-input .rfu-image-previewer {
  flex: 1 1 100%;
}
.str-chat__small-message-input__wrapper {
  position: relative;
  z-index: 0;
  width: 100%;
}
.str-chat__small-message-input-emojiselect {
  bottom: 10px;
  right: 6px;
}
.str-chat__small-message-input .rfu-file-upload-button {
  bottom: 9px;
  right: 26px;
}
.str-chat__small-message-input--textarea-wrapper {
  flex-wrap: wrap;
  flex: 1 0;
  position: relative;
}
.str-chat__small-message-input-emojiselect,
.str-chat__small-message-input .rfu-file-upload-button {
  position: absolute;
  cursor: pointer;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-size: 44px 44px;
  fill: rgba(0, 0, 0, 0.6);
}
.str-chat__small-message-input-emojiselect:hover,
.str-chat__small-message-input .rfu-file-upload-button:hover {
  fill: black;
}
.str-chat__small-message-input-emojipicker {
  position: absolute;
  bottom: 100%;
  right: 0;
  transform: scale(0.8);
  transform-origin: 100% 100%;
}
.str-chat__small-message-input--send-button {
  background: none;
  border: none;
  cursor: pointer;
  flex: 0 1;
  outline: 0;
}
.str-chat__small-message-input--send-button:hover {
  opacity: 0.69;
}
@media screen and (min-width: 768px) {
  .str-chat__small-message-input--send-button {
    display: none;
  }
}
.str-chat__small-message-input textarea {
  background: transparent;
  min-height: 36px;
  font-size: 13px;
  padding: 10px 44px 8px 8px;
}
.str-chat__small-message-input textarea:focus {
  height: 36px;
}
.str-chat__small-message-input .str-chat__emojisearch {
  bottom: 100%;
}
.str-chat__small-message-input .str-chat__user-item {
  font-size: 14px;
}
.str-chat__small-message-input .rfu-file-upload-button {
  position: absolute;
  cursor: pointer;
  right: 28px;
}
.str-chat__small-message-input .rfu-dropzone .rfu-dropzone__notifier {
  z-index: 1000;
}
.dark.str-chat .str-chat__small-message-input textarea {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.21);
  border-radius: 6px;
  color: white;
}
.dark.str-chat .str-chat__small-message-input .rfu-file-upload-button svg,
.dark.str-chat .str-chat__small-message-input .str-chat__small-message-input-emojiselect svg {
  fill: white;
}
.str-chat__typing-indicator {
  display: flex;
  visibility: hidden;
  align-items: center;
}
.str-chat__typing-indicator--typing {
  visibility: visible;
}
.str-chat__typing-indicator__avatars {
  display: flex;
}
.str-chat__typing-indicator__avatars .str-chat__avatar {
  border: 2px solid white;
  margin-right: -14px;
}
.str-chat__typing-indicator__avatars .str-chat__avatar:last-of-type {
  margin-right: 14px;
}
.str-chat__typing-indicator__dots {
  position: relative;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 7px;
  border-radius: 16px 16px 16px 2px;
}
.str-chat__typing-indicator__dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 3px;
  background: #006cff;
  animation: wave 1.1s linear infinite;
}
.str-chat__typing-indicator__dot:nth-child(2) {
  animation-delay: -0.9s;
  opacity: 0.5;
}
.str-chat__typing-indicator__dot:nth-child(3) {
  animation-delay: -0.8s;
  opacity: 0.2;
}
.dark.str-chat .str-chat__typing-indicator__avatars .str-chat__avatar {
  border-color: #282a2d;
}
.dark.str-chat .str-chat__typing-indicator__dots {
  background: rgba(255, 255, 255, 0.05);
}
@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }
  30% {
    transform: translateY(-8px);
  }
}
.str-chat__tooltip {
  position: absolute;
  right: 0;
  bottom: calc(100% + 10px);
  display: flex;
  background: #000;
  border-radius: 4px;
  padding: 3px 7px;
  color: white;
  font-size: 11px;
  max-width: 300px;
}
.str-chat__tooltip button {
  outline: none;
  outline: 0;
  background: none;
  color: #006cff;
  font-size: 11px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  border: none;
}
.str-chat__tooltip a {
  color: #006cff;
  text-decoration: none;
}
.str-chat__tooltip::after {
  content: '';
  position: absolute;
  bottom: -2px;
  right: 5px;
  width: 5px;
  height: 5px;
  background: #000;
  transform: rotate(45deg);
}
.emoji-mart,
.emoji-mart * {
  box-sizing: border-box;
  line-height: 1.15;
}
.emoji-mart {
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  font-size: 16px;
  display: inline-block;
  color: #222427;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff;
}
.emoji-mart .emoji-mart-emoji {
  padding: 6px;
}
.emoji-mart-bar {
  border: 0 solid #d9d9d9;
}
.emoji-mart-bar:first-child {
  border-bottom-width: 1px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.emoji-mart-bar:last-child {
  border-top-width: 1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.emoji-mart-anchors {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 6px;
  line-height: 0;
}
.emoji-mart-anchor {
  position: relative;
  display: block;
  flex: 1 1 auto;
  color: #858585;
  text-align: center;
  padding: 12px 4px;
  overflow: hidden;
  transition: color 0.1s ease-out;
  margin: 0;
  box-shadow: none;
  background: none;
  border: none;
}
.emoji-mart-anchor:focus {
  outline: 0;
}
.emoji-mart-anchor:hover,
.emoji-mart-anchor:focus,
.emoji-mart-anchor-selected {
  color: #464646;
}
.emoji-mart-anchor-selected .emoji-mart-anchor-bar {
  bottom: 0;
}
.emoji-mart-anchor-bar {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #464646;
}
.emoji-mart-anchors i {
  display: inline-block;
  width: 100%;
  max-width: 22px;
}
.emoji-mart-anchors svg,
.emoji-mart-anchors img {
  fill: currentColor;
  height: 18px;
  width: 18px;
}
.emoji-mart-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 270px;
  padding: 0 6px 6px 6px;
  will-change: transform;
  /* avoids "repaints on scroll" in mobile Chrome */
}
.emoji-mart-search {
  margin-top: 6px;
  padding: 0 6px;
  position: relative;
}
.emoji-mart-search input {
  font-size: 16px;
  display: block;
  width: 100%;
  padding: 5px 25px 6px 10px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  outline: 0;
}
.emoji-mart-search input,
.emoji-mart-search input::-webkit-search-decoration,
.emoji-mart-search input::-webkit-search-cancel-button,
.emoji-mart-search input::-webkit-search-results-button,
.emoji-mart-search input::-webkit-search-results-decoration {
  /* remove webkit/blink styles for <input type="search">
   * via https://stackoverflow.com/a/9422689 */
  -webkit-appearance: none;
}
.emoji-mart-search-icon {
  position: absolute;
  top: 7px;
  right: 11px;
  z-index: 2;
  padding: 2px 5px 1px;
  border: none;
  background: none;
}
.emoji-mart-category .emoji-mart-emoji span {
  z-index: 1;
  position: relative;
  text-align: center;
  cursor: default;
}
.emoji-mart-category .emoji-mart-emoji:hover:before {
  z-index: 0;
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  border-radius: 100%;
}
.emoji-mart-category-label {
  z-index: 2;
  position: relative;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.emoji-mart-category-label span {
  display: block;
  width: 100%;
  font-weight: 500;
  padding: 5px 6px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.95);
}
.emoji-mart-category-list {
  margin: 0;
  padding: 0;
}
.emoji-mart-category-list li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
}
.emoji-mart-emoji {
  position: relative;
  display: inline-block;
  font-size: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
}
.emoji-mart-emoji-native {
  font-family: 'Segoe UI Emoji', 'Segoe UI Symbol', 'Segoe UI', 'Apple Color Emoji', 'Twemoji Mozilla', 'Noto Color Emoji', 'Android Emoji';
}
.emoji-mart-no-results {
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  color: #858585;
}
.emoji-mart-no-results-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.emoji-mart-no-results .emoji-mart-category-label {
  display: none;
}
.emoji-mart-no-results .emoji-mart-no-results-label {
  margin-top: 0.2em;
}
.emoji-mart-no-results .emoji-mart-emoji:hover:before {
  content: none;
}
.emoji-mart-preview {
  position: relative;
  height: 70px;
}
.emoji-mart-preview-emoji,
.emoji-mart-preview-data,
.emoji-mart-preview-skins {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.emoji-mart-preview-emoji {
  left: 12px;
}
.emoji-mart-preview-data {
  left: 68px;
  right: 12px;
  word-break: break-all;
}
.emoji-mart-preview-skins {
  right: 30px;
  text-align: right;
}
.emoji-mart-preview-skins.custom {
  right: 10px;
  text-align: right;
}
.emoji-mart-preview-name {
  font-size: 14px;
}
.emoji-mart-preview-shortname {
  font-size: 12px;
  color: #888;
}
.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,
.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,
.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {
  margin-left: 0.5em;
}
.emoji-mart-preview-emoticon {
  font-size: 11px;
  color: #bbb;
}
.emoji-mart-title span {
  display: inline-block;
  vertical-align: middle;
}
.emoji-mart-title .emoji-mart-emoji {
  padding: 0;
}
.emoji-mart-title-label {
  color: #999a9c;
  font-size: 26px;
  font-weight: 300;
}
.emoji-mart-skin-swatches {
  font-size: 0;
  padding: 2px 0;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background-color: #fff;
}
.emoji-mart-skin-swatches.custom {
  font-size: 0;
  border: none;
  background-color: #fff;
}
.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {
  width: 16px;
  padding: 0 2px;
}
.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {
  opacity: 0.75;
}
.emoji-mart-skin-swatch {
  display: inline-block;
  width: 0;
  vertical-align: middle;
  transition-property: width, padding;
  transition-duration: 0.125s;
  transition-timing-function: ease-out;
}
.emoji-mart-skin-swatch:nth-child(1) {
  transition-delay: 0s;
}
.emoji-mart-skin-swatch:nth-child(2) {
  transition-delay: 0.03s;
}
.emoji-mart-skin-swatch:nth-child(3) {
  transition-delay: 0.06s;
}
.emoji-mart-skin-swatch:nth-child(4) {
  transition-delay: 0.09s;
}
.emoji-mart-skin-swatch:nth-child(5) {
  transition-delay: 0.12s;
}
.emoji-mart-skin-swatch:nth-child(6) {
  transition-delay: 0.15s;
}
.emoji-mart-skin-swatch.selected {
  position: relative;
  width: 16px;
  padding: 0 2px;
}
.emoji-mart-skin-swatch.selected:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin: -2px 0 0 -2px;
  background-color: #fff;
  border-radius: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-out;
}
.emoji-mart-skin-swatch.custom {
  display: inline-block;
  width: 0;
  height: 38px;
  overflow: hidden;
  vertical-align: middle;
  transition-property: width, height;
  transition-duration: 0.125s;
  transition-timing-function: ease-out;
  cursor: default;
}
.emoji-mart-skin-swatch.custom.selected {
  position: relative;
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0;
}
.emoji-mart-skin-swatch.custom.selected:after {
  content: '';
  width: 0;
  height: 0;
}
.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {
  background-color: #f4f4f4;
  border-radius: 10%;
}
.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0;
}
.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {
  opacity: 0.75;
}
.emoji-mart-skin-text.opened {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  color: #888;
  font-size: 11px;
  padding: 5px 2px;
  width: 95px;
  height: 40px;
  border-radius: 10%;
  background-color: #fff;
}
.emoji-mart-skin {
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  max-width: 12px;
  border-radius: 100%;
}
.emoji-mart-skin-tone-1 {
  background-color: #ffc93a;
}
.emoji-mart-skin-tone-2 {
  background-color: #fadcbc;
}
.emoji-mart-skin-tone-3 {
  background-color: #e0bb95;
}
.emoji-mart-skin-tone-4 {
  background-color: #bf8f68;
}
.emoji-mart-skin-tone-5 {
  background-color: #9b643d;
}
.emoji-mart-skin-tone-6 {
  background-color: #594539;
}
/* For screenreaders only, via https://stackoverflow.com/a/19758620 */
.emoji-mart-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
/*
 * Dark mode styles
 */
.emoji-mart-dark {
  color: #fff;
  border-color: #555453;
  background-color: #222;
}
.emoji-mart-dark .emoji-mart-bar {
  border-color: #555453;
}
.emoji-mart-dark .emoji-mart-search input {
  color: #fff;
  border-color: #555453;
  background-color: #2f2f2f;
}
.emoji-mart-dark .emoji-mart-search-icon svg {
  fill: #fff;
}
.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {
  background-color: #444;
}
.emoji-mart-dark .emoji-mart-category-label span {
  background-color: #222;
  color: #fff;
}
.emoji-mart-dark .emoji-mart-skin-swatches {
  border-color: #555453;
  background-color: #222;
}
.emoji-mart-dark .emoji-mart-anchor:hover,
.emoji-mart-dark .emoji-mart-anchor:focus,
.emoji-mart-dark .emoji-mart-anchor-selected {
  color: #bfbfbf;
}
.str-chat__message-commerce {
  display: flex;
  /* inline-flex if you don't want the  */
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0 0 0 0;
  position: relative;
  margin: 1px 0;
  /* deleted messages */
  /* error messages */
}
.str-chat__message-commerce-inner {
  position: relative;
  /* flex: 1 if you want the messagebubbles to be the same width- */
}
.str-chat__message-commerce-inner > .str-chat__message-commerce__actions {
  min-height: 10px;
  min-width: 30px;
  float: right;
}
.str-chat__message-commerce-inner > .str-chat__message-commerce__actions .str-chat__reaction-list {
  left: unset;
  right: 46px;
}
.str-chat__message-commerce .str-chat__avatar {
  margin-right: 8px;
}
.str-chat__message-commerce .str-chat__message-attachment-card--content {
  margin: 0;
  padding: 6px 8px;
}
.str-chat__message-commerce--top,
.str-chat__message-commerce--middle {
  margin-left: 40px;
}
.str-chat__message-commerce--top .str-chat__message-commerce-data,
.str-chat__message-commerce--middle .str-chat__message-commerce-data {
  display: none;
}
.str-chat__message-commerce--top .str-chat__message-commerce-text-inner {
  border-radius: 16px 16px 4px 4px;
}
.str-chat__message-commerce--bottom .str-chat__message-commerce-text-inner {
  border-radius: 4px 4px 16px 0;
}
.str-chat__message-commerce--single .str-chat__message-commerce-text-inner {
  border-radius: 16px 16px 16px 0;
}
.str-chat__message-commerce--single .str-chat__message-commerce-text-inner--has-attachment {
  border-radius: 4px 4px 16px 0;
}
.str-chat__message-commerce--middle .str-chat__message-commerce-text-inner {
  border-radius: 4px 4px 4px 4px;
}
.str-chat__message-commerce-text {
  display: flex;
  padding: 0 0 0 0;
  position: relative;
}
.str-chat__message-commerce-text-inner {
  position: relative;
  display: block;
  min-height: 32px;
  padding: 5px 10px;
  font-size: 15px;
  /* variables */
  color: black;
  /* variables */
  border-radius: 16px 16px 16px 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-left: 0;
  max-width: 345px;
}
.str-chat__message-commerce-text-inner p {
  margin: 0;
  white-space: pre-line;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
.str-chat__message-commerce-text-inner p:not(:first-of-type) {
  margin: 16px 0 0;
}
.str-chat__message-commerce-text-inner--has-attachment {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__message-commerce-text-inner--is-emoji {
  background: transparent;
  border: 1px solid transparent;
  font-size: 32px;
  line-height: 48px;
  padding-left: 0;
  padding-right: 0;
}
.str-chat__message-commerce-attachment--img {
  width: 100%;
  max-width: 480px;
  display: block;
  height: inherit;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.str-chat__message-commerce-data {
  margin-top: 5px;
  width: 100%;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.5);
}
.str-chat__message-commerce-name {
  font-weight: 700;
  margin-right: 5px;
}
.str-chat__message-commerce p {
  margin: 0;
  line-height: 20px;
}
.str-chat__message-commerce--with-reactions {
  margin-top: 30px;
}
.str-chat__message-commerce--with-reactions .str-chat__message-commerce__actions__action--reactions {
  display: flex;
}
.str-chat__message-commerce-link {
  color: magenta;
  font-weight: 700;
  text-decoration: none;
}
.str-chat__message-commerce-mention {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  font-size: 16px;
  color: magenta;
  font-weight: 700;
}
.str-chat__message-commerce--inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.str-chat__message-commerce--deleted {
  background: #f0f0f0;
  float: left;
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 12px;
  color: #a4a4a4;
  margin: 0 0 0 42px;
}
.str-chat__message-commerce--error {
  margin: 0 0 32px 0;
  font-size: 12px;
}
.str-chat__message-commerce--error .str-chat__message-text-inner {
  background: rgba(208, 2, 27, 0.1);
  border: 1px solid rgba(208, 2, 27, 0.1);
}
.str-chat__message-commerce--right.str-chat__message-commerce {
  justify-content: flex-end;
  margin-left: 0;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce__actions {
  justify-content: flex-end;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-inner > .str-chat__message-commerce__actions {
  float: left;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-inner > .str-chat__message-commerce__actions .str-chat__reaction-list {
  left: 46px;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-inner > .str-chat__message-commerce-reply-button {
  display: flex;
  justify-content: flex-end;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-inner > .str-chat__message-commerce-reply-button .str-chat__message-replies-count-button {
  display: flex;
  flex-direction: row-reverse;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-inner > .str-chat__message-commerce-reply-button .str-chat__message-replies-count-button svg {
  transform: scaleX(-1);
  margin-left: 5px;
  margin-bottom: 4px;
  margin-right: 0;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-text-inner {
  background: #ebebeb;
  border-width: 0px;
  margin-top: 2px;
  border-color: transparent;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-text-inner p {
  text-align: right;
}
.str-chat__message-commerce--right.str-chat__message-commerce > .str-chat__avatar {
  display: none;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-attachment {
  margin: 0 auto 0 30px;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-attachment--img {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-attachment-card {
  border-radius: 16px 16px 4px 16px;
}
.str-chat__message-commerce--right.str-chat__message-commerce--bottom,
.str-chat__message-commerce--right.str-chat__message-commerce--single {
  margin-right: 0;
}
.str-chat__message-commerce--right.str-chat__message-commerce--single .str-chat__message-commerce-text-inner {
  border-radius: 16px 16px 4px 16px;
}
.str-chat__message-commerce--right.str-chat__message-commerce--single .str-chat__message-commerce-text-inner--has-attachment {
  border-radius: 16px 4px 4px 16px;
}
.str-chat__message-commerce--right.str-chat__message-commerce--bottom .str-chat__message-commerce-text-inner {
  border-radius: 4px 4px 4px 16px;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__avatar {
  order: 1;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-text {
  flex-direction: row-reverse;
  justify-content: flex-start;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-text-inner {
  flex: unset;
}
.str-chat__message-commerce--right.str-chat__message-commerce .str-chat__message-commerce-data {
  text-align: right;
}
.str-chat__message-commerce--has-text .str-chat__message-commerce-inner .str-chat__message-attachment {
  width: 100%;
  height: auto;
  margin: 4px auto;
}
.str-chat__message-commerce {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.str-chat__message-commerce__actions {
  display: flex;
  margin-top: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 30px;
}
.str-chat__message-commerce__actions__action {
  margin: 5px;
  display: flex;
  align-items: center;
  height: 10px;
  cursor: pointer;
}
.str-chat__message-commerce__actions__action svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__message-commerce__actions__action:hover svg {
  opacity: 1;
}
.str-chat__message-commerce__actions__action--thread,
.str-chat__message-commerce__actions__action--reactions {
  display: none;
}
.str-chat__message-commerce__actions__action--options {
  position: relative;
  display: none;
}
.str-chat__message-commerce__actions__action--options .str-chat__message-actions-box {
  bottom: 10px;
  left: unset;
  right: 100%;
  width: 120px;
  border-radius: 16px 16px 2px 16px;
}
.str-chat__message-commerce.str-chat__message--with-reactions .str-chat__message-commerce__actions__action--reactions {
  display: flex;
}
.str-chat__message-commerce:hover .str-chat__message-commerce__actions__action--thread {
  display: flex;
}
.str-chat__message-commerce:hover .str-chat__message-commerce__actions__action--reactions {
  display: flex;
}
.str-chat__message-commerce-text {
  display: flex;
  padding: 0 0 0 0;
  position: relative;
}
.str-chat__message-commerce-text-inner {
  text-align: left;
}
.str-chat__message-commerce-text-inner.str-chat__message-commerce-text-inner--is-emoji {
  margin: 5px 0;
  background: transparent;
}
.str-chat__message-commerce-text-inner p {
  text-align: left;
}
.str-chat__message-commerce-text-inner a {
  color: #006cff;
  font-weight: 700;
  text-decoration: none;
}
.str-chat__message-commerce-text-inner blockquote {
  margin: 0 0 0 5px;
  font-style: italic;
  padding-left: 20px;
  position: relative;
}
.str-chat__message-commerce-text-inner blockquote::before {
  font-size: 25px;
  content: '\\201C';
  font-style: italic;
  position: absolute;
  opacity: 0.5;
  top: 2px;
  left: -5px;
}
.str-chat__message-commerce:hover .str-chat__message-commerce__actions__action--options {
  display: flex;
}
.str-chat__message-commerce:hover .str-chat__message-commerce__actions__action--reactions {
  display: flex;
}
.str-chat__message-commerce:hover .str-chat__message-commerce__actions__action--thread {
  display: flex;
}
.str-chat__commerce-message--error-message {
  text-align: left;
  text-transform: uppercase;
  font-size: 11px;
  opacity: 0.5;
}
.str-chat__message-commerce-status {
  margin: 10px 0px 10px 10px;
  order: 3;
  position: absolute;
  left: 100%;
  bottom: 0;
  line-height: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 11;
}
.str-chat__message-commerce-status-number {
  font-size: 10px;
  margin-left: 4px;
  position: absolute;
  left: 100%;
  color: rgba(0, 0, 0, 0.6);
}
.str-chat__message-commerce-status > .str-chat__avatar {
  align-self: flex-end;
  margin-right: 0;
}
.str-chat__message-commerce-status > .str-chat__tooltip {
  display: none;
  max-width: 300px;
  min-width: 100px;
  text-align: center;
}
.str-chat__message-commerce-status:hover > .str-chat__tooltip {
  display: block;
}
.str-chat__message-commerce-status::after {
  position: absolute;
  bottom: 100%;
  right: 0;
  content: ' ';
  width: 15px;
  height: 15px;
}
.str-chat__message-commerce .str-chat__message-attachment {
  width: calc(100% - 30px);
  max-width: unset;
  border-radius: unset;
  margin: 0 auto 0 0;
}
.str-chat__message-commerce .str-chat__message-attachment-card {
  margin: 0;
  border-radius: 4px 16px 4px 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__message-commerce .str-chat__message-attachment-card--content {
  background: #ebebeb;
}
.str-chat__message-commerce .str-chat__message-attachment-card--text {
  display: none;
}
.str-chat__list--thread .str-chat__message-commerce__actions {
  width: 30px;
}
.str-chat__list--thread .str-chat__message-commerce__actions__action--options .str-chat__message-actions-box {
  right: unset;
  left: 100%;
  border-radius: 16px 16px 16px 2px;
}
.str-chat.dark .str-chat__message-commerce-data {
  color: white;
  opacity: 0.5;
}
.str-chat.dark .str-chat__message-commerce-text-inner {
  background: rgba(255, 255, 255, 0.05);
  color: white;
}
.str-chat.dark .str-chat__message-commerce__actions svg {
  fill: white;
}
.str-chat.dark .str-chat__message-commerce .str-chat__message-attachment-card {
  background: rgba(0, 0, 0, 0.2);
}
.str-chat.dark .str-chat__message-commerce .str-chat__message-attachment-card--content {
  background: rgba(0, 0, 0, 0.2);
}
.str-chat.dark .str-chat__message-commerce .str-chat__message-attachment-card--title {
  color: white;
}
.str-chat.dark .str-chat__message-commerce .str-chat__message-attachment-card--url {
  color: rgba(255, 255, 255, 0.5);
}
.str-chat.dark .str-chat__message-commerce--right .str-chat__message-commerce-text-inner {
  background: rgba(0, 0, 0, 0.2);
}
.str-chat.dark .str-chat__message-commerce--right .str-chat__message-commerce .str-chat__message-attachment-card {
  background: rgba(0, 0, 0, 0.2);
}
.str-chat.dark .str-chat__message-commerce--right .str-chat__message-commerce .str-chat__message-attachment-card--content {
  background: rgba(0, 0, 0, 0.2);
}
.str-chat {
  /* .str-chat__message */
}
.str-chat__message {
  /* .str-chat__message-team */
}
.str-chat__message-team {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  position: relative;
  display: flex;
  padding: 5px 40px;
}
.str-chat__message-team .str-chat__avatar {
  margin-right: 0;
}
.str-chat__message-team-actions {
  position: absolute;
  top: -12px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 88px;
  height: 24px;
  border-radius: 100px;
  background: white;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);
  z-index: 10;
  visibility: hidden;
}
.str-chat__message-team-actions > span {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.str-chat__message-team-actions > span > span {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}
.str-chat__message-team-actions > span svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__message-team-actions > span:hover svg {
  opacity: 1;
}
.str-chat__message-team-actions .str-chat__message-actions-box {
  bottom: initial;
  left: initial;
  visibility: hidden;
  right: 100%;
  top: -10px;
  border-radius: 7px;
}
.str-chat__message-team-actions .str-chat__message-actions-box--open {
  visibility: visible;
}
.str-chat__message-team-group {
  position: relative;
  width: 100%;
}
.str-chat__message-team-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 50px;
  padding: 0 10px 0 0;
  justify-content: space-between;
}
.str-chat__message-team-meta time {
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
  font-size: 10px;
  margin-bottom: 5px;
  text-align: right;
  visibility: hidden;
}
.str-chat__message-team-author {
  font-size: 15px;
  text-transform: capitalize;
  line-height: 40px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.str-chat__message-team-content {
  width: 100%;
  padding-left: 10px;
  color: #404040;
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  margin: 0 0;
}
.str-chat__message-team-content--image {
  padding-left: 0;
  border-left-color: transparent;
}
.str-chat__message-team-content p {
  margin: 0;
  white-space: pre-line;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
.str-chat__message-team-content p:not(:first-of-type) {
  margin: 16px 0 0;
}
.str-chat__message-team-content p a {
  color: #006cff;
  font-weight: bold;
  text-decoration: none;
}
.str-chat__message-team-content p code {
  background-color: #f8f8f8;
  border: 1px solid rgba(208, 2, 27, 0.1);
  border-radius: 3px;
  padding: 2px;
}
.str-chat__message-team-content pre,
.str-chat__message-team-content code {
  font-family: Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console', 'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier, monospace;
  line-height: inherit;
  font-size: 12px;
  font-weight: 700;
}
.str-chat__message-team-content pre {
  margin: 0 5px 0 0;
  border-radius: 4px;
  background-color: #f8f8f8;
  border: 1px solid #d3d3d3;
  padding: 10px;
}
.str-chat__message-team-content code {
  width: inherit;
  white-space: pre-wrap;
  word-break: break-all;
}
.str-chat__message-team-content ul {
  margin: 0;
}
.str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,
.str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-135deg) translateX(1px);
  transform-origin: 0;
  width: 5px;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.1);
}
.str-chat__message-team-content--top {
  margin: 5px 0 0;
}
.str-chat__message-team-content--single {
  margin: 5px 0 0;
}
.str-chat__message-team-content--middle {
  margin: 0 0 0;
}
.str-chat__message-team-content--bottom {
  margin: 0 0 0;
}
.str-chat__message-team-text--is-emoji {
  font-size: 33px;
  line-height: 42px;
}
.str-chat__message-team-status {
  position: absolute;
  left: 100%;
  bottom: 1px;
  line-height: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 11;
}
.str-chat__message-team-status-number {
  font-size: 10px;
  margin-left: 4px;
  position: absolute;
  left: 100%;
  color: rgba(0, 0, 0, 0.6);
}
.str-chat__message-team-status > .str-chat__avatar {
  align-self: flex-end;
  margin-right: 0;
}
.str-chat__message-team-status > .str-chat__tooltip {
  display: none;
  max-width: 300px;
  min-width: 100px;
  text-align: center;
}
.str-chat__message-team-status:hover > .str-chat__tooltip {
  display: block;
}
.str-chat__message-team-status::after {
  position: absolute;
  bottom: 100%;
  right: 0;
  content: ' ';
  width: 15px;
  height: 15px;
}
.str-chat__message-team-failed {
  border: 0;
  background: none;
  display: flex;
  align-items: center;
  color: #ea152f;
  cursor: pointer;
  margin: 5px 0;
  font-size: 12px;
  padding: 0;
}
.str-chat__message-team-failed svg {
  margin-right: 7px;
}
.str-chat__message-team-form-footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 0 5px;
}
.str-chat__message-team--bottom .str-chat__message-team-meta time,
.str-chat__message-team--single .str-chat__message-team-meta time {
  visibility: visible;
}
.str-chat__message-team--editing {
  padding: 10px;
  background: #edf4ff;
  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.06), inset 0 1px 0 0 #006cff, inset 0 -1px 0 0 #006cff;
  z-index: 1;
}
.str-chat__message-team:hover {
  /* .-team:hover */
}
.str-chat__message-team:hover {
  /* .str-chat__message-attachment, */
}
.str-chat__message-team:hover .str-chat__message-team-content {
  background: rgba(0, 0, 0, 0.03);
}
.str-chat__message-team:hover .str-chat__message-team-meta time {
  visibility: visible;
}
.str-chat__message-team:hover .str-chat__message-team-actions {
  visibility: visible;
}
.str-chat__message-team--error {
  /* .str-chat__message-team--error */
  padding-top: 20px;
  padding-bottom: 20px;
}
.str-chat__message-team--error .str-chat__message-team-status {
  display: none;
}
.str-chat__message-team--error .str-chat__message-team-content {
  background: transparent;
  border-width: 2px;
  border-color: #d0021b;
  /* error */
}
.str-chat__message-team--error .str-chat__message-team-content p {
  opacity: 0.5;
}
.str-chat__message-team--error .str-chat__message-team-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(-135deg) translateX(1px);
  transform-origin: 0;
  width: 5px;
  height: 2px;
  background-color: #d0021b;
  /* error */
}
.str-chat__message-team--ephemeral .str-chat__message-team-status {
  display: none;
}
.str-chat__message-team--failed .str-chat__message-team-content--text {
  border-color: #d0021b;
}
.str-chat__message-team--failed .str-chat__message-team-content--text p {
  opacity: 0.5;
}
.str-chat__message-team .str-chat__message-attachment--img {
  border-radius: 0;
  padding-left: 5px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}
.str-chat__message-team .str-chat__message-attachment-card {
  margin: 0;
  border-radius: 4px 4px 4px 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__message-team .str-chat__message-attachment-card--content {
  background: #ebebeb;
}
.str-chat__message-team .str-chat__message-attachment-card--text {
  display: none;
}
.str-chat__message-team .str-chat__input-emojiselect,
.str-chat__message-team .str-chat__input-fileupload {
  position: static;
  top: initial;
}
/* .str-chat */
.str-chat__message-team-error-header {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.4);
  font-style: italic;
  text-transform: none;
}
.str-chat__thread-list .str-chat__message-simple__actions {
  min-width: 30px;
}
.str-chat__thread-list .str-chat__message-team {
  padding: 5px 10px;
}
.str-chat__thread-list .str-chat__message-team-actions {
  width: 60px;
  min-width: unset;
}
.str-chat__thread-list .str-chat__message-team-actions .str-chat__message-actions-box {
  top: initial;
  bottom: initial;
  bottom: -10px;
}
.str-chat blockquote {
  margin: 0 0 0 5px;
  font-style: italic;
  padding-left: 20px;
  position: relative;
}
.str-chat blockquote::before {
  font-size: 25px;
  content: '\\201C';
  font-style: italic;
  position: absolute;
  opacity: 0.5;
  top: 2px;
  left: -5px;
}
.str-chat.dark .str-chat__message-team-error-header {
  color: rgba(255, 255, 255, 0.5);
  opacity: 1;
}
.str-chat.dark .str-chat__message-team-author {
  color: white;
}
.str-chat.dark .str-chat__message-team-meta time {
  color: rgba(255, 255, 255, 0.3);
}
.str-chat.dark .str-chat__message-team-content,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment {
  border-color: rgba(0, 0, 0, 0.4);
  color: white;
}
.str-chat.dark .str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,
.str-chat.dark .str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment--top:not(.str-chat__message-team-content--image)::before,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment--single:not(.str-chat__message-team-content--image)::before {
  background-color: rgba(0, 0, 0, 0.4);
}
.str-chat.dark .str-chat__message-team-content--image,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment--image {
  border-color: transparent;
}
.str-chat.dark .str-chat__message-team-content p code,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment p code {
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.str-chat.dark .str-chat__message-team-content pre,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment pre {
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-file--item,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-file--item {
  border-color: rgba(0, 0, 0, 0.4);
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-file--item a,
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-file--item span,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-file--item a,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-file--item span {
  color: white;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-file--item span,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-file--item span {
  opacity: 0.4;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-file--item:hover,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-file--item:hover {
  background: transparent;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment--file a,
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment--file span,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment--file a,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment--file span {
  color: white;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment--file span,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment--file span {
  opacity: 0.4;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-card,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-card {
  background: transparent;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-card--content,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-card--content {
  background: rgba(0, 0, 0, 0.1);
  min-height: 58px;
  margin: 0;
  padding: 0px 16px;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-card--title,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-card--title {
  color: white;
}
.str-chat.dark .str-chat__message-team-content .str-chat__message-attachment-card--url,
.str-chat.dark .str-chat__message-team .str-chat__message-attachment .str-chat__message-attachment-card--url {
  color: rgba(255, 255, 255, 0.4);
}
.str-chat.dark .str-chat__message-team-actions {
  background: #1b1d20;
  border: 1px solid rgba(224, 224, 224, 0.03);
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);
  border-radius: 12px;
}
.str-chat.dark .str-chat__message-team-actions .str-chat__message-actions-box {
  background: #6a6b6d;
}
.str-chat.dark .str-chat__message-team-actions > span {
  border-color: rgba(0, 0, 0, 0.04);
}
.str-chat.dark .str-chat__message-team-actions > span svg {
  fill: #fff;
}
.str-chat.dark .str-chat__message-team--error .str-chat__message-team-content {
  border-color: red;
  border-width: 1px;
}
.str-chat.dark .str-chat__message-team--error .str-chat__message-team-content p {
  color: rgba(255, 255, 255, 0.5);
  opacity: 1;
}
.str-chat.dark .str-chat__message-team--error .str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,
.str-chat.dark .str-chat__message-team--error .str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before {
  background-color: red;
  height: 1px;
}
.str-chat.dark .str-chat__message-team--editing {
  padding: 10px;
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.06), inset 0 1px 0 0 rgba(0, 108, 255, 0.1), inset 0 -1px 0 0 rgba(0, 108, 255, 0.1);
  z-index: 1;
}
.str-chat__li {
  display: block;
  position: relative;
  /* group styling */
}
.str-chat__li--top,
.str-chat__li--single {
  margin: 20px 0 0;
}
.str-chat__li--top .str-chat__message-attachment--img,
.str-chat__li--top .str-chat__message-attachment-card,
.str-chat__li--top .str-chat__message .str-chat__gallery,
.str-chat__li--single .str-chat__message-attachment--img,
.str-chat__li--single .str-chat__message-attachment-card,
.str-chat__li--single .str-chat__message .str-chat__gallery {
  border-radius: 16px 16px 16px 2px;
}
.str-chat__li--top .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--top .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--single .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--single .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card {
  border-radius: 16px 16px 16px 2px;
}
.str-chat__li--top .str-chat__message--me,
.str-chat__li--single .str-chat__message--me {
  text-align: right;
}
.str-chat__li--top .str-chat__message--me .str-chat__message-attachment--img,
.str-chat__li--top .str-chat__message--me .str-chat__message-attachment-card,
.str-chat__li--single .str-chat__message--me .str-chat__message-attachment--img,
.str-chat__li--single .str-chat__message--me .str-chat__message-attachment-card {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--top .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--top .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--single .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--single .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--top .str-chat__message--me .str-chat__gallery,
.str-chat__li--single .str-chat__message--me .str-chat__gallery {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--top .str-chat__message--me.str-chat__message--has-text .str-chat__gallery,
.str-chat__li--single .str-chat__message--me.str-chat__message--has-text .str-chat__gallery {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--middle {
  margin: 0;
}
.str-chat__li--middle .str-chat__message-attachment--img,
.str-chat__li--middle .str-chat__message-attachment-card,
.str-chat__li--middle .str-chat__message .str-chat__gallery {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--middle .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--middle .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--middle .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__gallery {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--middle .str-chat__message--me .str-chat__message-attachment--img,
.str-chat__li--middle .str-chat__message--me .str-chat__message-attachment-card,
.str-chat__li--middle .str-chat__message--me .str-chat__message .str-chat__gallery {
  border-radius: 16px 2px 2px 16px;
}
.str-chat__li--middle .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--middle .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--middle .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__gallery {
  border-top-left-radius: 2px;
}
.str-chat__li--bottom {
  margin: 0 0 20px;
}
.str-chat__li--bottom .str-chat__message-attachment--img,
.str-chat__li--bottom .str-chat__message-attachment-card,
.str-chat__li--bottom .str-chat__message .str-chat__gallery {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--bottom .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--bottom .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--bottom .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__gallery {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment--img,
.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment-card,
.str-chat__li--bottom .str-chat__message--me .str-chat__message .str-chat__gallery {
  border-radius: 16px 2px 2px 16px;
}
.str-chat__li--bottom .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment--img,
.str-chat__li--bottom .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__message-attachment-card,
.str-chat__li--bottom .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment .str-chat__gallery {
  border-top-left-radius: 2px;
}
.str-chat__li--single {
  margin-bottom: 20px;
}
.str-chat__li--top .str-chat__message-data,
.str-chat__li--middle .str-chat__message-data {
  display: none;
}
.str-chat__li--top .str-chat__message-text-inner {
  border-radius: 16px 16px 16px 2px;
}
.str-chat__li--top .str-chat__message--me .str-chat__message-text-inner {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--single .str-chat__message-text-inner {
  border-radius: 16px 16px 16px 2px;
}
.str-chat__li--single .str-chat__message-text-inner--has-attachment {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--single .str-chat__message--me .str-chat__message-text-inner {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__li--single .str-chat__message--me .str-chat__message-text-inner--has-attachment {
  border-radius: 16px 2px 2px 16px;
}
.str-chat__li--bottom .str-chat__message-text-inner,
.str-chat__li--middle .str-chat__message-text-inner {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__li--bottom .str-chat__message--me .str-chat__message-text-inner,
.str-chat__li--middle .str-chat__message--me .str-chat__message-text-inner {
  border-radius: 16px 2px 2px 16px;
}
.str-chat__li--bottom .str-chat__message--me .str-chat__message-text-inner--has-attachment,
.str-chat__li--middle .str-chat__message--me .str-chat__message-text-inner--has-attachment {
  margin: 0;
}
.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment-card,
.str-chat__li--middle .str-chat__message--me .str-chat__message-attachment-card {
  margin: 0;
  padding: 0;
  border-radius: 16px 2px 2px 16px;
}
.str-chat__message,
.str-chat__message-simple {
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 0 0 0 0;
  position: relative;
  margin: 1px 0;
  /* me */
  /* deleted messages */
  /* error messages */
}
.str-chat__message--system,
.str-chat__message-simple--system {
  text-align: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  padding: 0 40px;
  margin: 40px 0;
  font-size: 10px;
}
.str-chat__message--system__text,
.str-chat__message-simple--system__text {
  display: flex;
  align-items: center;
  width: 100%;
}
.str-chat__message--system__text p,
.str-chat__message-simple--system__text p {
  margin: 0 25px;
  color: rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  font-weight: bold;
}
.str-chat__message--system__line,
.str-chat__message-simple--system__line {
  flex: 1;
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}
.str-chat__message--system__date,
.str-chat__message-simple--system__date {
  margin-top: 3px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
}
.str-chat__message-inner,
.str-chat__message-simple-inner {
  position: relative;
}
@media screen and (min-width: 420px) {
  .str-chat__message-inner,
  .str-chat__message-simple-inner {
    margin-right: 90px;
    margin-left: unset;
  }
}
.str-chat__message-inner > .str-chat__message-simple__actions,
.str-chat__message-simple-inner > .str-chat__message-simple__actions {
  position: absolute;
  top: 5px;
  left: 100%;
}
.str-chat__message-attachment-container,
.str-chat__message-simple-attachment-container {
  display: flex;
  flex-direction: column;
}
.str-chat__message-text,
.str-chat__message-simple-text {
  display: inline-flex;
  justify-content: flex-start;
  padding: 0 0 0 0;
  position: relative;
  width: 100%;
}
.str-chat__message-text-inner,
.str-chat__message-simple-text-inner {
  position: relative;
  flex: 1;
  display: block;
  min-height: 32px;
  padding: 5px 10px;
  font-size: 15px;
  /* variables */
  color: black;
  /* variables */
  border-radius: 16px 16px 16px 0;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-left: 0;
  /* set spacing when unfocused */
  /* if text consists is focused */
  /* if text consists of just one emoji */
}
.str-chat__message-text-inner p,
.str-chat__message-simple-text-inner p {
  /* Make sure really long urls and words don't break out.
        ** https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */
  overflow-wrap: break-word;
  word-wrap: break-word;
  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
}
.str-chat__message-text-inner--focused,
.str-chat__message-simple-text-inner--focused {
  background: #bcd8ff;
  border: 1px solid #006cff;
  margin-right: 0;
  margin-left: 0;
  /* set spacing when focused */
}
.str-chat__message-text-inner--has-attachment,
.str-chat__message-simple-text-inner--has-attachment {
  border-radius: 2px 16px 16px 2px;
}
.str-chat__message-text-inner--is-emoji,
.str-chat__message-simple-text-inner--is-emoji {
  background: transparent;
  border: 1px solid transparent;
  font-size: 32px;
  padding-left: 0;
  padding-right: 0;
}
.str-chat__message-attachment--img,
.str-chat__message-simple-attachment--img {
  width: 100%;
  max-width: 480px;
  display: block;
  height: inherit;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.str-chat__message-data,
.str-chat__message-simple-data {
  margin-top: 5px;
  width: 100%;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.5);
}
.str-chat__message-name,
.str-chat__message-simple-name {
  font-weight: 700;
  margin-right: 5px;
}
.str-chat__message p,
.str-chat__message-simple p {
  margin: 0;
  white-space: pre-line;
  line-height: 20px;
}
.str-chat__message p:not(:first-of-type),
.str-chat__message-simple p:not(:first-of-type) {
  margin: 16px 0 0;
}
.str-chat__message--me,
.str-chat__message-simple--me {
  display: flex;
  margin: 4px 0;
  justify-content: flex-end;
}
.str-chat__message--me .str-chat__message-text,
.str-chat__message-simple--me .str-chat__message-text {
  display: flex;
  justify-content: flex-end;
}
.str-chat__message--me .str-chat__message-attachment-container,
.str-chat__message-simple--me .str-chat__message-attachment-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.str-chat__message--me .str-chat__message-inner,
.str-chat__message-simple--me .str-chat__message-inner {
  justify-content: flex-end;
  align-items: flex-end;
}
@media screen and (min-width: 420px) {
  .str-chat__message--me .str-chat__message-inner,
  .str-chat__message-simple--me .str-chat__message-inner {
    margin-right: unset;
    margin-left: 90px;
  }
}
.str-chat__message--me .str-chat__message-inner > .str-chat__message-simple__actions,
.str-chat__message-simple--me .str-chat__message-inner > .str-chat__message-simple__actions {
  position: absolute;
  top: 5px;
  left: unset;
  right: 100%;
}
.str-chat__message--me .str-chat__message-text-inner,
.str-chat__message-simple--me .str-chat__message-text-inner {
  flex: initial;
  background: #ebebeb;
  border-color: transparent;
  text-align: right;
  border-radius: 16px 16px 2px 16px;
  margin-right: 0;
  /* set spacing when unfocused */
}
.str-chat__message--me .str-chat__message-text-inner--focused,
.str-chat__message-simple--me .str-chat__message-text-inner--focused {
  background: #bcd8ff;
  border: 1px solid #006cff;
  margin-left: 0;
  margin-right: 0;
  /* set spacing when focused */
}
.str-chat__message--me .str-chat__message-text-inner--has-attachment,
.str-chat__message-simple--me .str-chat__message-text-inner--has-attachment {
  border-radius: 16px 2px 2px 16px;
}
.str-chat__message--me .str-chat__message-text-inner--is-emoji,
.str-chat__message-simple--me .str-chat__message-text-inner--is-emoji {
  background: transparent;
  border: 1px solid transparent;
  font-size: 32px;
  padding-left: 0;
  padding-right: 0;
}
.str-chat__message--me .str-chat__message-text-inner--is-emoji p,
.str-chat__message-simple--me .str-chat__message-text-inner--is-emoji p {
  line-height: 48px;
}
.str-chat__message--me .str-chat__message-attachment--img,
.str-chat__message-simple--me .str-chat__message-attachment--img {
  width: 100%;
  max-width: 480px;
  display: block;
  height: inherit;
  object-fit: cover;
  border: none;
}
.str-chat__message--me .str-chat__message-data,
.str-chat__message-simple--me .str-chat__message-data {
  text-align: right;
}
.str-chat__message--with-reactions,
.str-chat__message-simple--with-reactions {
  margin-top: 30px;
}
.str-chat__message-link,
.str-chat__message-simple-link {
  color: magenta;
  font-weight: 700;
  text-decoration: none;
}
.str-chat__message-mention,
.str-chat__message-simple-mention {
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  font-size: 16px;
  color: magenta;
  font-weight: 700;
}
.str-chat__message--inner,
.str-chat__message-simple--inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.str-chat__message--deleted,
.str-chat__message-simple--deleted {
  margin: 0 0 0 42px;
  flex-direction: column;
  align-items: flex-start;
}
.str-chat__message--deleted-inner,
.str-chat__message-simple--deleted-inner {
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 12px;
  color: #a4a4a4;
}
.str-chat__message--me.str-chat__message--deleted,
.str-chat__message-simple--me.str-chat__message--deleted {
  margin: 0 42px 0 0;
  align-items: flex-end;
}
.str-chat__message--me.str-chat__message--deleted-inner,
.str-chat__message-simple--me.str-chat__message--deleted-inner {
  background: rgba(255, 255, 255, 0.1);
  padding: 8px 16px;
  border-radius: 16px;
  font-size: 12px;
  color: #a4a4a4;
}
.str-chat__message--error,
.str-chat__message--failed,
.str-chat__message-simple--error,
.str-chat__message-simple--failed {
  margin: 0 0 32px 42px;
  font-size: 12px;
  padding: 4px 0;
}
.str-chat__message--error .str-chat__message-text-inner,
.str-chat__message--failed .str-chat__message-text-inner,
.str-chat__message-simple--error .str-chat__message-text-inner,
.str-chat__message-simple--failed .str-chat__message-text-inner {
  background: rgba(208, 2, 27, 0.1);
  border: 1px solid rgba(208, 2, 27, 0.1);
}
.str-chat__message--me.str-chat__message--error,
.str-chat__message--me.str-chat__message--failed,
.str-chat__message-simple--me.str-chat__message--error,
.str-chat__message-simple--me.str-chat__message--failed {
  border-left: initial;
  margin-right: 42px;
}
.str-chat__message .str-chat__message-attachment-file--item:hover,
.str-chat__message-simple .str-chat__message-attachment-file--item:hover {
  background: transparent;
}
.messaging.str-chat .str-chat {
  /* __li*/
}
.messaging.str-chat .str-chat__message,
.messaging.str-chat .str-chat__message--me {
  margin: 1px 0;
}
.messaging.str-chat .str-chat__message--with-reactions,
.messaging.str-chat .str-chat__message--me--with-reactions {
  margin-top: 30px;
}
.messaging.str-chat .str-chat__message-attachment--image {
  margin: 1px 0;
  max-width: 480px;
}
.messaging.str-chat .str-chat__message-attachment--card {
  margin: 1px 0;
  line-height: normal;
}
.messaging.str-chat .str-chat__message-attachment-card {
  margin: 1px auto;
  line-height: normal;
}
.messaging.str-chat .str-chat__message-attachment-card--title {
  color: #006cff;
}
.messaging.str-chat .str-chat__message-attachment-card--text {
  display: none;
}
.messaging.str-chat .str-chat__message-attachment-card--url {
  text-transform: lowercase;
}
.messaging.str-chat .str-chat__message--deleted {
  margin: 0 42px;
}
.messaging.str-chat .str-chat__li--middle .str-chat__message .str-chat__message-attachment--card,
.messaging.str-chat .str-chat__li--middle .str-chat__message .str-chat__message-attachment--image {
  border-top-left-radius: 2px;
}
.str-chat__message-simple {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
.str-chat__message-simple__actions {
  display: flex;
  margin-top: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 90px;
}
.str-chat__message-simple__actions__action {
  margin: 5px;
  display: flex;
  align-items: center;
  height: 10px;
  cursor: pointer;
}
.str-chat__message-simple__actions__action svg {
  fill: #000;
  opacity: 0.5;
}
.str-chat__message-simple__actions__action:hover svg {
  opacity: 1;
}
.str-chat__message-simple__actions__action--thread,
.str-chat__message-simple__actions__action--reactions {
  display: none;
}
.str-chat__message-simple__actions__action--options {
  position: relative;
  display: none;
}
.str-chat__message-simple.str-chat__message--with-reactions .str-chat__message-simple__actions__action--reactions {
  display: flex;
}
.str-chat__message-simple:hover .str-chat__message-simple__actions__action--thread {
  display: flex;
}
.str-chat__message-simple:hover .str-chat__message-simple__actions__action--reactions {
  display: flex;
}
.str-chat__message-simple-text {
  display: flex;
  justify-content: flex-end;
  padding: 0 0 0 0;
  position: relative;
}
.str-chat__message-simple-text-inner {
  text-align: left;
  max-width: 460px;
}
.str-chat__message-simple-text-inner.str-chat__message-simple-text-inner--is-emoji {
  margin: 5px 0;
  background: transparent;
}
.str-chat__message-simple-text-inner.str-chat__message-simple-text-inner--is-emoji p {
  line-height: 48px;
}
.str-chat__message-simple-text-inner p {
  text-align: left;
}
.str-chat__message-simple-text-inner a {
  color: #006cff;
  font-weight: 700;
  text-decoration: none;
}
.str-chat__message-simple-text-inner blockquote {
  margin: 0 0 0 5px;
  font-style: italic;
  padding-left: 20px;
  position: relative;
}
.str-chat__message-simple-text-inner blockquote::before {
  font-size: 25px;
  content: '\\201C';
  font-style: italic;
  position: absolute;
  opacity: 0.5;
  top: 2px;
  left: -5px;
}
.str-chat__message-simple--me .str-chat__message-simple-reply-button {
  display: flex;
  justify-content: flex-end;
}
.str-chat__message-simple--me .str-chat__message-simple-reply-button .str-chat__message-replies-count-button {
  display: flex;
  flex-direction: row-reverse;
}
.str-chat__message-simple--me .str-chat__message-simple-reply-button .str-chat__message-replies-count-button svg {
  transform: scaleX(-1);
  margin-left: 5px;
  margin-bottom: 4px;
  margin-right: 0;
}
.str-chat__message-simple--me .str-chat__message-simple__actions {
  justify-content: flex-end;
}
.str-chat__message-simple--me .str-chat__message-attachment--image {
  max-width: 460px;
}
.str-chat__message-simple--me-text-inner--is-emoji {
  background-color: transparent;
  line-height: 32px;
}
.str-chat__message-simple--me .str-chat__message-simple__actions {
  order: -1;
}
.str-chat__message-simple:hover .str-chat__message-simple__actions__action--options {
  display: flex;
}
.str-chat__message-simple:hover .str-chat__message-simple__actions__action--reactions {
  display: flex;
}
.str-chat__message-simple:hover .str-chat__message-simple__actions__action--thread {
  display: flex;
}
.str-chat__simple-message--error-message {
  text-align: left;
  text-transform: uppercase;
  font-size: 11px;
  opacity: 0.5;
}
.str-chat__message-simple-status {
  margin: 10px 0px 10px 10px;
  order: 3;
  position: absolute;
  left: 100%;
  bottom: 0;
  line-height: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1;
}
.str-chat__message-simple-status-number {
  font-size: 10px;
  margin-left: 4px;
  position: absolute;
  left: 100%;
  color: rgba(0, 0, 0, 0.6);
}
.str-chat__message-simple-status > .str-chat__avatar {
  align-self: flex-end;
  margin-right: 0;
}
.str-chat__message-simple-status > .str-chat__tooltip {
  display: none;
  max-width: 300px;
  min-width: 100px;
  text-align: center;
}
.str-chat__message-simple-status:hover > .str-chat__tooltip {
  display: block;
}
.str-chat__message-simple-status::after {
  position: absolute;
  bottom: 100%;
  right: 0;
  content: ' ';
  width: 15px;
  height: 15px;
}
.str-chat__message-simple .str-chat__message-attachment-card {
  margin: 0;
  border-radius: 4px 16px 4px 4px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
}
.str-chat__message-simple .str-chat__message-attachment-card--content {
  background: #ebebeb;
}
.str-chat__message-simple .str-chat__message-attachment-card--text {
  display: none;
}
.str-chat__message-simple .str-chat__message-attachment--file {
  margin: 0;
  background: white;
  border-color: transparent;
  border: 1px solid #ebebeb;
  border-radius: 0;
}
.str-chat__message-simple .str-chat__message-attachment--file .str-chat__message-attachment-file--item {
  border-color: transparent;
  padding: 0 10px;
}
.str-chat__message-simple .str-chat__message-attachment--file:first-of-type {
  border-radius: 16px 16px 0 0;
  border-bottom: transparent;
}
.str-chat__message-simple .str-chat__message-attachment--file:last-of-type {
  border-top-color: transparent;
  border-radius: 0 0 16px 2px;
}
.str-chat__message-simple .str-chat__message-attachment--file:last-of-type:first-of-type {
  border-bottom: 1px solid #ebebeb;
  border-top: 1px solid #ebebeb;
  border-radius: 16px 16px 16px 2px;
}
.str-chat__message-simple .str-chat__message-attachment-file--item {
  border-radius: 0;
}
.str-chat__message-simple--me .str-chat__message-attachment-card {
  border-radius: 16px 4px 4px 4px;
}
.str-chat__message-simple--me .str-chat__message-attachment--file {
  background: #ebebeb;
}
.str-chat__message-simple--me .str-chat__message-attachment--file:last-of-type {
  border-radius: 0 0 2px 16px;
}
.str-chat__message-simple--me .str-chat__message-attachment--file:last-of-type:first-of-type {
  border-radius: 16px 16px 2px 16px;
}
.str-chat__list--thread .str-chat__message-simple__actions {
  width: 30px;
}
.str-chat__list--thread .str-chat__message-simple__actions__action--options .str-chat__message-actions-box {
  right: unset;
  left: 100%;
  border-radius: 16px 16px 16px 2px;
}
.livestream.str-chat .str-chat__li--single {
  margin: 0px 0;
}
@media screen and (max-width: 960px) {
  .str-chat__message-simple-text-inner {
    max-width: 218px;
  }
  .str-chat__message-simple-status {
    left: unset;
    right: 8px;
    bottom: 30px;
  }
}
.dark.str-chat .str-chat__message-simple-text-inner {
  background: rgba(255, 255, 255, 0.05);
  color: white;
}
.dark.str-chat .str-chat__message-simple-text-inner--is-emoji {
  background: transparent;
}
.dark.str-chat .str-chat__message-simple__actions svg {
  fill: white;
}
.dark.str-chat .str-chat__message-simple-data {
  color: white;
  opacity: 0.5;
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment-card {
  background: transparent;
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment-card--content {
  background: rgba(255, 255, 255, 0.05);
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment-card--url {
  color: rgba(255, 255, 255, 0.5);
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file {
  border-color: transparent;
  background: rgba(255, 255, 255, 0.05);
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file a,
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file span {
  color: white;
}
.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file span {
  opacity: 0.5;
}
.dark.str-chat .str-chat__message-simple .str-chat__message-simple-status-number {
  color: rgba(255, 255, 255, 0.6);
}
.dark.str-chat .str-chat__message-simple--me .str-chat__message-simple-text-inner {
  background: rgba(0, 0, 0, 0.2);
}
.dark.str-chat .str-chat__message-simple--me .str-chat__message-simple-text-inner--is-emoji {
  background: transparent;
}
.dark.str-chat .str-chat__message-simple--me .str-chat__message-simple .str-chat__message-attachment-card--content {
  background: rgba(0, 0, 0, 0.2);
}
.dark.str-chat .str-chat__message-simple--me .str-chat__message-simple .str-chat__message-attachment--file {
  background: rgba(0, 0, 0, 0.2);
}
.dark.str-chat .str-chat__message-simple__actions__action--options .str-chat__actions-box {
  background: #67686a;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08), 0 1px 8px 0 rgba(0, 0, 0, 0.05);
}
.dark.str-chat .str-chat__message--error .str-chat__message-simple-text-inner,
.dark.str-chat .str-chat__message--failed .str-chat__message-simple-text-inner {
  background: rgba(208, 2, 27, 0.1);
  border: 1px solid rgba(208, 2, 27, 0.1);
}
.str-chat__message .str-chat__message-simple__actions__action--options .str-chat__message-actions-box {
  left: 100%;
  right: unset;
}
.str-chat__message .str-chat__message-simple__actions__action--options .str-chat__message-actions-box--reverse {
  right: 100%;
  left: unset;
  border-radius: 16px 16px 2px 16px;
}
.str-chat__message .str-chat__message-simple__actions__action--options .str-chat__message-actions-box--mine {
  right: 100%;
  left: unset;
  border-radius: 16px 16px 2px 16px;
}
.str-chat__message .str-chat__message-simple__actions__action--options .str-chat__message-actions-box--mine.str-chat__message-actions-box--reverse {
  left: 100%;
  right: unset;
  border-radius: 16px 16px 16px 2px;
}
.str-chat__message a[href^='mailto:'] {
  -webkit-hyphens: none;
  -moz-hyphens: none;
  hyphens: none;
}
@media screen and (max-width: 375px) {
  .str-chat__message .str-chat__message-attachment--img {
    max-width: 235px;
  }
}
@media screen and (max-width: 414px) {
  .str-chat__message .str-chat__message-attachment--img {
    max-width: 274px;
  }
}
@media only screen and (device-width: 375px) and (-webkit-device-pixel-ratio: 3) {
  .str-chat__message .str-chat__message-attachment--img {
    max-width: 240px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chats/Chat/stream-style.less"],"names":[],"mappings":"AAAA,UAAU;AACV,WAAW;AACX,kBAAkB;AAClB;EACE,sBAAA;AACF;AACA;;;EAGE,mBAAA;AACF;AAKA;EACE,WAAA;AAHF;AAMA;EACE,aAAA;EACA,2DAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,SAAA;EACA,cAAA;AAJF;AAMA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAJF;AAMA;EACE,WAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAJF;AAOA;EACE,+BAAA;EACA,2DAAA;AALF;AAQA;;EAEE,yBAAA;AANF;AAQA;;EAEE,yBAAA;AANF;AAQA;EACE,mBAAA;AANF;AAQA;EACE,mBAAA;AANF;AASA;EACE,WAAA;AAPF;AAUA;EACE,aAAA;AARF;AAWA;EACE,iBAAA;AATF;AAWA;EACE,YAAA;EACA,aAAA;AATF;AAWA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AATF;AAWA;EACE,wBAAA;AATF;AAWA;EACE;IACE,kBAAA;EATF;AACF;AAWA;EACE,aAAA;AATF;AAWA;EACE,WAAA;AATF;AAWA;EACE,qCAAA;AATF;AAWA;EACE,iCAAA;EACA,4CAAA;AATF;AAYA;EACE,mBAAA;EACA,eAAA;AAVF;AAaA;EACE,mBAAA;EACA,YAAA;AAXF;AAcA;EACE,mBAAA;EACA,YAAA;AAZF;AAeA;EACE,WAAA;AAbF;AACA,UAAU;AACV,WAAW;AACX,kBAAkB;AAgBlB;EACE,gBAAA;EACA,kGAAA;EAKA,yGAAA;EAEA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAnBF;AAqBA;EACE,QAAA;EACA,qBAAA;AAnBF;AAqBA;EACE,OAAA;EACA,qBAAA;AAnBF;AAqBA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAnBF;AAqBA;EACE,yCAAA;AAnBF;AAqBA;EACE,cAAA;AAnBF;AAsBA;EACE,mBAAA;EACA,kGAAA;EAKA,yGAAA;AAxBF;AA2BA;EACE,YAAA;AAzBF;AA2BA;EACE,cAAA;AAzBF;AA4BA;;EAEE,iDAAA;EACA,8BAAA;EACA,sBAAA;AA1BF;AA6BA;EACE,cAAA;AA3BF;AA8BA;EACE,cAAA;AA5BF;AA+BA;EACE,cAAA;AA7BF;AAgCA;EACE,cAAA;AA9BF;AAiCA;EACE,cAAA;AA/BF;AAkCA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAhCF;AAmCA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAjCF;AAoCA;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;AAlCF;AAqCA;EACE,yBAAA;AAnCF;AAsCA;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AApCF;AAuCA;EACE,mBAAA;AArCF;AAwCA;EACE,mBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtCF;AAyCA;EACE,eAAA;AAvCF;AA0CA;EACE,YAAA;AAxCF;AA2CA;EACE,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAzCF;AA4CA;EACE,qBAAA;AA1CF;AA6CA;EACE,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;AA3CF;AA8CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;AA5CF;AA+CA;EACE,kBAAA;EACA,cAAA;AA7CF;AAgDA;EACE,mBAAA;AA9CF;AAiDA;;EAEE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA/CF;AAkDA;EACE,qBAAA;EACA,mBAAA;AAhDF;AAmDA;EACE,eAAA;AAjDF;AAoDA;EACE,aAAA;AAlDF;AAqDA;EACE,aAAA;AAnDF;AAsDA;EACE,eAAA;AApDF;AAuDA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AArDF;AAwDA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;AAtDF;AAyDA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAvDF;AA0DA;EACE,aAAA;AAxDF;AA2DA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AAzDF;AA4DA;EACE,mCAAA;EACA,cAAA;AA1DF;AA6DA;EACE,iCAAA;EACA,cAAA;AA3DF;AA8DA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AA5DF;AA+DA;EACE,aAAA;AA7DF;AAgEA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;AA9DF;AAiEA;;EAEE,oBAAA;EACA,oBAAA;EACA,aAAA;AA/DF;AAkEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;AAhEF;AAmEA;EACE,sGAAA;EAOA,sEAAA;AAvEF;AA0EA;EACE,kBAAA;AAxEF;AA2EA;EACE,kBAAA;EACA,WAAA;AAzEF;AA4EA;EACE,WAAA;AA1EF;AA6EA;EACE,eAAA;AA3EF;AA8EA;EACE,aAAA;AA5EF;AA+EA;EACE,aAAA;AA7EF;AAgFA;EACE,eAAA;AA9EF;AAiFA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AA/EF;AAkFA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AAhFF;AAmFA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gEAAA;EACA,wDAAA;AAjFF;AAoFA;EACE,+BAAA;EACA,uBAAA;AAlFF;AAqFA;EACE,+BAAA;EACA,uBAAA;AAnFF;AAsFA;EACE;;;IAGE,2BAAA;IACA,mBAAA;EApFF;EAsFA;IACE,2BAAA;IACA,mBAAA;EApFF;AACF;AAuFA;EACE;;;IAGE,2BAAA;IACA,mBAAA;EArFF;EAuFA;IACE,2BAAA;IACA,mBAAA;EArFF;AACF;AAwFA;EACE;IACE,gCAAA;IACA,wBAAA;EAtFF;AACF;AAyFA;EACE;IACE,gCAAA;IACA,wBAAA;EAvFF;AACF;AA0FA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,uCAAA;AAxFF;AA2FA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzFF;AA4FA;EACE,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AA1FF;AA6FA;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AA3FF;AA8FA;EACE,oBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AA5FF;AA+FA;EACE,mBAAA;AA7FF;AAgGA;EACE,gBAAA;AA9FF;AAiGA;EACE,kBAAA;EACA,mBAAA;EA/FA,qCAAqC;AACvC;AAiGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AA/FF;AACA,kCAAkC;AAkGlC;EACE,+BAAA;EACA,gBAAA;AAhGF;AAmGA;EACE,+BAAA;EACA,gBAAA;AAjGF;AAoGA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;AAlGF;AAqGA;EACE,eAAA;EACA,sBAAA;AAnGF;AAsGA;EACE,gBAAA;AApGF;AAuGA;EACE,gBAAA;AArGF;AAuGA;EACE,uBAAA;AArGF;AAuGA;EACE,YAAA;AArGF;AAuGA;EACE,YAAA;AArGF;AAuGA;EACE,WAAA;AArGF;AAuGA;EArGE,+BAA+B;EAC/B,wBAAwB;EAuGxB,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,WAAA;EACA,iBAAA;AArGF;AAuGA;EACE,mBAAA;AArGF;AAuGA;;EAEE,kBAAA;AArGF;AAuGA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArGF;AAuGA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AArGF;AAuGA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AArGF;AAuGA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AArGF;AAuGA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AArGF;AAuGA;EACE,uBAAA;AArGF;AAuGA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AArGF;AAuGA;EACE,uBAAA;AArGF;AAuGA;EACE,aAAA;AArGF;AAuGA;EACE,0BAAA;AArGF;AAuGA;EACE,YAAA;AArGF;AAuGA;EACE,gBAAA;AArGF;AAwGA;EACE,YAAA;EACA,WAAA;AAtGF;AAyGA;EAGE,iBAAA;AAzGF;AA4GA;EAEE,eAAA;AA3GF;AA6GA;EAGE,iBAAA;AA7GF;AA+GA;EAGE,qCAAA;AA/GF;AAkHA;;EAEE,YAAA;AAhHF;AAmHA;EACE,uBAAA;AAjHF;AAoHA;EACE,WAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;AAlHF;AAqHA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;EACA,aAAA;AAnHF;AAqHA;EACE,yBAAA;EACA,6CAAA;AAnHF;AAqHA;EACE,yBAAA;EACA,YAAA;AAnHF;AAqHA;EACE,qCAAA;AAnHF;AAsHA;EACE,YAAA;AApHF;AAsHA;EACE,sCAAA;AApHF;AAuHA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;AArHF;AAuHA;EACE,WAAA;EACA,aAAA;AArHF;AAuHA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AArHF;AAuHA;EACE,gBAAA;EACA,OAAA;AArHF;AAuHA;EACE,cAAA;AArHF;AAuHA;;EAEE,gBAAA;EACA,uBAAA;AArHF;AAuHA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AArHF;AAuHA;EACE,aAAA;AArHF;AAuHA;EACE,qBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AArHF;AAuHA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AArHF;AAuHA;EAEE,aAAA;AAtHF;AAyHA;EACE,gBAAA;EACA,WAAA;AAvHF;AA0HA;EACE,+BAAA;EACA,6BAAA;EACA,+BAAA;AAxHF;AA2HA;EACE,oBAAA;AAzHF;AA4HA;EACE,yBAAA;EACA,0BAAA;EACA,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AA1HF;AA4HA;EACE,kBAAA;AA1HF;AA4HA;EACE,kBAAA;AA1HF;AA4HA;EACE,gBAAA;AA1HF;AA4HA;;EAEE,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA1HF;AA4HA;EACE,sBAAA;AA1HF;AA4HA;EACE,yBAAA;AA1HF;AA6HA;EACE,QAAA;EACA,SAAA;EACA,iBAAA;AA3HF;AA8HA;;EAEE,kBAAA;AA5HF;AA+HA;EACE,aAAA;EACA,aAAA;EACA,4CAAA;AA7HF;AA+HA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,2DAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;AA7HF;AA+HA;EACE,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AA7HF;AA+HA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2DAAA;EACA,gBAAA;EA7HA,+CAA+C;EA+H/C,2CAAA;AA7HF;AA+HA;EACE,eAAA;EACA,OAAA;AA7HF;AA+HA;EACE,gBAAA;EACA,SAAA;AA7HF;AA+HA;EACE,gBAAA;EACA,SAAA;AA7HF;AA+HA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;EACA,qBAAA;EACA,4BAAA;AA7HF;AA+HA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AA7HF;AAgIA;EACE;IACE,YAAA;EA9HF;EAgIA;IACE,UAAA;EA9HF;EAgIA;IACE,YAAA;EA9HF;AACF;AAgIA;EACE,aAAA;EACA,cAAA;AA9HF;AAgIA;EACE,kBAAA;AA9HF;AAiIA;EACE,kBAAA;AA/HF;AAkIA;EACE,gBAAA;AAhIF;AAmIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAjIF;AAoIA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;AAlIF;AAqIA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnIF;AAqIA;EACE,wBAAA;AAnIF;AAqIA;EACE,oCAAA;AAnIF;AAsIA;EACE,qCAAA;EACA,yCAAA;EACA,kBAAA;AApIF;AAsIA;EACE,8BAAA;AApIF;AAuIA;EACE,kBAAA;EACA,UAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,0EAAA;AArIF;AAwIA;EACE;IACE,kBAAA;IACA,mBAAA;EAtIF;AACF;AAyIA;EACE,kCAAA;EACA,0EAAA;EACA,4BAAA;EACA,YAAA;AAvIF;AA0IA;EACE,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,0CAAA;AAxIF;AA2IA;EACE,qCAAA;EACA,2CAAA;AAzIF;AA2IA;;EAEE,YAAA;AAzIF;AA2IA;EACE,eAAA;AAzIF;AA4IA;EACE,qCAAA;EACA,0EAAA;EACA,4BAAA;EACA,aAAA;AA1IF;AA4IA;EACE,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AA1IF;AA4IA;EACE,aAAA;EACA,eAAA;AA1IF;AA4IA;EACE,aAAA;AA1IF;AA4IA;EACE,aAAA;AA1IF;AA6IA;EACE,kCAAA;EACA,0EAAA;EACA,4BAAA;EACA,YAAA;AA3IF;AA8IA;EACE,iCAAA;EACA,2CAAA;AA5IF;AA8IA;EACE,YAAA;AA5IF;AA8IA;EACE,eAAA;AA5IF;AA8IA;EACE,eAAA;AA5IF;AA+IA;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;AA7IF;AA+IA;EACE,mBAAA;AA7IF;AA+IA;EACE;IACE,aAAA;EA7IF;AACF;AAgJA;EACE,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA9IF;AAiJA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA/IF;AAkJA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAhJF;AAkJA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAhJF;AAkJA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAhJF;AAkJA;EACE,+BAAA;AAhJF;AAkJA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAhJF;AAmJA;EACE,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;AAjJF;AAmJA;EACE,SAAA;EACA,UAAA;EACA,cAAA;AAjJF;AAmJA;EACE,SAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;AAjJF;AAmJA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;AAjJF;AAmJA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;AAjJF;AAoJA;EACE,mBAAA;EACA,YAAA;AAlJF;AAqJA;EACE,oCAAA;AAnJF;AAsJA;EApJE,uBAAuB;EAsJvB,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AApJF;AAsJA;EACE,OAAA;AApJF;AAsJA;EACE,iBAAA;EACA,4CAAA;AApJF;AAuJA;EACE,gBAAA;EACA,4EAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,6BAAA;AArJF;AAuJA;;EAEE,aAAA;EACA,6GAAA;EAEA,yBAAA;AAtJF;AAwJA;EACE,aAAA;AAtJF;AAwJA;EACE,oBAAA;AAtJF;AAyJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;AAvJF;AA0JA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;EACA,YAAA;EACA,2CAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAxJF;AA0JA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAxJF;AA2JA;EACE;IACE,aAAA;EAzJF;EA2JA;;;IAGE,eAAA;IACA,YAAA;IACA,MAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;IACA,0EAAA;IACA,kCAAA;EAzJF;EA2JA;;;IAGE,SAAA;EAzJF;AACF;AA4JA;EACE,UAAA;AA1JF;AA4JA;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;AA1JF;AA6JA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;AA3JF;AA8JA;EACE,2DAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AA5JF;AA8JA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AA5JF;AA8JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA5JF;AA8JA;EACE,cAAA;AA5JF;AA8JA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5JF;AA8JA;;EAEE,gBAAA;EACA,YAAA;EACA,YAAA;AA5JF;AA8JA;EACE,gBAAA;EACA,mBAAA;AA5JF;AA8JA;EACE,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AA5JF;AA8JA;EACE,gBAAA;EACA,0BAAA;AA5JF;AA8JA;EACE,kBAAA;EACA,mBAAA;AA5JF;AA8JA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AA5JF;AA8JA;EACE,mBAAA;AA5JF;AA8JA;EACE,mBAAA;AA5JF;AA8JA;EACE,mBAAA;AA5JF;AA8JA;EACE,WAAA;AA5JF;AA8JA;EACE,OAAA;EACA,iBAAA;AA5JF;AA8JA;EACE,SAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AA5JF;AA+JA;EACE,mBAAA;AA7JF;AA+JA;EACE,gBAAA;EACA,gBAAA;AA7JF;AA+JA;EACE,gBAAA;AA7JF;AAgKA;EACE,mBAAA;AA9JF;AAgKA;EACE,YAAA;AA9JF;AAgKA;EACE,8BAAA;AA9JF;AAgKA;EACE,gBAAA;AA9JF;AAiKA;EACE,aAAA;EACA,YAAA;AA/JF;AAiKA;EACE,OAAA;EACA,aAAA;AA/JF;AAkKA;EACE,gCAAA;AAhKF;AAmKA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAjKF;AAmKA;EACE,OAAA;EACA,+BAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAjKF;AAmKA;EACE,WAAA;AAjKF;AAmKA;EACE,iBAAA;EACA,yBAAA;EACA,6CAAA;AAjKF;AAmKA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,4EAAA;EACA,eAAA;EACA,UAAA;AAjKF;AAmKA;EACE,iBAAA;EACA,yBAAA;EACA,6CAAA;AAjKF;AAmKA;EACE,aAAA;EACA,0BAAA;AAjKF;AAoKA;EACE,qCAAA;EACA,YAAA;AAlKF;AAqKA;EACE,mBAAA;AAnKF;AAqKA;EACE,WAAA;AAnKF;AAsKA;EACE,aAAA;EACA,gBAAA;AApKF;AAsKA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;AApKF;AAsKA;EACE,eAAA;EACA,eAAA;AApKF;AAuKA;EACE,aAAA;EACA,iBAAA;AArKF;AAuKA;EACE,kBAAA;EACA,yBAAA;EACA,eAAA;AArKF;AAuKA;EACE,eAAA;EACA,eAAA;AArKF;AAwKA;;EAEE,aAAA;AAtKF;AAyKA;EACE,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAvKF;AAyKA;EACE,iBAAA;EACA,4EAAA;AAvKF;AA0KA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAxKF;AA2KA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAzKF;AA4KA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AA1KF;AA6KA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA3KF;AA8KA;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AA5KF;AA+KA;EACE,mBAAA;EACA,YAAA;AA7KF;AA+KA;EACE,YAAA;AA7KF;AA+KA;EAGE,gCAAA;AA/KF;AAkLA;EACE,kBAAA;AAhLF;AAkLA;EAGE,gBAAA;EACA,YAAA;AAlLF;AAqLA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;AAnLF;AAsLA;EACE,2DAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,4CAAA;EACA,gBAAA;EACA,UAAA;AApLF;AAsLA;EACE,iBAAA;EACA,4EAAA;AApLF;AAsLA;EACE,WAAA;EACA,YAAA;AApLF;AAsLA;EACE,OAAA;EACA,iBAAA;AApLF;AAsLA;EACE,gBAAA;AApLF;AAuLA;EACE,YAAA;EACA,mBAAA;AArLF;AAwLA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;EACA,aAAA;AAtLF;AAwLA;EACE,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AAtLF;AAwLA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAtLF;AAwLA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAtLF;AAwLA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAtLF;AAwLA;EAEE,UAAA;EACA,gBAAA;AAvLF;AA0LA;EACE,mBAAA;AAxLF;AA2LA;EACE,YAAA;AAzLF;AA4LA;EACE,mBAAA;EACA,4EAAA;AA1LF;AA6LA;EACE,qCAAA;EACA,2CAAA;AA3LF;AA8LA;EACE,+BAAA;AA5LF;AA+LA;EACE,YAAA;AA7LF;AAgMA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AA9LF;AAgMA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,2DAAA;AA9LF;AAgMA;EACE,OAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AA9LF;AAgMA;EACE,kBAAA;AA9LF;AAiMA;EACE,cAAA;AA/LF;AAkMA;EACE,0CAAA;AAhMF;AAmMA;EACE,+BAAA;AAjMF;AAoMA;EACE,oCAAA;AAlMF;AAqMA;EACE,WAAA;AAnMF;AAqMA;EACE,kBAAA;EACA,WAAA;AAnMF;AAqMA;EACE,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EAnMA,uBAAuB;AACzB;AAqMA;EACE,sEAAA;EACA,UAAA;AAnMF;AAqMA;EACE,gBAAA;EACA,YAAA;EAnMA,0BAA0B;EAqM1B,gBAAA;EACA,yBAAA;AAnMF;AAqMA;EACE,cAAA;AAnMF;AAqMA;EACE,WAAA;AAnMF;AAqMA;;;EAGE,eAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAnMF;AAqMA;;;EAGE,WAAA;EACA,YAAA;AAnMF;AAqMA;;;EAGE,UAAA;AAnMF;AAsMA;EACE,aAAA;AApMF;AAuMA;;EAEE,WAAA;AArMF;AAwMA;EACE,+BAAA;AAtMF;AAwMA;EACE,cAAA;AAtMF;AAyMA;EACE,qCAAA;EACA,yCAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AAvMF;AAyMA;EACE,mCAAA;EACA,yCAAA;EACA,kBAAA;AAvMF;AA0MA;EACE,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAxMF;AA0MA;EAxME,eAAe;EA0Mf,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAxMF;AA0MA;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAxMF;AA0MA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AAxMF;AA0MA;EACE,gBAAA;AAxMF;AA0MA;EACE,eAAA;AAxMF;AA2MA;;;;EAIE,aAAA;AAzMF;AA2MA;;;;EAIE,YAAA;EACA,aAAA;AAzMF;AA2MA;;;;EAIE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;AAzMF;AA2MA;;;;EAIE,kBAAA;EACA,UAAA;AAzMF;AA2MA;;;;EAIE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;AAzMF;AA4MA;EACE,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AA1MF;AA4MA;;EAEE,WAAA;EACA,YAAA;AA1MF;AA6MA;EACE,iCAAA;AA3MF;AA8MA;EACE,iCAAA;AA5MF;AA+MA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA7MF;AAgNA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA9MF;AAgNA;EACE,OAAA;AA9MF;AAgNA;;;EAGE,mEAAA;AA9MF;AAgNA;;EAEE,kBAAA;EACA,YAAA;AA9MF;AAgNA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AA9MF;AAgNA;EACE,UAAA;EACA,kBAAA;AA9MF;AAgNA;EACE,UAAA;AA9MF;AAgNA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kDAAA;AA9MF;AAgNA;EACE,sDAAA;AA9MF;AAgNA;EACE,uDAAA;AA9MF;AAiNA;EACE;IACE,YAAA;EA/MF;EAiNA;IACE,UAAA;EA/MF;AACF;AAkNA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,eAAA;AAhNF;AAmNA;EACE,SAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAjNF;AAoNA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AAlNF;AAqNA;EACE;IACE,+BAAA;IACA,0BAAA;IACA,uBAAA;EAnNF;EAqNA;IACE,iCAAA;IACA,4BAAA;IACA,yBAAA;EAnNF;AACF;AAsNA;EACE;IACE,2BAAA;IACA,4BAAA;IACA,+BAAA;IACA,0BAAA;IACA,uBAAA;EApNF;EAsNA;IACE,6BAAA;IACA,8BAAA;IACA,iCAAA;IACA,4BAAA;IACA,yBAAA;EApNF;AACF;AAuNA;EACE,gBAAA;EACA,4EAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,2DAAA;EACA,iBAAA;AArNF;AAuNA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AArNF;AAuNA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AArNF;AAuNA;EACE,cAAA;AArNF;AAuNA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AArNF;AAuNA;EACE,mBAAA;AArNF;AAuNA;;EAEE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;AArNF;AAuNA;;EAEE,WAAA;AArNF;AAuNA;EACE,WAAA;EACA,sBAAA;AArNF;AAuNA;EACE,WAAA;EACA,sBAAA;AArNF;AAuNA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AArNF;AAuNA;EACE,kBAAA;AArNF;AAuNA;EACE,kBAAA;AArNF;AAwNA;EACE,YAAA;EACA,OAAA;AAtNF;AAwNA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,YAAA;AAtNF;AAwNA;EACE,gBAAA;EACA,yBAAA;EACA,6CAAA;AAtNF;AAwNA;EACE,yBAAA;AAtNF;AAyNA;EACE,kBAAA;EACA,OAAA;EACA,wBAAA;EACA,kBAAA;EACA,qCAAA;EACA,wEAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAvNF;AAyNA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,0BAAA;AAvNF;AA0NA;EACE,mBAAA;EACA,wEAAA;EACA,0BAAA;AAxNF;AA0NA;EACE,mBAAA;EACA,2CAAA;EACA,2CAAA;EACA,YAAA;AAxNF;AA0NA;EACE,YAAA;AAxNF;AA2NA;EACE,YAAA;AAzNF;AA4NA;EACE,uBAAA;AA1NF;AA6NA;EACE,YAAA;AA3NF;AA8NA;EACE,eAAA;AA5NF;AA+NA;EACE,yBAAA;EACA,YAAA;AA7NF;AAgOA;EACE,0BAAA;AA9NF;AAiOA;EACE,aAAA;EACA,eAAA;AA/NF;AAkOA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAhOF;AAkOA;EACE,cAAA;AAhOF;AAkOA;EACE,eAAA;AAhOF;AAkOA;EACE,eAAA;AAhOF;AAmOA;EACE,kBAAA;EACA,eAAA;AAjOF;AAmOA;EACE,eAAA;AAjOF;AAoOA;EACE,kBAAA;EACA,aAAA;AAlOF;AAqOA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;AAnOF;AAsOA;EACE,kCAAA;EACA,cAAA;AApOF;AAuOA;EACE,gCAAA;EACA,cAAA;AArOF;AAwOA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAtOF;AAwOA;EACE,aAAA;AAtOF;AAyOA;EACE,aAAA;AAvOF;AA0OA;;EAEE,kBAAA;AAxOF;AA0OA;;EAEE,oBAAA;AAxOF;AA2OA;EACE,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,2CAAA;EACA,sBAAA;AAzOF;AA2OA;EACE,kBAAA;EACA,qCAAA;EACA,oCAAA;EACA,eAAA;EACA,aAAA;AAzOF;AA2OA;EACE,oBAAA;EACA,qCAAA;AAzOF;AA4OA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AA1OF;AA6OA;EACE,wBAAA;AA3OF;AA8OA;EACE,qCAAA;EACA,4CAAA;AA5OF;AA8OA;EACE,qCAAA;AA5OF;AA8OA;EACE,8BAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;AA5OF;AA8OA;EACE,WAAA;AA5OF;AA8OA;EACE,WAAA;AA5OF;AA+OA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AA7OF;AAgPA;EACE,cAAA;AA9OF;AAiPA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AA/OF;AAkPA;EACE,cAAA;AAhPF;AAmPA;EAGE,YAAA;EACA,WAAA;AAnPF;AAsPA;EAGE,YAAA;EACA,WAAA;AAtPF;AAyPA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAvPF;AAyPA;EACE,aAAA;EACA,eAAA;AAvPF;AAyPA;EACE,OAAA;AAvPF;AAyPA;EACE,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;AAvPF;AAyPA;EACE,YAAA;EACA,kBAAA;EACA,6BAAA;AAvPF;AAyPA;EACE,kBAAA;EACA,iBAAA;AAvPF;AAyPA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;AAvPF;AAyPA;EACE,UAAA;EACA,YAAA;AAvPF;AAyPA;EACE,UAAA;AAvPF;AAyPA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAvPF;AAyPA;EAGE,YAAA;EACA,WAAA;AAzPF;AA2PA;EAGE,YAAA;EACA,UAAA;EACA,YAAA;AA3PF;AA6PA;EAGE,SAAA;EACA,YAAA;AA7PF;AA+PA;EACE,kBAAA;EACA,kBAAA;AA7PF;AA+PA;EACE,WAAA;AA7PF;AA+PA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AA7PF;AA+PA;EACE,UAAA;EACA,YAAA;AA7PF;AA+PA;EACE,UAAA;AA7PF;AAgQA;EACE,cAAA;AA9PF;AAgQA;EACE,sBAAA;EACA,uBAAA;AA9PF;AAgQA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AA9PF;AAgQA;;EAEE,UAAA;AA9PF;AAgQA;;EAEE,YAAA;EACA,YAAA;EACA,WAAA;AA9PF;AAgQA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA9PF;AAiQA;EACE,kBAAA;EACA,uBAAA;AA/PF;AAkQA;EACE,qCAAA;AAhQF;AAkQA;EACE,qCAAA;EACA,mBAAA;EACA,YAAA;AAhQF;AAkQA;;EAEE,UAAA;AAhQF;AAmQA;EACE,gBAAA;AAjQF;AAoQA;EACE;IACE,kBAAA;EAlQF;AACF;AAqQA;EACE,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EAnQA,mCAAmC;EAqQnC,mBAAA;AAnQF;AAqQA;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAnQF;AAqQA;EACE,mBAAA;EACA,iBAAA;AAnQF;AAqQA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAnQF;AAsQA;EACE,cAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;AApQF;AAuQA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2DAAA;EACA,kBAAA;AArQF;AAuQA;EACE,gCAAA;EACA,sCAAA;EACA,YAAA;AArQF;AAuQA;EACE,iCAAA;EACA,uCAAA;EACA,WAAA;AArQF;AAwQA;EACE,iCAAA;EACA,uCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,2DAAA;EACA,kBAAA;AAtQF;AAyQA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;AAvQF;AA0QA;EACE,oBAAA;EACA,iBAAA;AAxQF;AA0QA;EACE,iBAAA;AAxQF;AA2QA;EACE;IACE,oBAAA;EAzQF;EA2QA;IACE,eAAA;EAzQF;AACF;AA4QA;EACE,qCAAA;AA1QF;AA4QA;EACE,qCAAA;AA1QF;AA6QA;EACE,kBAAA;AA3QF;AA8QA;EACE,oBAAA;AA5QF;AA8QA;EACE,kBAAA;EACA,mBAAA;AA5QF;AA+QA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AA7QF;AAgRA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA9QF;AAgRA;EACE,wBAAA;EACA,iBAAA;AA9QF;AAiRA;EACE,8BAAA;AA/QF;AAkRA;EACE,wBAAA;AAhRF;AAmRA;EACE,2DAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;AAjRF;AAmRA;EACE,WAAA;AAjRF;AAmRA;EACE,eAAA;AAjRF;AAmRA;EACE,OAAA;AAjRF;AAmRA;EACE,kBAAA;EACA,iBAAA;EACA,6BAAA;AAjRF;AAmRA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAjRF;AAmRA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAjRF;AAmRA;EACE,UAAA;AAjRF;AAmRA;EACE,SAAA;EACA,qBAAA;EAjRA,iDAAiD;EAmRjD,yBAAA;EACA,qBAAA;EACA,yBAAA;EAjRA,uCAAuC;EAmRvC,sBAAA;EAjRA,iEAAiE;EAmRjE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;AAjRF;AAmRA;EACE,gBAAA;AAjRF;AAmRA;EACE,0CAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;AAjRF;AAmRA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;AAjRF;AAmRA;;EAEE,iOAAA;EAIA,oBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AApRF;AAsRA;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,wCAAA;AApRF;AAsRA;EACE,cAAA;EACA,qBAAA;AApRF;AAsRA;EACE,aAAA;AApRF;AAsRA;EACE,oCAAA;EACA,qCAAA;EACA,2CAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EApRA,sBAAsB;EAsRtB,mBAAA;EACA,8BAAA;AApRF;AAsRA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AApRF;AAsRA;EACE,+BAAA;AApRF;AAsRA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AApRF;AAsRA;EACE,UAAA;EACA,YAAA;AApRF;AAsRA;EACE,UAAA;AApRF;AAsRA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;AApRF;AAsRA;EACE,mBAAA;AApRF;AAsRA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,OAAA;EACA,cAAA;AApRF;AAsRA;EACE,eAAA;EACA,iBAAA;AApRF;AAsRA;EACE,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AApRF;AAsRA;EACE,iBAAA;AApRF;AAsRA;EACE,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kBAAA;AApRF;AAsRA;EACE,gBAAA;AApRF;AAsRA;EACE,SAAA;EACA,gBAAA;EACA,oCAAA;EACA,qCAAA;AApRF;AAsRA;EACE,oCAAA;AApRF;AAsRA;EACE,aAAA;AApRF;AAsRA;EACE,yBAAA;AApRF;AAsRA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AApRF;AAsRA;;EAEE,UAAA;AApRF;AAsRA;;EAQE,kBAAA;EACA,QAAA;EACA,iBAAA;AA1RF;AA4RA;EACE,eAAA;AA1RF;AA4RA;EACE,mBAAA;EACA,WAAA;AA1RF;AA6RA;EACE,eAAA;AA3RF;AA8RA;EACE,YAAA;EACA,gBAAA;AA5RF;AA8RA;EAGE,YAAA;EACA,eAAA;EACA,aAAA;AA9RF;AAiSA;EACE,cAAA;AA/RF;AAiSA;EACE,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,kBAAA;AA/RF;AAiSA;EAGE,8BAAA;EACA,2CAAA;AAjSF;AAmSA;EAGE,8BAAA;AAnSF;AAqSA;EAGE,gCAAA;AArSF;AAwSA;EACE,mBAAA;EACA,2CAAA;EACA,2CAAA;AAtSF;AAwSA;EAGE,uCAAA;AAxSF;AA0SA;EACE,UAAA;AAxSF;AA2SA;EACE,WAAA;EACA,YAAA;AAzSF;AA4SA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,kGAAA;EAKA,yGAAA;EAEA,YAAA;AA/SF;AAkTA;EACE,cAAA;AAhTF;AAmTA;EACE,YAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAjTF;AAoTA;EACE,iBAAA;EACA,WAAA;EACA,SAAA;AAlTF;AAqTA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;AAnTF;AAsTA;EACE,cAAA;AApTF;AAuTA;EACE,4CAAA;AArTF;AAwTA;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;AAtTF;AAyTA;EACE,QAAA;AAvTF;AA0TA;EACE,SAAA;AAxTF;AA2TA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAzTF;AA4TA;;EAEE,UAAA;EACA,kBAAA;AA1TF;AA6TA;;EAEE,aAAA;AA3TF;AA8TA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,wFAAA;EAKA,mBAAA;EACA,aAAA;EACA,YAAA;AAhUF;AAmUA;EACE,mBAAA;AAjUF;AAoUA;EACE,QAAA;EACA,UAAA;EACA,wlBAAA;EACA,kBAAA;EACA,WAAA;AAlUF;AAqUA;EACE,iBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnUF;AAqUA;EACE,aAAA;AAnUF;AAqUA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAnUF;AAqUA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAnUF;AAqUA;EACE,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;AAnUF;AAqUA;EACE,aAAA;AAnUF;AAqUA;EACE,gBAAA;AAnUF;AAqUA;;EAEE,kBAAA;EACA,UAAA;EACA,YAAA;AAnUF;AAsUA;EACE,uBAAA;EACA,iBAAA;AApUF;AAuUA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,2DAAA;EACA,eAAA;EACA,4CAAA;AArUF;AAuUA;EACE,OAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AArUF;AAwUA;EACE,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;AAtUF;AAwUA;EACE,eAAA;EACA,iBAAA;AAtUF;AAwUA;EACE,eAAA;EACA,2DAAA;EACA,OAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAtUF;AAwUA;EACE,iBAAA;EACA,4EAAA;AAtUF;AAyUA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAvUF;AA0UA;EACE,iBAAA;EACA,eAAA;AAxUF;AA2UA;;EAEE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;AAzUF;AA2UA;;EAEE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;AAzUF;AA2UA;;EAEE,aAAA;AAzUF;AA2UA;;;;EAIE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,YAAA;AAzUF;AA2UA;;EAEE,YAAA;EACA,WAAA;EACA,gCAAA;AAzUF;AA2UA;;EAEE,WAAA;EACA,WAAA;EACA,4BAAA;AAzUF;AA2UA;;EAEE,cAAA;EACA,UAAA;EACA,kBAAA;AAzUF;AA2UA;;EAEE,yBAAA;AAzUF;AA2UA;;EAEE,YAAA;EACA,WAAA;EACA,4BAAA;AAzUF;AA2UA;;EAEE,WAAA;EACA,WAAA;EACA,wBAAA;AAzUF;AA2UA;;EAEE,aAAA;EACA,mBAAA;AAzUF;AA2UA;;EAEE,UAAA;AAzUF;AA2UA;;EAEE,YAAA;EACA,eAAA;AAzUF;AA4UA;;;;EAYE,UAAA;AAlVF;AAqVA;;;;EAIE,cAAA;EACA,UAAA;AAnVF;AAqVA;;;;EAIE,sBAAA;AAnVF;AAqVA;;;;EAIE,YAAA;EACA,WAAA;EACA,4BAAA;AAnVF;AAqVA;;;;EAIE,WAAA;EACA,WAAA;EACA,wBAAA;AAnVF;AAqVA;;;;EAIE,WAAA;EACA,aAAA;AAnVF;AAqVA;;;;EAIE,sBAAA;AAnVF;AAqVA;;;;EAIE,YAAA;EACA,WAAA;EACA,gCAAA;AAnVF;AAqVA;;;;EAIE,WAAA;EACA,WAAA;EACA,4BAAA;AAnVF;AAsVA;EACE,WAAA;EACA,WAAA;AApVF;AAuVA;EAGE,YAAA;EACA,UAAA;AAvVF;AA0VA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;AAxVF;AA2VA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AAzVF;AA4VA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA1VF;AA4VA;EACE,UAAA;AA1VF;AA4VA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,oBAAA;EACA,gCAAA;AA1VF;AA4VA;EACE,qBAAA;AA1VF;AA4VA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;AA1VF;AA4VA;EACE,SAAA;EACA,mBAAA;AA1VF;AA4VA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;AA1VF;AA4VA;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,wFAAA;EAKA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AA9VF;AAgWA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2CAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AA9VF;AAgWA;EACE,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AA9VF;AAgWA;EACE,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA9VF;AAgWA;EACE,cAAA;AA9VF;AAiWA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,0FAAA;EAKA,2CAAA;EACA,6EAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAnWF;AAqWA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AAnWF;AAqWA;EACE,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,wFAAA;EAKA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAvWF;AAyWA;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2CAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAvWF;AAyWA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;AAvWF;AA0WA;;;;;EAKE,UAAA;EACA,OAAA;AAxWF;AA2WA;EACE,WAAA;EACA,QAAA;AAzWF;AA4WA;EACE,WAAA;EACA,UAAA;EACA,QAAA;AA1WF;AA6WA;EACE,WAAA;EACA,UAAA;EACA,QAAA;AA3WF;AA8WA;EACE,YAAA;EACA,OAAA;AA5WF;AA8WA;EACE,QAAA;EACA,WAAA;AA5WF;AA+WA;EACE,WAAA;EACA,QAAA;AA7WF;AA+WA;EACE,YAAA;EACA,OAAA;AA7WF;AAgXA;EACE,iBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;AA9WF;AAgXA;EACE;IACE,aAAA;EA9WF;AACF;AAiXA;EACE,qBAAA;EACA,wBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA/WF;AAiXA;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,wFAAA;EAKA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAnXF;AAqXA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,6BAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,yCAAA;AAnXF;AAqXA;EACE,WAAA;EACA,eAAA;AAnXF;AAqXA;EACE,cAAA;AAnXF;AAqXA;EACE,sCAAA;EACA,qBAAA;AAnXF;AAqXA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAnXF;AAsXA;EACE,0CAAA;EACA,kBAAA;AApXF;AAsXA;EACE,WAAA;AApXF;AAuXA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2DAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AArXF;AAuXA;EACE,eAAA;AArXF;AAuXA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AArXF;AAuXA;EACE,eAAA;AArXF;AAuXA;EACE,cAAA;EACA,eAAA;AArXF;AAuXA;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AArXF;AAuXA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AArXF;AAuXA;EACE,UAAA;AArXF;AAwXA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAtXF;AAwXA;EACE,SAAA;AAtXF;AAwXA;EACE,yBAAA;EACA,gBAAA;AAtXF;AAwXA;;EAEE,YAAA;EACA,aAAA;AAtXF;AAyXA;EACE,yBAAA;AAvXF;AAyXA;EACE,uBAAA;EACA,UAAA;AAvXF;AAyXA;EAIE,UAAA;AA1XF;AA6XA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AA3XF;AA8XA;EACE,gBAAA;AA5XF;AA+XA;EACE;IACE,eAAA;IACA,MAAA;IACA,QAAA;IACA,aAAA;IACA,iBAAA;IACA,aAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;EA7XF;AACF;AAgYA;EACE,qCAAA;AA9XF;AAgYA;EACE,kCAAA;EACA,0EAAA;EACA,YAAA;AA9XF;AAgYA;EACE,YAAA;AA9XF;AAiYA;EACE;IACE,mBAAA;EA/XF;AACF;AAkYA;EACE,iBAAA;AAhYF;AAmYA;EACE;IACE,eAAA;IACA,MAAA;IACA,QAAA;IACA,aAAA;IACA,iBAAA;IACA,aAAA;IACA,SAAA;IACA,YAAA;IACA,eAAA;EAjYF;AACF;AAoYA;EACE,YAAA;AAlYF;AAqYA;EACE,mBAAA;AAnYF;AAsYA;;EAEE,uBAAA;AApYF;AAsYA;;EAEE,qCAAA;AApYF;AAuYA;;EAEE,eAAA;AArYF;AAwYA;;EAEE,mBAAA;AAtYF;AAwYA;;EAEE,qCAAA;EACA,2CAAA;EACA,YAAA;AAtYF;AAwYA;;EAEE,oCAAA;EACA,kBAAA;EACA,YAAA;AAtYF;AAyYA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAvYF;AAyYA;EACE,cAAA;AAvYF;AAyYA;EACE,cAAA;AAvYF;AAyYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AAvYF;AAyYA;EACE,YAAA;EACA,UAAA;AAvYF;AAyYA;EACE,WAAA;EACA,WAAA;AAvYF;AAyYA;EACE,eAAA;EACA,SAAA;EACA,kBAAA;AAvYF;AAyYA;;EAEE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;AAvYF;AAyYA;;EAEE,WAAA;AAvYF;AAyYA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,qBAAA;EACA,2BAAA;AAvYF;AAyYA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAvYF;AAyYA;EACE,aAAA;AAvYF;AAyYA;EACE;IACE,aAAA;EAvYF;AACF;AAyYA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAvYF;AAyYA;EACE,YAAA;AAvYF;AAyYA;EACE,YAAA;AAvYF;AAyYA;EACE,eAAA;AAvYF;AAyYA;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAvYF;AAyYA;EACE,aAAA;AAvYF;AA0YA;EACE,qCAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;AAxYF;AA2YA;;EAKE,WAAA;AA5YF;AA+YA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AA7YF;AA+YA;EACE,mBAAA;AA7YF;AA+YA;EACE,aAAA;AA7YF;AA+YA;EACE,uBAAA;EACA,mBAAA;AA7YF;AA+YA;EACE,kBAAA;AA7YF;AA+YA;EACE,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,YAAA;EACA,iCAAA;AA7YF;AA+YA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;AA7YF;AA+YA;EACE,sBAAA;EACA,YAAA;AA7YF;AA+YA;EACE,sBAAA;EACA,YAAA;AA7YF;AAgZA;EACE,qBAAA;AA9YF;AAiZA;EACE,qCAAA;AA/YF;AAkZA;EACE;;;IAGE,kBAAA;EAhZF;EAkZA;IACE,2BAAA;EAhZF;AACF;AAmZA;EACE,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAjZF;AAmZA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,2DAAA;EACA,YAAA;AAjZF;AAmZA;EACE,cAAA;EACA,qBAAA;AAjZF;AAmZA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;AAjZF;AAoZA;;EAEE,sBAAA;EACA,iBAAA;AAlZF;AAqZA;EACE,4EAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnZF;AAsZA;EACE,YAAA;AApZF;AAuZA;EACE,uBAAA;AArZF;AAwZA;EACE,wBAAA;EACA,2BAAA;EACA,4BAAA;AAtZF;AAyZA;EACE,qBAAA;EACA,8BAAA;EACA,+BAAA;AAvZF;AA0ZA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,cAAA;AAxZF;AA2ZA;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAzZF;AA4ZA;EACE,UAAA;AA1ZF;AA6ZA;;;EAGE,cAAA;AA3ZF;AA8ZA;EACE,SAAA;AA5ZF;AA+ZA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AA7ZF;AAgaA;EACE,qBAAA;EACA,WAAA;EACA,eAAA;AA9ZF;AAiaA;;EAEE,kBAAA;EACA,YAAA;EACA,WAAA;AA/ZF;AAkaA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EAhaA,iDAAiD;AACnD;AAmaA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAjaF;AAoaA;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AAlaF;AAqaA;;;;;EA/ZE;8CAC4C;EAqa5C,wBAAA;AAnaF;AAsaA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AApaF;AAuaA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAraF;AAwaA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAtaF;AAyaA;EACE,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,MAAA;AAvaF;AA0aA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2CAAA;AAxaF;AA2aA;EACE,SAAA;EACA,UAAA;AAzaF;AA4aA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;AA1aF;AA6aA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA3aF;AA8aA;EACE,yIAAA;AA5aF;AAgbA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA9aF;AAibA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AA/aF;AAkbA;EACE,aAAA;AAhbF;AAmbA;EACE,iBAAA;AAjbF;AAobA;EACE,aAAA;AAlbF;AAqbA;EACE,kBAAA;EACA,YAAA;AAnbF;AAsbA;;;EAGE,kBAAA;EACA,QAAA;EACA,2BAAA;AApbF;AAubA;EACE,UAAA;AArbF;AAwbA;EACE,UAAA;EACA,WAAA;EACA,qBAAA;AAtbF;AAybA;EACE,WAAA;EACA,iBAAA;AAvbF;AA0bA;EACE,WAAA;EACA,iBAAA;AAxbF;AA2bA;EACE,eAAA;AAzbF;AA4bA;EACE,eAAA;EACA,WAAA;AA1bF;AA6bA;;;EAGE,kBAAA;AA3bF;AA8bA;EACE,eAAA;EACA,WAAA;AA5bF;AA+bA;EACE,qBAAA;EACA,sBAAA;AA7bF;AAgcA;EACE,UAAA;AA9bF;AAicA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA/bF;AAkcA;EACE,YAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAhcF;AAmcA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;AAjcF;AAocA;EACE,WAAA;EACA,cAAA;AAlcF;AAqcA;EACE,aAAA;AAncF;AAscA;EACE,qBAAA;EACA,QAAA;EACA,sBAAA;EACA,mCAAA;EACA,2BAAA;EACA,oCAAA;AApcF;AAucA;EACE,oBAAA;AArcF;AAwcA;EACE,uBAAA;AAtcF;AAycA;EACE,uBAAA;AAvcF;AA0cA;EACE,uBAAA;AAxcF;AA2cA;EACE,uBAAA;AAzcF;AA4cA;EACE,uBAAA;AA1cF;AA6cA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AA3cF;AA8cA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;EACA,iCAAA;AA5cF;AA+cA;EACE,qBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,2BAAA;EACA,oCAAA;EACA,eAAA;AA7cF;AAgdA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA9cF;AAidA;EACE,WAAA;EACA,QAAA;EACA,SAAA;AA/cF;AAkdA;EACE,yBAAA;EACA,kBAAA;AAhdF;AAmdA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAjdF;AAodA;EAEE,aAAA;AAndF;AAsdA;EACE,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AApdF;AAudA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AArdF;AAwdA;EACE,yBAAA;AAtdF;AAydA;EACE,yBAAA;AAvdF;AA0dA;EACE,yBAAA;AAxdF;AA2dA;EACE,yBAAA;AAzdF;AA4dA;EACE,yBAAA;AA1dF;AA6dA;EACE,yBAAA;AA3dF;AACA,qEAAqE;AA8drE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AA5dF;AACA;;EAEE;AA+dF;EACE,WAAA;EACA,qBAAA;EACA,sBAAA;AA7dF;AAgeA;EACE,qBAAA;AA9dF;AAieA;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA/dF;AAkeA;EACE,UAAA;AAheF;AAmeA;EACE,sBAAA;AAjeF;AAoeA;EACE,sBAAA;EACA,WAAA;AAleF;AAqeA;EACE,qBAAA;EACA,sBAAA;AAneF;AAseA;;;EAGE,cAAA;AApeF;AAueA;EACE,aAAA;EAreA,uCAAuC;EAuevC,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EAreA,qBAAqB;EACrB,mBAAmB;AACrB;AAueA;EACE,kBAAA;EAreA,iEAAiE;AACnE;AAueA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAreF;AAueA;EAGE,WAAA;EACA,WAAA;AAveF;AAyeA;EACE,iBAAA;AAveF;AAyeA;EACE,SAAA;EACA,gBAAA;AAveF;AAyeA;;EAEE,iBAAA;AAveF;AAyeA;;EAEE,aAAA;AAveF;AAyeA;EACE,gCAAA;AAveF;AAyeA;EACE,6BAAA;AAveF;AAyeA;EACE,+BAAA;AAveF;AAyeA;EAEE,6BAAA;AAxeF;AA0eA;EACE,8BAAA;AAxeF;AA0eA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AAxeF;AA0eA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EAxeA,cAAc;EA0ed,YAAA;EAxeA,cAAc;EA0ed,+BAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;EACA,gBAAA;AAxeF;AA0eA;EACE,SAAA;EACA,qBAAA;EAxeA,iDAAiD;EA0ejD,yBAAA;EACA,qBAAA;EACA,yBAAA;EAxeA,uCAAuC;EA0evC,sBAAA;EAxeA,iEAAiE;EA0ejE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;AAxeF;AA0eA;EACE,gBAAA;AAxeF;AA0eA;EACE,gCAAA;AAxeF;AA0eA;EACE,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAxeF;AA0eA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;AAxeF;AA0eA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAxeF;AA0eA;EACE,gBAAA;EACA,iBAAA;AAxeF;AA0eA;EACE,SAAA;EACA,iBAAA;AAxeF;AA0eA;EACE,gBAAA;AAxeF;AA0eA;EAEE,aAAA;AAzeF;AA2eA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAzeF;AA2eA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAzeF;AA2eA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAzeF;AA2eA;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAzeF;AA2eA;EACE,kBAAA;EACA,eAAA;AAzeF;AA2eA;EACE,iCAAA;EACA,uCAAA;AAzeF;AA2eA;EACE,yBAAA;EACA,cAAA;AAzeF;AA2eA;EAEE,yBAAA;AA1eF;AA4eA;EAGE,WAAA;AA5eF;AA8eA;EAIE,UAAA;AA/eF;AAifA;EAGE,aAAA;EACA,yBAAA;AAjfF;AAmfA;EAIE,aAAA;EACA,2BAAA;AApfF;AAsfA;EAKE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAxfF;AA0fA;EAEE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAzfF;AA2fA;EAGE,iBAAA;AA3fF;AA6fA;EAEE,aAAA;AA5fF;AA8fA;EAEE,qBAAA;AA7fF;AA+fA;EAEE,iCAAA;AA9fF;AAggBA;EAEE,iCAAA;AA/fF;AAigBA;;EAEE,eAAA;AA/fF;AAigBA;EAEE,iCAAA;AAhgBF;AAkgBA;EAEE,gCAAA;AAjgBF;AAmgBA;EAEE,+BAAA;AAlgBF;AAogBA;EAEE,QAAA;AAngBF;AAqgBA;EAEE,2BAAA;EACA,2BAAA;AApgBF;AAsgBA;EAEE,WAAA;AArgBF;AAugBA;EAEE,iBAAA;AAtgBF;AAwgBA;EAGE,WAAA;EACA,YAAA;EACA,gBAAA;AAxgBF;AA2gBA;EACE,2DAAA;AAzgBF;AA2gBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;AAzgBF;AA2gBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAzgBF;AA2gBA;EACE,UAAA;EACA,YAAA;AAzgBF;AA2gBA;EACE,UAAA;AAzgBF;AA2gBA;;EAEE,aAAA;AAzgBF;AA2gBA;EACE,kBAAA;EACA,aAAA;AAzgBF;AA2gBA;EAEE,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;AA1gBF;AA4gBA;EAEE,aAAA;AA3gBF;AA6gBA;EAEE,aAAA;AA5gBF;AA8gBA;EAEE,aAAA;AA7gBF;AA+gBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AA7gBF;AA+gBA;EACE,gBAAA;AA7gBF;AA+gBA;EACE,aAAA;EACA,uBAAA;AA7gBF;AA+gBA;EACE,gBAAA;AA7gBF;AA+gBA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AA7gBF;AA+gBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AA7gBF;AA+gBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AA7gBF;AA+gBA;EAEE,aAAA;AA9gBF;AAghBA;EAEE,aAAA;AA/gBF;AAihBA;EAEE,aAAA;AAhhBF;AAmhBA;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AAjhBF;AAohBA;EACE,0BAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAlhBF;AAohBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAlhBF;AAohBA;EACE,oBAAA;EACA,eAAA;AAlhBF;AAohBA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAlhBF;AAohBA;EACE,cAAA;AAlhBF;AAohBA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAlhBF;AAqhBA;EACE,wBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AAnhBF;AAshBA;EACE,SAAA;EACA,+BAAA;EACA,gBAAA;EACA,qCAAA;AAphBF;AAshBA;EACE,mBAAA;AAphBF;AAshBA;EACE,aAAA;AAphBF;AAuhBA;EACE,WAAA;AArhBF;AAwhBA;EAGE,YAAA;EACA,UAAA;EACA,iCAAA;AAxhBF;AA2hBA;EACE,YAAA;EACA,YAAA;AAzhBF;AA4hBA;EACE,qCAAA;EACA,YAAA;AA1hBF;AA6hBA;EACE,WAAA;AA3hBF;AA8hBA;EACE,8BAAA;AA5hBF;AA8hBA;EAGE,8BAAA;AA9hBF;AAgiBA;EAGE,YAAA;AAhiBF;AAkiBA;EAGE,+BAAA;AAliBF;AAqiBA;EAGE,8BAAA;AAriBF;AAwiBA;EAIE,8BAAA;AAziBF;AA2iBA;EAIE,8BAAA;AA5iBF;AA+iBA;EA7iBE,uBAAuB;AACzB;AA+iBA;EA7iBE,4BAA4B;AAC9B;AA+iBA;EACE,2DAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AA7iBF;AA+iBA;EACE,eAAA;AA7iBF;AA+iBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;AA7iBF;AA+iBA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA7iBF;AA+iBA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA7iBF;AA+iBA;EACE,UAAA;EACA,YAAA;AA7iBF;AA+iBA;EACE,UAAA;AA7iBF;AA+iBA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AA7iBF;AA+iBA;EACE,mBAAA;AA7iBF;AA+iBA;EACE,kBAAA;EACA,WAAA;AA7iBF;AA+iBA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AA7iBF;AA+iBA;EACE,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA7iBF;AA+iBA;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA7iBF;AA+iBA;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;AA7iBF;AA+iBA;EACE,eAAA;EACA,8BAAA;AA7iBF;AA+iBA;EACE,SAAA;EACA,qBAAA;EA7iBA,iDAAiD;EA+iBjD,yBAAA;EACA,qBAAA;EACA,yBAAA;EA7iBA,uCAAuC;EA+iBvC,sBAAA;EA7iBA,iEAAiE;EA+iBjE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;AA7iBF;AA+iBA;EACE,gBAAA;AA7iBF;AA+iBA;EACE,cAAA;EACA,iBAAA;EACA,qBAAA;AA7iBF;AA+iBA;EACE,yBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;AA7iBF;AA+iBA;;EAEE,iOAAA;EAIA,oBAAA;EACA,eAAA;EACA,gBAAA;AAhjBF;AAkjBA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;AAhjBF;AAkjBA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;AAhjBF;AAkjBA;EACE,SAAA;AAhjBF;AAkjBA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;AAhjBF;AAkjBA;EACE,eAAA;AAhjBF;AAkjBA;EACE,eAAA;AAhjBF;AAkjBA;EACE,aAAA;AAhjBF;AAkjBA;EACE,aAAA;AAhjBF;AAkjBA;EACE,eAAA;EACA,iBAAA;AAhjBF;AAkjBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAhjBF;AAkjBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAhjBF;AAkjBA;EACE,oBAAA;EACA,eAAA;AAhjBF;AAkjBA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAhjBF;AAkjBA;EACE,cAAA;AAhjBF;AAkjBA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAhjBF;AAkjBA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AAhjBF;AAkjBA;EACE,iBAAA;AAhjBF;AAkjBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAhjBF;AAkjBA;;EAEE,mBAAA;AAhjBF;AAkjBA;EACE,aAAA;EACA,mBAAA;EACA,6FAAA;EAEA,UAAA;AAjjBF;AAmjBA;EAjjBE,iBAAiB;AACnB;AAmjBA;EAjjBE,mCAAmC;AACrC;AAmjBA;EACE,+BAAA;AAjjBF;AAmjBA;EACE,mBAAA;AAjjBF;AAmjBA;EACE,mBAAA;AAjjBF;AAmjBA;EAjjBE,mCAAmC;EAmjBnC,iBAAA;EACA,oBAAA;AAjjBF;AAmjBA;EACE,aAAA;AAjjBF;AAmjBA;EACE,uBAAA;EACA,iBAAA;EACA,qBAAA;EAjjBA,UAAU;AACZ;AAmjBA;EACE,YAAA;AAjjBF;AAmjBA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EAjjBA,UAAU;AACZ;AAmjBA;EACE,aAAA;AAjjBF;AAmjBA;EACE,qBAAA;AAjjBF;AAmjBA;EACE,YAAA;AAjjBF;AAmjBA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAjjBF;AAmjBA;EACE,SAAA;EACA,8BAAA;EACA,gBAAA;EACA,qCAAA;AAjjBF;AAmjBA;EACE,mBAAA;AAjjBF;AAmjBA;EACE,aAAA;AAjjBF;AAmjBA;;EAEE,gBAAA;EACA,YAAA;AAjjBF;AACA,cAAc;AAojBd;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAljBF;AAqjBA;EACE,eAAA;AAnjBF;AAsjBA;EACE,iBAAA;AApjBF;AAsjBA;EACE,WAAA;EACA,gBAAA;AApjBF;AAsjBA;EAGE,YAAA;EACA,eAAA;EACA,aAAA;AAtjBF;AAyjBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAvjBF;AAyjBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AAvjBF;AA0jBA;EACE,+BAAA;EACA,UAAA;AAxjBF;AA2jBA;EACE,YAAA;AAzjBF;AA4jBA;EACE,+BAAA;AA1jBF;AA6jBA;;EAEE,gCAAA;EACA,YAAA;AA3jBF;AA6jBA;;;;EAUE,oCAAA;AAjkBF;AAmkBA;;EAEE,yBAAA;AAjkBF;AAmkBA;;EAEE,2CAAA;EACA,0CAAA;AAjkBF;AAmkBA;;EAEE,2CAAA;EACA,0CAAA;AAjkBF;AAmkBA;;EAOE,gCAAA;AAtkBF;AAwkBA;;;;EAkBE,YAAA;AAplBF;AAslBA;;EASE,YAAA;AA3lBF;AA6lBA;;EAOE,uBAAA;AAhmBF;AAkmBA;;;;EAkBE,YAAA;AA9mBF;AAgnBA;;EASE,YAAA;AArnBF;AAwnBA;;EAOE,uBAAA;AA3nBF;AA6nBA;;EAOE,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAhoBF;AAkoBA;;EAOE,YAAA;AAroBF;AAuoBA;;EAOE,+BAAA;AA1oBF;AA6oBA;EACE,mBAAA;EACA,2CAAA;EACA,2CAAA;EACA,mBAAA;AA3oBF;AA6oBA;EACE,mBAAA;AA3oBF;AA6oBA;EACE,iCAAA;AA3oBF;AA6oBA;EACE,UAAA;AA3oBF;AA8oBA;EACE,iBAAA;EACA,iBAAA;AA5oBF;AA8oBA;EAIE,+BAAA;EACA,UAAA;AA/oBF;AAipBA;;EAME,qBAAA;EACA,WAAA;AAnpBF;AAspBA;EACE,aAAA;EACA,8BAAA;EACA,2HAAA;EAGA,UAAA;AAtpBF;AAypBA;EACE,cAAA;EACA,kBAAA;EAvpBA,kBAAkB;AACpB;AAypBA;;EAEE,gBAAA;AAvpBF;AAypBA;;;;;;EAME,iCAAA;AAvpBF;AAypBA;;;;EAYE,iCAAA;AA/pBF;AAiqBA;;EAEE,iBAAA;AA/pBF;AAiqBA;;;;EAME,iCAAA;AAjqBF;AAmqBA;;;;EAYE,iCAAA;AAzqBF;AA2qBA;;EAEE,iCAAA;AAzqBF;AA2qBA;;EAME,iCAAA;AA7qBF;AA+qBA;EACE,SAAA;AA7qBF;AA+qBA;;;EAGE,gCAAA;AA7qBF;AA+qBA;;;EASE,gCAAA;AAnrBF;AAqrBA;;;EAME,gCAAA;AAtrBF;AAwrBA;;;EASE,2BAAA;AA5rBF;AA8rBA;EACE,gBAAA;AA5rBF;AA8rBA;;;EAGE,gCAAA;AA5rBF;AA8rBA;;;EASE,gCAAA;AAlsBF;AAosBA;;;EAME,gCAAA;AArsBF;AAusBA;;;EASE,2BAAA;AA3sBF;AA6sBA;EACE,mBAAA;AA3sBF;AA6sBA;;EAEE,aAAA;AA3sBF;AA6sBA;EACE,iCAAA;AA3sBF;AA6sBA;EACE,iCAAA;AA3sBF;AA6sBA;EACE,iCAAA;AA3sBF;AA6sBA;EACE,gCAAA;AA3sBF;AA6sBA;EACE,iCAAA;AA3sBF;AA6sBA;EAGE,gCAAA;AA7sBF;AA+sBA;;EAEE,gCAAA;AA7sBF;AA+sBA;;EAEE,gCAAA;AA7sBF;AA+sBA;;EAME,SAAA;AAjtBF;AAmtBA;;EAIE,SAAA;EACA,UAAA;EACA,gCAAA;AAntBF;AAstBA;;EAEE,oBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EAptBA,OAAO;EACP,qBAAqB;EACrB,mBAAmB;AACrB;AAstBA;;EAEE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAptBF;AAstBA;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;AAptBF;AAstBA;;EAEE,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AAptBF;AAstBA;;EAEE,OAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;AAptBF;AAstBA;;EAEE,eAAA;EACA,yBAAA;EACA,yBAAA;AAptBF;AAstBA;;EAEE,kBAAA;AAptBF;AAstBA;EACE;;IAEE,kBAAA;IACA,kBAAA;EAptBF;AACF;AAstBA;;EAEE,kBAAA;EACA,QAAA;EACA,UAAA;AAptBF;AAstBA;;EAEE,aAAA;EACA,sBAAA;AAptBF;AAstBA;;EAEE,oBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAptBF;AAstBA;;EAEE,kBAAA;EACA,OAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EAptBA,cAAc;EAstBd,YAAA;EAptBA,cAAc;EAstBd,+BAAA;EACA,gBAAA;EACA,qCAAA;EACA,cAAA;EAptBA,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;AACzC;AAstBA;;EAntBE;kGACgG;EAstBhG,yBAAA;EACA,qBAAA;EAptBA,iEAAiE;EAstBjE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;AAptBF;AAstBA;;EAEE,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EAptBA,6BAA6B;AAC/B;AAstBA;;EAEE,gCAAA;AAptBF;AAstBA;;EAEE,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAptBF;AAstBA;;EAEE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,eAAA;AAptBF;AAstBA;;EAEE,eAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;AAptBF;AAstBA;;EAEE,gBAAA;EACA,iBAAA;AAptBF;AAstBA;;EAEE,SAAA;EACA,qBAAA;EACA,iBAAA;AAptBF;AAstBA;;EAEE,gBAAA;AAptBF;AAstBA;;EAEE,aAAA;EACA,aAAA;EACA,yBAAA;AAptBF;AAstBA;;EAEE,aAAA;EACA,yBAAA;AAptBF;AAstBA;;EAEE,aAAA;EACA,sBAAA;EACA,qBAAA;AAptBF;AAstBA;;EAEE,yBAAA;EACA,qBAAA;AAptBF;AAstBA;EACE;;IAEE,mBAAA;IACA,iBAAA;EAptBF;AACF;AAstBA;;EAME,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;AAxtBF;AA0tBA;;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EAxtBA,+BAA+B;AACjC;AA0tBA;;EAEE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EAxtBA,6BAA6B;AAC/B;AA0tBA;;EAEE,gCAAA;AAxtBF;AA0tBA;;EAEE,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAxtBF;AA0tBA;;EAEE,iBAAA;AAxtBF;AA0tBA;;EAEE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAxtBF;AA0tBA;;EAEE,iBAAA;AAxtBF;AA0tBA;;EAEE,gBAAA;AAxtBF;AA0tBA;;EAEE,cAAA;EACA,gBAAA;EACA,qBAAA;AAxtBF;AA0tBA;;EAEE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAxtBF;AA0tBA;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;AAxtBF;AA0tBA;;EAEE,kBAAA;EACA,sBAAA;EACA,uBAAA;AAxtBF;AA0tBA;;EAEE,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAxtBF;AA0tBA;;EAEE,kBAAA;EACA,qBAAA;AAxtBF;AA0tBA;;EAEE,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAxtBF;AA0tBA;;;;EAIE,qBAAA;EACA,eAAA;EACA,cAAA;AAxtBF;AA0tBA;;;;EAIE,iCAAA;EACA,uCAAA;AAxtBF;AA0tBA;;;;EAIE,oBAAA;EACA,kBAAA;AAxtBF;AA0tBA;;EAEE,uBAAA;AAxtBF;AA2tBA;EAztBE,QAAQ;AACV;AA2tBA;;EAEE,aAAA;AAztBF;AA2tBA;;EAEE,gBAAA;AAztBF;AA2tBA;EACE,aAAA;EACA,gBAAA;AAztBF;AA2tBA;EACE,aAAA;EACA,mBAAA;AAztBF;AA2tBA;EACE,gBAAA;EACA,mBAAA;AAztBF;AA2tBA;EACE,cAAA;AAztBF;AA2tBA;EACE,aAAA;AAztBF;AA2tBA;EACE,yBAAA;AAztBF;AA2tBA;EACE,cAAA;AAztBF;AA2tBA;;EAQE,2BAAA;AA/tBF;AAkuBA;EACE,2DAAA;AAhuBF;AAkuBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;AAhuBF;AAkuBA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAhuBF;AAkuBA;EACE,UAAA;EACA,YAAA;AAhuBF;AAkuBA;EACE,UAAA;AAhuBF;AAkuBA;;EAEE,aAAA;AAhuBF;AAkuBA;EACE,kBAAA;EACA,aAAA;AAhuBF;AAkuBA;EAEE,aAAA;AAjuBF;AAmuBA;EAEE,aAAA;AAluBF;AAouBA;EAEE,aAAA;AAnuBF;AAquBA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAnuBF;AAquBA;EACE,gBAAA;EACA,gBAAA;AAnuBF;AAquBA;EACE,aAAA;EACA,uBAAA;AAnuBF;AAquBA;EAEE,iBAAA;AApuBF;AAsuBA;EACE,gBAAA;AApuBF;AAsuBA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AApuBF;AAsuBA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AApuBF;AAsuBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AApuBF;AAsuBA;EACE,aAAA;EACA,yBAAA;AApuBF;AAsuBA;EAGE,aAAA;EACA,2BAAA;AAtuBF;AAwuBA;EAIE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAzuBF;AA2uBA;EACE,yBAAA;AAzuBF;AA2uBA;EACE,gBAAA;AAzuBF;AA2uBA;EACE,6BAAA;EACA,iBAAA;AAzuBF;AA2uBA;EACE,SAAA;AAzuBF;AA2uBA;EAEE,aAAA;AA1uBF;AA4uBA;EAEE,aAAA;AA3uBF;AA6uBA;EAEE,aAAA;AA5uBF;AA+uBA;EACE,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AA7uBF;AAgvBA;EACE,0BAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AA9uBF;AAgvBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AA9uBF;AAgvBA;EACE,oBAAA;EACA,eAAA;AA9uBF;AAgvBA;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA9uBF;AAgvBA;EACE,cAAA;AA9uBF;AAgvBA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA9uBF;AAivBA;EACE,SAAA;EACA,+BAAA;EACA,gBAAA;EACA,qCAAA;AA/uBF;AAivBA;EACE,mBAAA;AA/uBF;AAivBA;EACE,aAAA;AA/uBF;AAkvBA;EACE,SAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;AAhvBF;AAkvBA;EAGE,yBAAA;EACA,eAAA;AAlvBF;AAovBA;EACE,4BAAA;EACA,0BAAA;AAlvBF;AAovBA;EACE,6BAAA;EACA,2BAAA;AAlvBF;AAovBA;EAEE,gCAAA;EACA,6BAAA;EACA,iCAAA;AAnvBF;AAsvBA;EACE,gBAAA;AApvBF;AAuvBA;EACE,+BAAA;AArvBF;AAwvBA;EACE,mBAAA;AAtvBF;AAwvBA;EACE,2BAAA;AAtvBF;AAwvBA;EAEE,iCAAA;AAvvBF;AA0vBA;EACE,WAAA;AAxvBF;AA2vBA;EAGE,YAAA;EACA,UAAA;EACA,iCAAA;AA3vBF;AA8vBA;EACE,aAAA;AA5vBF;AA+vBA;EACE;IACE,gBAAA;EA7vBF;EA+vBA;IACE,WAAA;IACA,UAAA;IACA,YAAA;EA7vBF;AACF;AAgwBA;EACE,qCAAA;EACA,YAAA;AA9vBF;AAgwBA;EACE,uBAAA;AA9vBF;AAiwBA;EACE,WAAA;AA/vBF;AAkwBA;EACE,YAAA;EACA,YAAA;AAhwBF;AAmwBA;EACE,uBAAA;AAjwBF;AAmwBA;EAGE,qCAAA;AAnwBF;AAqwBA;EAGE,+BAAA;AArwBF;AAwwBA;EACE,yBAAA;EACA,qCAAA;AAtwBF;AAwwBA;;EAKE,YAAA;AAzwBF;AA2wBA;EAIE,YAAA;AA5wBF;AA+wBA;EAGE,+BAAA;AA/wBF;AAkxBA;EAGE,8BAAA;AAlxBF;AAoxBA;EAGE,uBAAA;AApxBF;AAuxBA;EAIE,8BAAA;AAxxBF;AA2xBA;EAIE,8BAAA;AA5xBF;AA+xBA;EAGE,mBAAA;EACA,yGAAA;AA/xBF;AAmyBA;;EAEE,iCAAA;EACA,uCAAA;AAjyBF;AAoyBA;EAGE,UAAA;EACA,YAAA;AApyBF;AAsyBA;EAGE,WAAA;EACA,WAAA;EACA,iCAAA;AAtyBF;AAyyBA;EAGE,WAAA;EACA,WAAA;EACA,iCAAA;AAzyBF;AA2yBA;EAGE,UAAA;EACA,YAAA;EACA,iCAAA;AA3yBF;AA8yBA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;AA5yBF;AA+yBA;EACE;IACE,gBAAA;EA7yBF;AACF;AAgzBA;EACE;IACE,gBAAA;EA9yBF;AACF;AAizBA;EACE;IACE,gBAAA;EA/yBF;AACF","sourcesContent":["/* fonts */\n/* colors */\n/* miscellaneous */\n.str-chat {\n  box-sizing: border-box;\n}\n.str-chat *,\n.str-chat *::after,\n.str-chat *::before {\n  box-sizing: inherit;\n\n  // we don't want to edit this file, but we comment this out for FA4. Can undo on upgrade to FA5\n  // font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.clearfix {\n  clear: both;\n}\n\n.messenger-chat.str-chat {\n  height: 100vh;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  margin: 0;\n  flex: 1 0 100%;\n}\n.messenger-chat.str-chat .str-chat__container {\n  flex: 1;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.messenger-chat.str-chat .str-chat__main-panel {\n  width: 100%;\n  flex: 1;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 0 10px;\n}\n\n.str-chat {\n  max-height: calc(100vh - 205px);\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n\n.str-chat.messaging,\n.str-chat.commerce {\n  background-color: #f1f1f3;\n}\n.str-chat.messaging.dark,\n.str-chat.commerce.dark {\n  background-color: #212326;\n}\n.str-chat.team.dark {\n  background: #212326;\n}\n.str-chat.livestream.dark {\n  background: #1a1a1a;\n}\n\n.str-chat-channel-list {\n  float: left;\n}\n\n.str-chat__channel-list-empty {\n  display: none;\n}\n\n.str-chat-channel {\n  max-height: 100vh;\n}\n.str-chat-channel .str-chat__container {\n  height: 100%;\n  display: flex;\n}\n.str-chat-channel .str-chat__container .str-chat__main-panel {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.str-chat-channel.messaging .str-chat__main-panel {\n  padding: 20px 10px 0 0px;\n}\n@media screen and (max-width: 960px) {\n  .str-chat-channel.messaging .str-chat__main-panel {\n    padding: 5px 5px 0;\n  }\n}\n.str-chat-channel.team .str-chat__container {\n  display: flex;\n}\n.str-chat-channel.commerce .str-chat__main-panel {\n  width: 100%;\n}\n.str-chat-channel.commerce .str-chat__container {\n  background: rgba(255, 255, 255, 0.97);\n}\n.str-chat-channel.commerce.dark .str-chat__container {\n  background: rgba(29, 32, 36, 0.9);\n  box-shadow: 0 10px 31px 0 rgba(0, 0, 0, 0.5);\n}\n\n.str-chat.dark .emoji-mart {\n  background: #1a1a1a;\n  border: #343434;\n}\n\n.str-chat.dark .emoji-mart-category-label span {\n  background: #1f1f1f;\n  color: white;\n}\n\n.str-chat.dark .emoji-mart-search input {\n  background: #1f1f1f;\n  color: white;\n}\n\n.str-chat.dark .emoji-mart-search button svg {\n  fill: white;\n}\n\n/* fonts */\n/* colors */\n/* miscellaneous */\n.str-chat__actions-box {\n  background: #fff;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(255, 255, 255, 0.02) 0%,\n    rgba(0, 0, 0, 0.02) 100%\n  );\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08),\n    0 1px 8px 0 rgba(0, 0, 0, 0.05);\n  border-radius: 7px;\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  position: absolute;\n  min-width: 150px;\n}\n.str-chat__actions-box--right {\n  right: 0;\n  top: calc(100% + 2px);\n}\n.str-chat__actions-box--left {\n  left: 0;\n  top: calc(100% + 2px);\n}\n.str-chat__actions-box > button {\n  text-align: left;\n  width: 100%;\n  border: none;\n  margin: 0;\n  padding: 10px;\n  font-size: 12px;\n  background: none;\n  cursor: pointer;\n}\n.str-chat__actions-box > button:not(:last-of-type) {\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.08);\n}\n.str-chat__actions-box > button:hover {\n  color: #006cff;\n}\n\n.dark.str-chat .str-chat__message-actions-box {\n  background: #67686a;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(255, 255, 255, 0.02) 0%,\n    rgba(0, 0, 0, 0.02) 100%\n  );\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08),\n    0 1px 8px 0 rgba(0, 0, 0, 0.05);\n}\n.dark.str-chat .str-chat__message-actions-box button {\n  color: white;\n}\n.dark.str-chat .str-chat__message-actions-box button:hover {\n  color: #006cff;\n}\n\n[class*=' rfu-'],\n[class^='rfu-'] {\n  font-family: Avenir, Arial, Helvetica, sans-serif;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.rfu-file-icon--small.svg-inline--fa {\n  color: #414d54;\n}\n\n.rfu-file-icon--small.fa-file-excel {\n  color: #207245;\n}\n\n.rfu-file-icon--small.fa-file-powerpoint {\n  color: #cb4a32;\n}\n\n.rfu-file-icon--small.fa-file-word {\n  color: #2c599d;\n}\n\n.rfu-file-icon--small.fa-file-pdf {\n  color: #f82903;\n}\n\n.rfu-file-previewer {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 8px 0;\n  position: relative;\n}\n\n.rfu-file-previewer ol {\n  position: relative;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.rfu-file-previewer ol li {\n  position: relative;\n  padding: 8px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.rfu-file-previewer ol li:last-child {\n  border-color: transparent;\n}\n\n.rfu-file-previewer__file {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.rfu-file-previewer__file:hover {\n  background: #fafafa;\n}\n\n.rfu-file-previewer__file a {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  margin: 0 8px;\n  color: #414d54;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rfu-file-previewer__file svg {\n  min-width: 25px;\n}\n\n.rfu-file-previewer__file--uploading {\n  opacity: 0.4;\n}\n\n.rfu-file-previewer__file--failed a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #8b9297;\n}\n\n.rfu-file-previewer__file--failed a:after {\n  text-decoration: none;\n}\n\n.rfu-file-previewer__image {\n  min-width: 25px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.rfu-file-previewer__loading-indicator {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.rfu-file-previewer__close-button {\n  position: relative;\n  z-index: 10000;\n}\n\n.rfu-file-previewer__failed {\n  background: #ff6363;\n}\n\n.rfu-file-previewer__failed,\n.rfu-file-previewer__retry {\n  padding: 3px 6px;\n  margin-left: 8px;\n  color: #fff;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.rfu-file-previewer__retry {\n  text-decoration: none;\n  background: #63e5a4;\n}\n\n.rfu-file-upload-button {\n  cursor: pointer;\n}\n\n.rfu-file-upload-button svg {\n  fill: #a0b2b8;\n}\n\n.rfu-file-upload-button:hover svg {\n  fill: #88979c;\n}\n\n.rfu-file-upload-button label {\n  cursor: pointer;\n}\n\n.rfu-file-upload-button .rfu-file-input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.rfu-icon-button {\n  cursor: pointer;\n  position: relative;\n  padding: 4px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rfu-icon-button svg {\n  margin: 4px;\n  position: relative;\n  z-index: 50;\n  fill: #a0b2b8;\n}\n\n.rfu-icon-button:hover svg {\n  fill: #88979c;\n}\n\n.rfu-dropzone .rfu-dropzone__notifier {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  padding: 30px;\n  z-index: 90;\n  display: none;\n  border-radius: 4px;\n}\n\n.rfu-dropzone--accept .rfu-dropzone__notifier {\n  background: rgba(0, 212, 106, 0.83);\n  display: block;\n}\n\n.rfu-dropzone--reject .rfu-dropzone__notifier {\n  background: rgba(255, 0, 0, 0.83);\n  display: block;\n}\n\n.rfu-dropzone__inner {\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  border: 1px dashed #fff;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  color: #fff;\n  font-weight: 800;\n  font-size: 12px;\n}\n\n.rfu-dropzone--reject .rfu-dropzone__inner {\n  display: none;\n}\n\n.rfu-image-previewer {\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin: 8px 0;\n}\n\n.rfu-image-previewer,\n.rfu-image-previewer__image {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.rfu-image-previewer__image {\n  width: 100px;\n  height: 100px;\n  position: relative;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rfu-image-previewer__image--loaded .rfu-thumbnail__overlay {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(rgba(0, 0, 0, 0.4)),\n    to(transparent)\n  );\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0, transparent);\n}\n\n.rfu-image-previewer__image .rfu-thumbnail__wrapper {\n  position: absolute;\n}\n\n.rfu-image-previewer__image .rfu-loading-indicator {\n  position: absolute;\n  z-index: 90;\n}\n\n.rfu-image-previewer__retry {\n  z-index: 90;\n}\n\n.rfu-image-upload-button {\n  cursor: pointer;\n}\n\n.rfu-image-upload-button svg {\n  fill: #a0b2b8;\n}\n\n.rfu-image-upload-button:hover svg {\n  fill: #88979c;\n}\n\n.rfu-image-upload-button label {\n  cursor: pointer;\n}\n\n.rfu-image-upload-button .rfu-image-input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.rfu-loading-indicator {\n  margin: 0 auto;\n  width: 70px;\n  text-align: center;\n}\n\n.rfu-loading-indicator > div {\n  width: 18px;\n  height: 18px;\n  background-color: #ccc;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s ease-in-out infinite both;\n  animation: sk-bouncedelay 1.4s ease-in-out infinite both;\n}\n\n.rfu-loading-indicator .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.rfu-loading-indicator .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%,\n  80%,\n  to {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes sk-bouncedelay {\n  0%,\n  80%,\n  to {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@-webkit-keyframes spinner {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n\n@keyframes spinner {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n\n.rfu-loading-indicator__spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #eee;\n  border-top-color: #00d46a;\n  border-radius: 50%;\n  -webkit-animation: spinner 0.6s linear infinite;\n  animation: spinner 0.6s linear infinite;\n}\n\n.rfu-thumbnail__wrapper {\n  width: 100px;\n  height: 100px;\n  border-radius: 4px;\n  overflow: hidden;\n  position: relative;\n}\n\n.rfu-thumbnail__overlay {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.4);\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  padding: 5px;\n}\n\n.rfu-thumbnail__image {\n  width: inherit;\n  height: inherit;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.rfu-thumbnail-placeholder {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 100px;\n  height: 100px;\n  border: 1px dashed #bfbfbf;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.rfu-thumbnail-placeholder:hover {\n  background: #f2f2f2;\n}\n\n.str-chat__attachment {\n  max-width: 450px;\n}\n\n.str-chat__player-wrapper {\n  position: relative;\n  padding-top: 56.25%;\n  /* Player ratio: 100 / (1280 / 720) */\n}\n.str-chat__player-wrapper .react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n/* border radius for attachments */\n.str-chat__message .str-chat__player-wrapper .react-player {\n  border-radius: 16px 16px 16px 0;\n  overflow: hidden;\n}\n\n.str-chat__message--me .str-chat__player-wrapper .react-player {\n  border-radius: 16px 16px 0 16px;\n  overflow: hidden;\n}\n\n.str-chat__message-attachment {\n  width: 100%;\n  max-width: 375px;\n  border-radius: 16px;\n  margin: 8px auto 8px 0;\n  padding: 0;\n}\n\n.str-chat__message--me .str-chat__message-attachment {\n  padding-left: 0;\n  margin: 8px 0 8px auto;\n}\n\n.str-chat__message-team.thread-list .str-chat__message-attachment {\n  max-width: 200px;\n}\n\n.str-chat__message-attachment {\n  overflow: hidden;\n}\n.str-chat__message-attachment:hover {\n  background: transparent;\n}\n.str-chat__message-attachment--card--no-image {\n  height: 60px;\n}\n.str-chat__message-attachment--card--actions {\n  height: auto;\n}\n.str-chat__message-attachment-file {\n  width: 100%;\n}\n.str-chat__message-attachment-file--item {\n  /* border: 3px solid #f7f7f7; */\n  /* border-radius: 4px; */\n  position: relative;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  line-height: 22px;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  width: auto;\n  padding-left: 5px;\n}\n.str-chat__message-attachment-file--item:hover {\n  background: #f7f7f7;\n}\n.str-chat__message-attachment-file--item img,\n.str-chat__message-attachment-file--item svg {\n  margin-right: 10px;\n}\n.str-chat__message-attachment-file--item-text {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.str-chat__message-attachment-file--item a {\n  font-weight: 700;\n  color: black;\n  opacity: 0.8;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n.str-chat__message-attachment-file--item a::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.str-chat__message-attachment-file--item span {\n  line-height: 14px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  display: block;\n  color: black;\n  opacity: 0.5;\n}\n.str-chat__message-attachment--image {\n  height: auto;\n  max-height: 300px;\n  max-width: 100%;\n  border-radius: 0;\n}\n.str-chat__message-attachment--image:hover {\n  background: transparent;\n}\n.str-chat__message-attachment--image img {\n  height: inherit;\n  width: auto;\n  max-height: inherit;\n  max-width: 100%;\n  display: block;\n  object-fit: cover;\n  overflow: hidden;\n}\n.str-chat__message-attachment--image img:hover {\n  background: transparent;\n}\n.str-chat__message-attachment--image--actions {\n  height: 320px;\n}\n.str-chat__message-attachment--image--actions img {\n  height: calc(320px - 40px);\n}\n.str-chat__message-attachment--media {\n  width: 300px;\n}\n.str-chat__message-attachment-card {\n  min-height: 60px;\n}\n\n.str-chat__message-attachment-card__giphy-logo {\n  height: 20px;\n  width: auto;\n}\n\n.messaging.str-chat\n  .str-chat__message-attachment.str-chat__message-attachment--image--actions\n  .str-chat__message-attachment--img {\n  max-height: 254px;\n}\n\n.livestream.str-chat\n  .str-chat__message-attachment.str-chat__message-attachment--file {\n  max-width: 100%;\n}\n.livestream.str-chat\n  .str-chat__message-attachment.str-chat__message-attachment--file\n  .str-chat__message-attachment-file--item {\n  border-left: none;\n}\n.livestream.str-chat\n  .str-chat__message-attachment.str-chat__message-attachment--file\n  .str-chat__message-attachment-file--item:hover {\n  background: rgba(255, 255, 255, 0.29);\n}\n\n.livestream.str-chat.dark .str-chat__message-attachment-file--item a,\n.livestream.str-chat.dark .str-chat__message-attachment-file--item span {\n  color: white;\n}\n\n.livestream.str-chat.dark .str-chat__message-attachment-file--item:hover {\n  background: transparent;\n}\n\n.str-chat__message-attachment-actions-form {\n  width: 100%;\n  margin: 8px 0;\n  padding: 0;\n  display: flex;\n}\n\n.str-chat__message-attachment-actions-button {\n  flex: 1;\n  border: none;\n  background: none;\n  margin: 0 4px;\n  padding: 8px 8px;\n  border-radius: 100px;\n  outline: none;\n}\n.str-chat__message-attachment-actions-button:focus {\n  border: 1px solid #006cff;\n  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n.str-chat__message-attachment-actions-button--primary {\n  background-color: #006cff;\n  color: white;\n}\n.str-chat__message-attachment-actions-button--default {\n  border: 2px solid rgba(0, 0, 0, 0.08);\n}\n\n.dark.str-chat .str-chat__message-attachment-actions-button {\n  color: white;\n}\n.dark.str-chat .str-chat__message-attachment-actions-button--default {\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.str-chat__message-attachment-card {\n  position: relative;\n  background: white;\n  border-radius: 16px 16px 16px 0;\n  overflow: hidden;\n  font-size: 13px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  margin: 32px 0 0 0;\n}\n.str-chat__message-attachment-card--header {\n  width: 100%;\n  height: 175px;\n}\n.str-chat__message-attachment-card--header img {\n  width: inherit;\n  height: inherit;\n  object-fit: cover;\n}\n.str-chat__message-attachment-card--title {\n  font-weight: 700;\n  flex: 1;\n}\n.str-chat__message-attachment-card--flex {\n  min-width: 0px;\n}\n.str-chat__message-attachment-card--flex,\n.str-chat__message-attachment-card--flex > * {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.str-chat__message-attachment-card--content {\n  padding: 8px 16px;\n  margin: -8px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.str-chat__message-attachment-card--content > * {\n  margin: 8px 0;\n}\n.str-chat__message-attachment-card--url {\n  text-decoration: none;\n  display: block;\n  color: black;\n  text-transform: uppercase;\n  opacity: 0.5;\n}\n.str-chat__message-attachment-card--url::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.str-chat__message-attachment-card--giphy\n  .str-chat__message-attachment-card--header {\n  height: unset;\n}\n\n.str-chat.commerce .str-chat__message-attachment-card {\n  max-width: 375px;\n  width: 100%;\n}\n\n.str-chat__message--me .str-chat__message-attachment-card {\n  background: rgba(0, 0, 0, 0.08);\n  border: 1px solid transparent;\n  border-radius: 16px 16px 0 16px;\n}\n\n.dark.str-chat .str-chat__message-attachment-card__giphy-logo {\n  filter: invert(100%);\n}\n\n.str-chat__avatar {\n  flex: 0 0 32px !important;\n  font-size: 16px !important;\n  height: 32px !important;\n  line-height: 32px !important;\n  margin-right: 14px !important;\n  width: 32px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  text-transform: uppercase;\n  overflow: hidden;\n}\n.str-chat__avatar--circle {\n  border-radius: 50%;\n}\n.str-chat__avatar--rounded {\n  border-radius: 6px;\n}\n.str-chat__avatar--square {\n  border-radius: 0;\n}\n.str-chat__avatar-image,\n.str-chat__avatar-fallback {\n  display: block;\n  width: inherit;\n  height: inherit;\n  object-fit: cover;\n  text-align: center;\n}\n.str-chat__avatar-image--loaded {\n  background-color: none;\n}\n.str-chat__avatar-fallback {\n  background-color: #006cff;\n}\n\n.str-chat__message--me > .str-chat__avatar {\n  order: 1;\n  margin: 0;\n  margin-left: 10px;\n}\n\n.str-chat__li--top .str-chat__message > .str-chat__avatar,\n.str-chat__li--middle .str-chat__message > .str-chat__avatar {\n  visibility: hidden;\n}\n\n.str-chat__header {\n  display: flex;\n  padding: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__header-thread {\n  display: flex;\n  padding: 10px;\n  min-height: 70px;\n  align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background: #fff;\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.07);\n  font-size: 14px;\n}\n.str-chat__header-thread__back-button {\n  padding: 10px 10px 10px 10px;\n  border: 0;\n  background: none;\n  transform: rotate(180deg);\n}\n.str-chat__header-livestream {\n  padding: 10px 40px;\n  min-height: 70px;\n  display: flex;\n  align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background: #fff;\n  /* box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.07); */\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);\n}\n.str-chat__header-livestream-left {\n  font-size: 14px;\n  flex: 1;\n}\n.str-chat__header-livestream-left--title {\n  font-weight: 700;\n  margin: 0;\n}\n.str-chat__header-livestream-left--members {\n  font-weight: 400;\n  margin: 0;\n}\n.str-chat__header-livestream-left--livelabel {\n  position: relative;\n  left: 5px;\n  font-size: 13px;\n  text-transform: uppercase;\n  color: red;\n  display: inline-block;\n  animation: pulse 2s infinite;\n}\n.str-chat__header-livestream-left--livelabel::before {\n  content: '';\n  position: relative;\n  top: -2px;\n  left: -4px;\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  border-radius: 100%;\n  background-color: red;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n.str-chat__header-livestream-right {\n  display: flex;\n  margin: 0 -5px;\n}\n.str-chat__header-livestream-right-button-wrapper {\n  position: relative;\n}\n\n.str-chat__header .str-chat__avatar {\n  margin: 0 16px 0 0;\n}\n\n.str-chat__title {\n  font-weight: 600;\n}\n\n.str-chat__meta {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.str-chat__info {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.4);\n}\n\n.str-chat__square-button {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  width: 30px;\n  height: 30px;\n  margin: 0 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.str-chat__square-button svg {\n  fill: rgba(0, 0, 0, 0.8);\n}\n.str-chat__square-button:active {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.dark.str-chat .str-chat__square-button {\n  background: rgba(255, 255, 255, 0.07);\n  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.69);\n  border-radius: 3px;\n}\n.dark.str-chat .str-chat__square-button svg {\n  fill: rgba(255, 255, 255, 0.7);\n}\n\n.messaging.str-chat .str-chat__header-livestream {\n  position: relative;\n  z-index: 1;\n  border-radius: 10px 10px 0 0;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: none;\n  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);\n}\n\n@media screen and (max-width: 960px) {\n  .messaging.str-chat .str-chat__header-livestream {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n\n.messaging.str-chat.dark .str-chat__header-livestream {\n  background: rgba(46, 48, 51, 0.98);\n  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);\n  border-radius: 10px 10px 0 0;\n  color: white;\n}\n\n.livestream.str-chat .str-chat__header-livestream {\n  position: relative;\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.29);\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);\n}\n\n.livestream.str-chat.dark .str-chat__header-livestream {\n  background: rgba(255, 255, 255, 0.03);\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.34);\n}\n.livestream.str-chat.dark .str-chat__header-livestream-left--title,\n.livestream.str-chat.dark .str-chat__header-livestream-left--members {\n  color: white;\n}\n.livestream.str-chat.dark .str-chat__header-livestream-left--title {\n  font-size: 15px;\n}\n\n.commerce.str-chat .str-chat__header-livestream {\n  background: rgba(255, 255, 255, 0.81);\n  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);\n  border-radius: 10px 10px 0 0;\n  padding: 25px;\n}\n.commerce.str-chat .str-chat__header-livestream-left--title {\n  font-size: 25px;\n  margin: 0;\n  line-height: 1;\n  font-weight: 400;\n}\n.commerce.str-chat .str-chat__header-livestream-left--subtitle {\n  margin: 8px 0;\n  font-size: 15px;\n}\n.commerce.str-chat .str-chat__header-livestream-left--members {\n  display: none;\n}\n.commerce.str-chat .str-chat__header-livestream-right-button--info {\n  display: none;\n}\n\n.commerce.str-chat.dark .str-chat__header-livestream {\n  background: rgba(44, 47, 51, 0.81);\n  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);\n  border-radius: 10px 10px 0 0;\n  color: white;\n}\n\n.team.str-chat.dark .str-chat__header-livestream {\n  background: rgba(38, 40, 43, 0.9);\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.26);\n}\n.team.str-chat.dark .str-chat__header-livestream-left {\n  color: white;\n}\n.team.str-chat.dark .str-chat__header-livestream-left--title {\n  font-size: 18px;\n}\n.team.str-chat.dark .str-chat__header-livestream-left--members {\n  font-size: 13px;\n}\n\n.str-chat__header-hamburger {\n  width: 30px;\n  height: 40px;\n  padding: 10px 10px 10px 0px;\n  margin-right: 10px;\n  display: none;\n  flex-direction: column;\n  justify-content: space-around;\n  cursor: pointer;\n}\n.str-chat__header-hamburger:hover .str-chat__header-hamburger--line {\n  background: #006cff;\n}\n@media screen and (max-width: 960px) {\n  .str-chat__header-hamburger {\n    display: flex;\n  }\n}\n\n.str-chat__header-hamburger--line {\n  width: 100%;\n  height: 2px;\n  background: #bcd8ff;\n  border-radius: 2px;\n}\n\n.str-chat__audio__wrapper {\n  height: 80px;\n  overflow: hidden;\n  position: relative;\n  border-radius: 6px;\n  margin: 0;\n  display: flex;\n  background: #f1f1f1;\n}\n\n.str-chat__audio__image {\n  height: 80px;\n  width: 80px;\n  position: relative;\n  z-index: 20;\n}\n.str-chat__audio__image--overlay {\n  width: inherit;\n  height: inherit;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 30;\n  font-size: 3em;\n  color: rgba(255, 255, 255, 0.69);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n}\n.str-chat__audio__image--button {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n}\n.str-chat__audio__image--button svg {\n  fill: rgba(255, 255, 255, 0.69);\n}\n.str-chat__audio__image img {\n  z-index: 20;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: inherit;\n  height: inherit;\n  object-fit: cover;\n}\n\n.str-chat__audio__content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 8px 16px;\n  margin-left: 16px;\n  width: 100%;\n}\n.str-chat__audio__content--title {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n}\n.str-chat__audio__content--subtitle {\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  font-size: 12px;\n  opacity: 0.49;\n}\n.str-chat__audio__content--progress {\n  height: 6px;\n  width: 100%;\n  border-radius: 4px;\n  background: rgba(0, 0, 0, 0.1);\n  padding: 1px;\n  margin: 2px 0;\n}\n.str-chat__audio__content--progress > div {\n  height: 4px;\n  border-radius: 4px;\n  width: 0%;\n  background: #006cff;\n  transition: width 0.5s linear;\n}\n\n.str-chat.dark .str-chat__audio__wrapper {\n  background: #1a1a1a;\n  color: white;\n}\n\n.str-chat.dark .str-chat__audio__content--progress {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.str-chat__channel-list {\n  /* min-height: 667px; */\n  flex: 1;\n  overflow-y: auto;\n  max-width: 320px;\n  background: #f2f3f5;\n  display: flex;\n  flex-direction: column;\n}\n.str-chat__channel-list--channels {\n  flex: 1;\n}\n.str-chat__channel-list .channel_preview {\n  padding: 8px 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.str-chat__button {\n  background: #fff;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09);\n  font-size: 14px;\n  padding: 14px 70px;\n  color: #006cff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(100% - 10px);\n  margin: 5px;\n  border: 1px solid transparent;\n}\n.str-chat__button:active,\n.str-chat__button:focus {\n  outline: none;\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09),\n    0 0 0 2px rgba(0, 108, 255, 0.36);\n  border: 1px solid #006cff;\n}\n.str-chat__button > * {\n  margin: 0 5px;\n}\n.str-chat__button--round {\n  border-radius: 100px;\n}\n\n.str-chat-channel-checkbox {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 100001;\n}\n\n.str-chat-channel-list-burger {\n  width: 10px;\n  height: 50px;\n  background: white;\n  border-radius: 0 4px 4px 0;\n  padding: 3px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.09);\n  position: fixed;\n  top: 10px;\n  left: 0;\n  z-index: 10000;\n  justify-content: center;\n  cursor: pointer;\n}\n.str-chat-channel-list-burger div {\n  width: 4px;\n  height: 100%;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n@media screen and (max-width: 960px) {\n  .str-chat-channel-list-burger {\n    display: flex;\n  }\n  .str-chat-channel-list.messaging,\n  .str-chat-channel-list.team,\n  .str-chat-channel-list.commerce {\n    position: fixed;\n    left: -380px;\n    top: 0;\n    z-index: 1001;\n    min-height: 100vh;\n    overflow-y: auto;\n    box-shadow: 7px 0 9px 0 rgba(0, 0, 0, 0.03), 1px 0 0 0 rgba(0, 0, 0, 0.03);\n    transition: left 200ms ease-in-out;\n  }\n  .str-chat-channel-list--open.messaging,\n  .str-chat-channel-list--open.team,\n  .str-chat-channel-list--open.commerce {\n    left: 0px;\n  }\n}\n\n.str-chat-channel-list .str-chat__channel-list-messenger {\n  padding: 0;\n}\n.str-chat-channel-list .str-chat__channel-list-messenger__main {\n  padding: 20px 10px 0 10px;\n  height: 100%;\n  overflow-y: auto;\n}\n\n.str-chat__channel-list-messenger {\n  padding: 20px 10px 0 10px;\n  min-width: 300px;\n  height: 100%;\n}\n\n.str-chat__channel-list-messenger {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: flex;\n  height: 100%;\n  overflow-y: auto;\n}\n.str-chat__channel-list-messenger__sidebar {\n  display: flex;\n  flex-direction: column;\n  width: 70px;\n  padding: 45px 10px 10px;\n  background: #dedfe2;\n}\n.str-chat__channel-list-messenger__sidebar--top {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: -10px 0;\n}\n.str-chat__channel-list-messenger__sidebar--top > * {\n  margin: 10px 0;\n}\n.str-chat__channel-list-messenger__sidebar--bottom {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.str-chat__channel-list-messenger__send-button,\n.str-chat__channel-list-messenger__search-button {\n  background: none;\n  margin: none;\n  border: none;\n}\n.str-chat__channel-list-messenger__main {\n  min-width: 230px;\n  background: #f1f1f3;\n}\n.str-chat__channel-list-messenger__header {\n  padding: 15px 15px 15px 20px;\n  max-height: 70px;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.01);\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);\n  font-size: 14px;\n  color: #000;\n  letter-spacing: 0;\n  position: relative;\n}\n.str-chat__channel-list-messenger__header--title {\n  font-weight: 700;\n  text-transform: capitalize;\n}\n.str-chat__channel-list-messenger__header--status {\n  position: relative;\n  padding: 0 0 0 10px;\n}\n.str-chat__channel-list-messenger__header--status::before {\n  position: absolute;\n  top: 5px;\n  left: 0;\n  content: ' ';\n  width: 6px;\n  height: 6px;\n  border-radius: 10px;\n}\n.str-chat__channel-list-messenger__header--status.watcher_count::before {\n  background: #28ca42;\n}\n.str-chat__channel-list-messenger__header--status.busy::before {\n  background: #28ca42;\n}\n.str-chat__channel-list-messenger__header--status.away::before {\n  background: #28ca42;\n}\n.str-chat__channel-list-messenger__header--left {\n  width: 40px;\n}\n.str-chat__channel-list-messenger__header--middle {\n  flex: 1;\n  margin-left: 15px;\n}\n.str-chat__channel-list-messenger__header--button {\n  margin: 0;\n  padding: 15px 5px;\n  border: 0;\n  background: none;\n}\n\n.messenger-chat.str-chat .str-chat__channel-list-messenger {\n  padding: 0 0 0 10px;\n}\n.messenger-chat.str-chat .str-chat__channel-list-messenger__header {\n  background: none;\n  box-shadow: none;\n}\n.messenger-chat.str-chat .str-chat__channel-list-messenger__main {\n  background: none;\n}\n\n.dark.str-chat .str-chat__channel-list-messenger {\n  background: #1d1f22;\n}\n.dark.str-chat .str-chat__channel-list-messenger__header--title {\n  color: white;\n}\n.dark.str-chat .str-chat__channel-list-messenger__sidebar {\n  background: rgba(0, 0, 0, 0.2);\n}\n.dark.str-chat .str-chat__channel-list-messenger__main {\n  background: none;\n}\n\n.str-chat__down {\n  display: flex;\n  height: 100%;\n}\n.str-chat__down-main {\n  flex: 1;\n  padding: 30px;\n}\n\n.dark.str-chat .str-chat__down {\n  color: rgba(255, 255, 255, 0.87);\n}\n\n.str-chat__channel-search {\n  margin: 10px;\n  margin-bottom: 30px;\n  display: flex;\n  align-items: center;\n}\n.str-chat__channel-search input {\n  flex: 1;\n  background: rgba(0, 0, 0, 0.05);\n  margin-right: 20px;\n  border: 1px solid transparent;\n  outline: none;\n  height: 30px;\n  border-radius: 15px;\n  color: black;\n  font-size: 14px;\n  padding: 0 10px;\n}\n.str-chat__channel-search input::placeholder {\n  color: gray;\n}\n.str-chat__channel-search input:focus {\n  background: white;\n  border: 1px solid #006cff;\n  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n.str-chat__channel-search button {\n  margin: 0;\n  padding: 0 0 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12), 0 1px 4px 0 rgba(0, 0, 0, 0.09);\n  cursor: pointer;\n  outline: 0;\n}\n.str-chat__channel-search button:focus {\n  background: white;\n  border: 1px solid #006cff;\n  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n.str-chat__channel-search button svg {\n  fill: #006cff;\n  transform: translateX(2px);\n}\n\n.dark.str-chat .str-chat__channel-search input {\n  background: rgba(255, 255, 255, 0.04);\n  color: white;\n}\n\n.dark.str-chat .str-chat__channel-search button {\n  background: #006cff;\n}\n.dark.str-chat .str-chat__channel-search button svg {\n  fill: white;\n}\n\n.str-chat.messaging .str-chat__event-component__channel-event {\n  display: flex;\n  margin-top: 20px;\n}\n.str-chat.messaging .str-chat__event-component__channel-event__content {\n  margin-right: 10px;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 15px;\n}\n.str-chat.messaging .str-chat__event-component__channel-event__date {\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.str-chat.team .str-chat__event-component__channel-event {\n  display: flex;\n  margin: 20px 40px;\n}\n.str-chat.team .str-chat__event-component__channel-event__content {\n  margin-right: 10px;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 15px;\n}\n.str-chat.team .str-chat__event-component__channel-event__date {\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.str-chat.commerce .str-chat__event-component__channel-event,\n.str-chat.livestream .str-chat__event-component__channel-event {\n  display: none;\n}\n\n.vesta-preview button {\n  align-items: center;\n  background: none;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  border: none;\n  display: flex;\n  flex-direction: row;\n  font-size: 13px;\n  margin: 0;\n  outline: 0;\n  overflow: hidden;\n  padding: 10px 40px 10px 10px;\n  position: relative;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 100%;\n}\n.vesta-preview button:focus {\n  background: white;\n  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n\n.str-chat__channel-preview-messenger--right {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  padding: 0 10px;\n  max-width: 250px;\n}\n\n.str-chat__channel-preview-avatar {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  border-radius: 18px;\n}\n\n.str-chat__channel-preview-end-first-row {\n  color: black;\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.str-chat__channel-preview-unread-badge {\n  position: absolute;\n  right: 10px;\n  width: 22px;\n  height: 22px;\n  color: black;\n  font-size: 12px;\n  background: lightgray;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n}\n\n.str-chat__channel-preview-messenger--last-message p {\n  color: gray;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin: 0;\n  max-width: 120px;\n}\n\n.str-chat__channel-preview--active {\n  background: #006cff;\n  color: white;\n}\n.str-chat__channel-preview--active .str-chat__channel-preview-end-first-row {\n  color: white;\n}\n.str-chat__channel-preview--active\n  .str-chat__channel-preview-messenger--last-message\n  p {\n  color: rgba(255, 255, 255, 0.69);\n}\n\n.str-chat__channel-preview-messenger--unread {\n  position: relative;\n}\n.str-chat__channel-preview-messenger--unread\n  .str-chat__channel-preview-messenger--last-message\n  p {\n  font-weight: 700;\n  color: black;\n}\n\n.str-chat__channel-preview--dot {\n  width: 5px;\n  height: 5px;\n  position: absolute;\n  border-radius: 50%;\n  left: 2px;\n  background-color: magenta;\n}\n\n.str-chat__channel-preview-compact {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: flex;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 40px;\n  color: black;\n  position: relative;\n  border: none;\n  background: none;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  padding: 0 40px 0 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  text-align: left;\n  outline: 0;\n}\n.str-chat__channel-preview-compact:focus {\n  background: white;\n  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n.str-chat__channel-preview-compact--left {\n  width: 22px;\n  height: 22px;\n}\n.str-chat__channel-preview-compact--right {\n  flex: 1;\n  margin-left: 11px;\n}\n.str-chat__channel-preview-compact--unread {\n  font-weight: 700;\n}\n\n.str-chat__channel-preview-compact--active {\n  color: white;\n  background: #004ab3;\n}\n\n.str-chat__channel-preview-messenger {\n  display: flex;\n  width: 100%;\n  border: none;\n  padding: 10px;\n  align-items: center;\n  background: rgba(255, 255, 255, 0);\n  text-align: left;\n  margin: 5px 0;\n}\n.str-chat__channel-preview-messenger--active {\n  border: none;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: none;\n}\n.str-chat__channel-preview-messenger--last-message {\n  font-size: 13px;\n  line-height: 14px;\n  opacity: 0.5;\n}\n.str-chat__channel-preview-messenger--name {\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 600;\n  max-width: 250px;\n}\n.str-chat__channel-preview-messenger--name span {\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.str-chat__channel-preview-messenger--unread\n  .str-chat__channel-preview-messenger--last-message {\n  opacity: 1;\n  font-weight: 600;\n}\n\n.dark.str-chat .str-chat__channel-preview--active {\n  background: #132d50;\n}\n\n.dark.str-chat .str-chat__channel-preview-end-first-row {\n  color: white;\n}\n\n.dark.str-chat .str-chat__channel-preview button:focus {\n  background: #132d50;\n  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n\n.dark.str-chat .str-chat__channel-preview-messenger--active {\n  background: rgba(255, 255, 255, 0.06);\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.07);\n}\n\n.dark.str-chat .str-chat__channel-preview-messenger--last-message {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.dark.str-chat .str-chat__channel-preview-messenger--name {\n  color: white;\n}\n\n.str-chat__date-separator {\n  display: flex;\n  margin: 40px;\n  align-items: center;\n}\n.str-chat__date-separator-date {\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.7);\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.str-chat__date-separator-line {\n  flex: 1;\n  background-color: rgba(0, 0, 0, 0.1);\n  height: 1px;\n  border: none;\n}\n.str-chat__date-separator > *:not(:last-child) {\n  margin-right: 20px;\n}\n\n.commerce.str-chat .str-chat__date-separator {\n  margin: 40px 0;\n}\n\n.dark.str-chat .str-chat__date-separator-line {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.dark.str-chat .str-chat__date-separator-date {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.dark.str-chat.team .str-chat__date-separator-line {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.str-chat__edit-message-form {\n  width: 100%;\n}\n.str-chat__edit-message-form form {\n  position: relative;\n  width: 100%;\n}\n.str-chat__edit-message-form textarea {\n  padding: 7px;\n  background: #fff;\n  box-shadow: inset 0 0 0 1px #006cff;\n  border: 1px solid transparent;\n  resize: none;\n  border-radius: 5px;\n  width: 100%;\n  font-size: 15px;\n  line-height: 22px;\n  /* color: $fontColor; */\n}\n.str-chat__edit-message-form textarea:focus {\n  box-shadow: inset 0 0 0 1px #006cff, 0 0 0 2px rgba(0, 108, 255, 0.36);\n  outline: 0;\n}\n.str-chat__edit-message-form button {\n  background: none;\n  border: none;\n  /* font-size: $fontSize; */\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.4);\n}\n.str-chat__edit-message-form button[type='submit'] {\n  color: #006cff;\n}\n.str-chat__edit-message-form .rfu-dropzone {\n  width: 100%;\n}\n.str-chat__edit-message-form .rfu-file-upload-button,\n.str-chat__edit-message-form .str-chat__input-emojiselect,\n.str-chat__edit-message-form .str-chat__input-fileupload {\n  position: unset;\n  top: unset;\n  right: unset;\n  left: unset;\n}\n.str-chat__edit-message-form .rfu-file-upload-button svg,\n.str-chat__edit-message-form .str-chat__input-emojiselect svg,\n.str-chat__edit-message-form .str-chat__input-fileupload svg {\n  fill: black;\n  opacity: 0.5;\n}\n.str-chat__edit-message-form .rfu-file-upload-button:hover svg,\n.str-chat__edit-message-form .str-chat__input-emojiselect:hover svg,\n.str-chat__edit-message-form .str-chat__input-fileupload:hover svg {\n  opacity: 1;\n}\n\n.str-chat__edit-message-form-options {\n  display: flex;\n}\n\n.str-chat.dark .str-chat__edit-message-form .rfu-file-upload-button svg,\n.str-chat.dark .str-chat__edit-message-form .str-chat__input-emojiselect svg {\n  fill: white;\n}\n\n.str-chat.dark .str-chat__edit-message-form button {\n  color: rgba(255, 255, 255, 0.4);\n}\n.str-chat.dark .str-chat__edit-message-form button[type='submit'] {\n  color: #006cff;\n}\n\n.str-chat.dark .str-chat__edit-message-form textarea {\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.21);\n  border: 2px solid transparent;\n  border-radius: 6px;\n  color: white;\n}\n.str-chat.dark .str-chat__edit-message-form textarea:focus {\n  box-shadow: inset 0 0 0 1px #006cff;\n  border: 2px solid rgba(0, 108, 255, 0.36);\n  border-radius: 6px;\n}\n\n.str-chat__gallery {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n.str-chat__gallery-image {\n  /* flex: 1; x */\n  width: 150px;\n  height: 150px;\n  background: white;\n  margin-bottom: 1px;\n  margin-right: 1px;\n}\n.str-chat__gallery-image:hover {\n  cursor: -moz-zoom-in;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n.str-chat__gallery-image img {\n  width: inherit;\n  height: inherit;\n  object-fit: cover;\n}\n.str-chat__gallery--square {\n  max-width: 301px;\n}\n.str-chat__gallery--square .str-chat__gallery-image:nth-child(even) {\n  margin-right: 0;\n}\n\n.livestream.str-chat .str-chat__gallery,\n.messaging.str-chat .str-chat__gallery,\n.commerce.str-chat .str-chat__gallery,\n.team.str-chat .str-chat__gallery {\n  margin: 5px 0;\n}\n.livestream.str-chat .str-chat__gallery-image,\n.messaging.str-chat .str-chat__gallery-image,\n.commerce.str-chat .str-chat__gallery-image,\n.team.str-chat .str-chat__gallery-image {\n  width: 150px;\n  height: 150px;\n}\n.livestream.str-chat .str-chat__gallery-placeholder,\n.messaging.str-chat .str-chat__gallery-placeholder,\n.commerce.str-chat .str-chat__gallery-placeholder,\n.team.str-chat .str-chat__gallery-placeholder {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-size: cover;\n  background-position: top left;\n  background-repeat: no-repeat;\n  cursor: -moz-zoom-in;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n.livestream.str-chat .str-chat__gallery-placeholder p,\n.messaging.str-chat .str-chat__gallery-placeholder p,\n.commerce.str-chat .str-chat__gallery-placeholder p,\n.team.str-chat .str-chat__gallery-placeholder p {\n  position: relative;\n  z-index: 1;\n}\n.livestream.str-chat .str-chat__gallery-placeholder:after,\n.messaging.str-chat .str-chat__gallery-placeholder:after,\n.commerce.str-chat .str-chat__gallery-placeholder:after,\n.team.str-chat .str-chat__gallery-placeholder:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.69);\n  z-index: 0;\n}\n\n.commerce.str-chat .str-chat__gallery {\n  width: calc(100% - 30px);\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: 100px;\n}\n.commerce.str-chat .str-chat__gallery-image,\n.commerce.str-chat .str-chat__gallery-placeholder {\n  width: 100%;\n  height: 100%;\n}\n\n.commerce.str-chat .str-chat__message-commerce .str-chat__gallery {\n  border-radius: 16px 16px 16px 2px;\n}\n\n.commerce.str-chat .str-chat__message-commerce--right .str-chat__gallery {\n  border-radius: 16px 16px 2px 16px;\n}\n\n.str-chat__infinite-scroll-paginator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n\n.str-chat__loading-channels {\n  width: 300px;\n  height: 100%;\n  padding: 20px;\n  background: #fafafa;\n}\n.str-chat__loading-channels-meta {\n  flex: 1;\n}\n.str-chat__loading-channels-avatar,\n.str-chat__loading-channels-username,\n.str-chat__loading-channels-status {\n  background-image: linear-gradient(-90deg, #f2f2f2 0%, #e5e5e5 100%);\n}\n.str-chat__loading-channels-username,\n.str-chat__loading-channels-status {\n  border-radius: 2px;\n  height: 14px;\n}\n.str-chat__loading-channels-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  margin-right: 10px;\n}\n.str-chat__loading-channels-username {\n  width: 40%;\n  margin-bottom: 6px;\n}\n.str-chat__loading-channels-status {\n  width: 80%;\n}\n.str-chat__loading-channels-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 40px;\n  border-radius: 3px;\n  margin-bottom: 10px;\n  animation: pulsate 1s linear 0s infinite alternate;\n}\n.str-chat__loading-channels-item:nth-of-type(2) {\n  animation: pulsate 1s linear 0.3334 infinite alternate;\n}\n.str-chat__loading-channels-item:last-of-type {\n  animation: pulsate 1s linear 0.6667s infinite alternate;\n}\n\n@keyframes pulsate {\n  from {\n    opacity: 0.5;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.str-chat.messaging .str-chat__load-more-button {\n  border: 0;\n  width: 100%;\n  height: 40px;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: none;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.07);\n  padding: 10px;\n  font-size: 14px;\n}\n\n.str-chat.str-chat-channel-list .str-chat__load-more-button button {\n  border: 0;\n  background: transparent;\n  width: 100%;\n  height: 40px;\n  padding: 10px;\n  font-size: 14px;\n}\n\n.str-chat__loading-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: rotate 1s linear infinite;\n}\n\n@-webkit-keyframes rotate {\n  from {\n    -webkit-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate {\n  from {\n    -ms-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -webkit-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -ms-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.str-chat__message-input {\n  background: #fff;\n  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.05), 0 -1px 0 0 rgba(0, 0, 0, 0.07);\n  display: flex;\n  flex-wrap: wrap;\n  padding: 10px !important;\n  position: relative;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  padding-bottom: 0;\n}\n.str-chat__message-input-large {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n}\n.str-chat__message-input--emojipicker {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n}\n.str-chat__message-input .rfu-dropzone {\n  flex: 1 1 100%;\n}\n.str-chat__message-input--textarea-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 0;\n  position: relative;\n}\n.str-chat__message-input--textarea-wrapper .str-chat__textarea textarea {\n  padding-right: 70px;\n}\n.str-chat__message-input-emojiselect,\n.str-chat__message-input .rfu-file-upload-button {\n  position: absolute;\n  cursor: pointer;\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-size: 44px 44px;\n  fill: rgba(0, 0, 0, 0.6);\n}\n.str-chat__message-input-emojiselect:hover,\n.str-chat__message-input .rfu-file-upload-button:hover {\n  fill: black;\n}\n.str-chat__message-input-emojiselect {\n  right: 20px;\n  top: calc(100% - 35px);\n}\n.str-chat__message-input .rfu-file-upload-button {\n  right: 46px;\n  top: calc(100% - 34px);\n}\n.str-chat__message-input-footer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  background: white;\n  padding: 0 10px 10px 10px;\n  color: gray;\n}\n.str-chat__message-input-footer--typing {\n  font-style: italic;\n}\n.str-chat__message-input-footer--count--hidden {\n  visibility: hidden;\n}\n\n.str-chat__textarea {\n  height: auto;\n  flex: 1;\n}\n.str-chat__textarea textarea {\n  width: 100%;\n  outline: none;\n  padding: 11px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  font-size: 15px;\n  min-height: 42px;\n  transition: height 100ms ease-in;\n  resize: none;\n}\n.str-chat__textarea textarea:focus {\n  background: #fff;\n  border: 1px solid #006cff;\n  box-shadow: 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n.str-chat__textarea textarea:placeholder {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.str-chat__emojisearch {\n  bottom: calc(100%);\n  left: 0;\n  width: calc(100% - 20px);\n  position: absolute;\n  background: rgba(240, 240, 240, 0.95);\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.31), 0 0 6px 0 rgba(0, 0, 0, 0.12);\n  z-index: -1;\n  border-radius: 4px 4px 0 0;\n  margin: 0 10px;\n  max-height: 360px;\n  overflow-y: auto;\n}\n.str-chat__emojisearch__list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  border-radius: 4px 4px 0 0;\n}\n\n.dark.str-chat .str-chat__emojisearch {\n  background: #35373a;\n  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.31), 0 0 6px 0 rgba(0, 0, 0, 0.12);\n  border-radius: 4px 4px 0 0;\n}\n.dark.str-chat .str-chat__emojisearch .rta__list-header {\n  background: #1b1d20;\n  border: 1px solid rgba(224, 224, 224, 0.03);\n  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);\n  color: white;\n}\n.dark.str-chat .str-chat__emojisearch .rta__entity {\n  color: white;\n}\n\n.dark.str-chat .rfu-file-previewer__file a {\n  color: white;\n}\n\n.dark.str-chat .rfu-file-previewer__file:hover {\n  background: transparent;\n}\n\n.dark.str-chat .rfu-file-previewer__close-button {\n  color: white;\n}\n\n.rta {\n  font-size: 14px;\n}\n\n.rta__entity--selected {\n  background-color: #006cff;\n  color: white;\n}\n\n.rta__list {\n  border-radius: 4px 4px 0 0;\n}\n\n.rta__list-header {\n  padding: 15px;\n  font-size: 14px;\n}\n\n.str-chat__emoji-item {\n  padding: 0 20px;\n  display: flex;\n  align-items: center;\n  margin: 0 -8px;\n}\n.str-chat__emoji-item span {\n  display: block;\n}\n.str-chat__emoji-item--entity {\n  min-width: 24px;\n}\n.str-chat__emoji-item--name {\n  font-size: 12px;\n}\n\n.str-chat__slash-command {\n  padding: 10px 15px;\n  font-size: 14px;\n}\n.str-chat__slash-command-description {\n  font-size: 12px;\n}\n\n.str-chat__user-item {\n  padding: 10px 15px;\n  display: flex;\n}\n\n.str-chat .rfu-dropzone .rfu-dropzone__notifier {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  padding: 5px;\n  z-index: 1001;\n  display: none;\n}\n\n.str-chat .rfu-dropzone--accept .rfu-dropzone__notifier {\n  background: rgba(0, 108, 255, 0.7);\n  display: block;\n}\n\n.str-chat .rfu-dropzone--reject .rfu-dropzone__notifier {\n  background: rgba(255, 0, 0, 0.7);\n  display: block;\n}\n\n.rfu-dropzone__inner {\n  width: 100%;\n  height: 100%;\n  padding: 0 30px;\n  border: 1px dashed transparent;\n  box-sizing: border-box;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: white;\n  font-weight: 800;\n  font-size: 12px;\n}\n.rfu-dropzone__inner svg {\n  display: none;\n}\n\n.rfu-dropzone--reject .rfu-dropzone__inner {\n  display: none;\n}\n\n.team.str-chat .str-chat__input,\n.livestream.str-chat .str-chat__input {\n  padding: 10px 40px;\n}\n.team.str-chat .str-chat__input-footer,\n.livestream.str-chat .str-chat__input-footer {\n  padding: 0 40px 10px;\n}\n\n.livestream.str-chat .str-chat__input {\n  position: relative;\n  z-index: 1;\n  background: rgba(255, 255, 255, 0.29);\n  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.1);\n  padding: 10px 20px 5px;\n}\n.livestream.str-chat .str-chat__input textarea {\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.26);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  font-size: 13px;\n  padding: 12px;\n}\n.livestream.str-chat .str-chat__input-footer {\n  padding: 0 20px 10px;\n  background: rgba(255, 255, 255, 0.29);\n}\n\n.str-chat__file-uploads {\n  max-height: 300px;\n  flex: 1 1 100%;\n  overflow-y: auto;\n}\n\n.rfu-file-upload-button svg {\n  fill: rgba(0, 0, 0, 0.6);\n}\n\n.dark.str-chat .str-chat__input {\n  background: rgba(255, 255, 255, 0.03);\n  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.34);\n}\n.dark.str-chat .str-chat__input-footer {\n  background: rgba(255, 255, 255, 0.03);\n}\n.dark.str-chat .str-chat__input textarea {\n  background: rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 0, 0, 0.4);\n  border-radius: 2px;\n  color: white;\n}\n.dark.str-chat .str-chat__input .str-chat__input-emojiselect svg {\n  fill: white;\n}\n.dark.str-chat .str-chat__input .rfu-file-upload-button svg {\n  fill: white;\n}\n\n.str-chat__fileupload-wrapper .str-chat__tooltip {\n  display: none;\n  bottom: 35px;\n  right: 50px;\n}\n\n.str-chat__fileupload-wrapper:hover .str-chat__tooltip {\n  display: block;\n}\n\n.str-chat__emojiselect-wrapper .str-chat__tooltip {\n  display: none;\n  bottom: 35px;\n  right: 24px;\n}\n\n.str-chat__emojiselect-wrapper:hover .str-chat__tooltip {\n  display: block;\n}\n\n.str-chat__small-message-input--textarea-wrapper\n  .str-chat__fileupload-wrapper\n  .str-chat__tooltip {\n  bottom: 32px;\n  right: 32px;\n}\n\n.str-chat__small-message-input--textarea-wrapper\n  .str-chat__emojiselect-wrapper\n  .str-chat__tooltip {\n  bottom: 32px;\n  right: 10px;\n}\n\n.str-chat__input-flat {\n  background: white;\n  padding: 10px 40px;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n}\n.str-chat__input-flat-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n}\n.str-chat__input-flat .str-chat__textarea {\n  flex: 1;\n}\n.str-chat__input-flat .str-chat__textarea > textarea {\n  min-height: 56px;\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: 8px;\n  padding: 20px 69px;\n  font-size: 15px;\n  line-height: 17px;\n  border: none;\n  margin: 0;\n}\n.str-chat__input-flat .str-chat__textarea > textarea:focus {\n  border: none;\n  border-radius: 8px;\n  box-shadow: 0 0 0 3px #006cff;\n}\n.str-chat__input-flat-footer {\n  padding: 10px 40px;\n  background: white;\n}\n.str-chat__input-flat-emojiselect {\n  position: absolute;\n  top: calc(50% - 17px);\n  left: 25px;\n}\n.str-chat__input-flat-emojiselect svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__input-flat-emojiselect svg:hover {\n  opacity: 1;\n}\n.str-chat__input-flat--textarea-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 0;\n  position: relative;\n}\n.str-chat__input-flat--textarea-wrapper\n  .str-chat__fileupload-wrapper\n  .str-chat__tooltip {\n  bottom: 45px;\n  right: 25px;\n}\n.str-chat__input-flat--textarea-wrapper\n  .str-chat__emojiselect-wrapper\n  .str-chat__tooltip {\n  bottom: 50px;\n  left: 32px;\n  right: unset;\n}\n.str-chat__input-flat--textarea-wrapper\n  .str-chat__emojiselect-wrapper\n  .str-chat__tooltip:after {\n  left: 5px;\n  right: unset;\n}\n.str-chat__input--emojipicker {\n  position: absolute;\n  bottom: calc(100%);\n}\n.str-chat__input-flat .rfu-file-previewer {\n  width: 100%;\n}\n.str-chat__input-flat .rfu-file-upload-button {\n  position: absolute;\n  top: calc(50% - 11px);\n  right: 25px;\n}\n.str-chat__input-flat .rfu-file-upload-button svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__input-flat .rfu-file-upload-button svg:hover {\n  opacity: 1;\n}\n\n.rfu-image-previewer {\n  flex: 1 1 100%;\n}\n.rfu-image-previewer__image {\n  width: 60px !important;\n  height: 60px !important;\n}\n.rfu-image-previewer__image .rfu-thumbnail__wrapper {\n  width: 60px !important;\n  height: 60px !important;\n  border-radius: 10px;\n}\n.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-thumbnail__overlay,\n.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-icon-button {\n  padding: 0;\n}\n.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-thumbnail__overlay svg,\n.rfu-image-previewer__image .rfu-thumbnail__wrapper .rfu-icon-button svg {\n  opacity: 0.9;\n  height: 25px;\n  width: 25px;\n}\n.rfu-image-previewer .rfu-thumbnail-placeholder {\n  width: 60px;\n  height: 60px;\n  border-radius: 10px;\n}\n\n.commerce.str-chat .str-chat__input-flat {\n  padding: 10px 22px;\n  background: transparent;\n}\n\n.dark.str-chat .str-chat__input-flat {\n  background: rgba(255, 255, 255, 0.04);\n}\n.dark.str-chat .str-chat__input-flat textarea {\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  color: white;\n}\n.dark.str-chat .str-chat__input-flat-emojiselect svg,\n.dark.str-chat .str-chat__input-flat .rfu-file-upload-button svg {\n  fill: #fff;\n}\n\n.dark.str-chat.commerce .str-chat__input-flat {\n  background: none;\n}\n\n@media screen and (max-width: 960px) {\n  .str-chat.messaging .str-chat__input-flat {\n    padding: 10px 10px;\n  }\n}\n\n.str-chat__list {\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  /* enable smooth scrolling on ios */\n  padding: 75px 0 0 0;\n}\n.str-chat__list-wrapper {\n  flex: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n.str-chat__list--thread {\n  padding: 15px 0 0 0;\n  overflow: visible;\n}\n.str-chat__list__center {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.str-chat__ul {\n  display: block;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.str-chat__custom-notification {\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 8px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  text-align: center;\n}\n.str-chat__custom-notification.notification-success {\n  background: rgba(2, 208, 2, 0.1);\n  border: 1px solid rgba(2, 208, 2, 0.1);\n  color: green;\n}\n.str-chat__custom-notification.notification-error {\n  background: rgba(208, 2, 27, 0.1);\n  border: 1px solid rgba(208, 2, 27, 0.1);\n  color: #f00;\n}\n\n.str-chat__connection-issue {\n  background: rgba(208, 2, 27, 0.1);\n  border: 1px solid rgba(208, 2, 27, 0.1);\n  color: #f00;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 8px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  text-align: center;\n}\n\n.str-chat__list-notifications {\n  padding: 0 40px;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.messaging.str-chat .str-chat__list {\n  padding: 55px 40px 0;\n  background: white;\n}\n.messaging.str-chat .str-chat__list-notifications {\n  background: white;\n}\n\n@media screen and (max-width: 960px) {\n  .messaging.str-chat .str-chat__list {\n    padding: 55px 10px 0;\n  }\n  .messaging.str-chat .str-chat__list-notifications {\n    padding: 0 10px;\n  }\n}\n\n.messaging.str-chat.dark .str-chat__list {\n  background: rgba(255, 255, 255, 0.04);\n}\n.messaging.str-chat.dark .str-chat__list-notifications {\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.livestream.str-chat .str-chat__list {\n  padding: 55px 10px;\n}\n\n.commerce.str-chat .str-chat__list {\n  padding: 75px 20px 0;\n}\n.commerce.str-chat .str-chat__list-notifications {\n  padding-left: 22px;\n  padding-right: 22px;\n}\n\n.str-chat__message-notification {\n  display: block;\n  position: absolute;\n  align-self: center;\n  background: #006cff;\n  border: none;\n  color: white;\n  border-radius: 50px;\n  padding: 4px 10px;\n  font-size: 12px;\n  bottom: -10px;\n  z-index: 101;\n}\n\n.str-chat__message-replies-count-button {\n  display: block;\n  border: none;\n  background: none;\n  padding: 0;\n  margin-top: 8px;\n  font-size: 12px;\n  line-height: 15px;\n  font-weight: 700;\n  color: #006cff;\n  cursor: pointer;\n}\n.str-chat__message-replies-count-button svg {\n  fill: rgba(0, 0, 0, 0.1);\n  margin-right: 5px;\n}\n\n.dark.str-chat .str-chat__message-replies-count-button svg {\n  fill: rgba(255, 255, 255, 0.1);\n}\n\n.dark.str-chat.team .str-chat__message-replies-count-button svg {\n  fill: rgba(0, 0, 0, 0.4);\n}\n\n.str-chat__message-livestream {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  display: flex;\n  width: 100%;\n  margin: 0 0;\n  padding: 10px 10px;\n  border: 1px solid rgba(0, 0, 0, 0);\n  position: relative;\n}\n.str-chat__message-livestream-left {\n  width: 30px;\n}\n.str-chat__message-livestream-left .str-chat__avatar {\n  margin-right: 0;\n}\n.str-chat__message-livestream-right {\n  flex: 1;\n}\n.str-chat__message-livestream-content {\n  position: relative;\n  padding: 5px 10px;\n  border: 1px solid transparent;\n}\n.str-chat__message-livestream-content > * {\n  font-size: 13px;\n  line-height: 20px;\n  margin: 0;\n}\n.str-chat__message-livestream-content .str-chat__message-mention {\n  font-size: 13px;\n  line-height: 20px;\n  margin: 0;\n}\n.str-chat__message-livestream-content .str-chat__message-mention:focus {\n  outline: 1;\n}\n.str-chat__message-livestream-content p {\n  margin: 0;\n  white-space: pre-line;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n.str-chat__message-livestream-content p:not(:first-of-type) {\n  margin: 16px 0 0;\n}\n.str-chat__message-livestream-content p code {\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(0, 108, 255, 0.1);\n  border-radius: 3px;\n  padding: 2px 4px;\n}\n.str-chat__message-livestream-content p a {\n  color: #006cff;\n  font-weight: bold;\n  text-decoration: none;\n}\n.str-chat__message-livestream-content pre,\n.str-chat__message-livestream-content code {\n  font-family: Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',\n    'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono',\n    'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier,\n    monospace;\n  line-height: inherit;\n  padding: 10px;\n  font-size: 12px;\n  font-weight: 700;\n}\n.str-chat__message-livestream-content pre {\n  margin: 0 5px 0 0;\n  border-radius: 4px;\n  background-color: rgba(0, 108, 255, 0.1);\n  border: 1px solid rgba(0, 108, 255, 0.2);\n}\n.str-chat__message-livestream-content code {\n  width: inherit;\n  word-break: break-all;\n}\n.str-chat__message-livestream:hover .str-chat__message-livestream-actions {\n  display: flex;\n}\n.str-chat__message-livestream-actions {\n  background: rgba(255, 255, 255, 0.6);\n  border: 1px solid rgba(0, 0, 0, 0.23);\n  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);\n  width: 141px;\n  height: 24px;\n  padding: 0 4px;\n  position: absolute;\n  top: -12px;\n  right: 0;\n  border-radius: 24px;\n  display: none;\n  /* FFS display: none */\n  align-items: center;\n  justify-content: space-between;\n}\n.str-chat__message-livestream-actions > span {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n  cursor: pointer;\n}\n.str-chat__message-livestream-actions > span:not(:last-of-type) {\n  border-right: 1px solid #e0e0e0;\n}\n.str-chat__message-livestream-actions > span > span {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n}\n.str-chat__message-livestream-actions > span svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__message-livestream-actions > span:hover svg {\n  opacity: 1;\n}\n.str-chat__message-livestream-actions .str-chat__message-actions-box {\n  bottom: initial;\n  left: initial;\n  visibility: hidden;\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 7px;\n}\n.str-chat__message-livestream-actions .str-chat__message-actions-box--open {\n  visibility: visible;\n}\n.str-chat__message-livestream-time {\n  font-size: 10px;\n  line-height: 20px;\n  color: rgba(0, 0, 0, 0.5);\n  flex: 2;\n  padding: 0 4px;\n}\n.str-chat__message-livestream-text--is-emoji {\n  font-size: 33px;\n  line-height: 42px;\n}\n.str-chat__message-livestream-author {\n  margin-bottom: 8px;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.str-chat__message-livestream-author strong {\n  margin-right: 8px;\n}\n.str-chat__message-livestream:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 6px;\n}\n.str-chat__message-livestream .str-chat__message-attachment--img {\n  border-radius: 0;\n}\n.str-chat__message-livestream .str-chat__message-attachment-card {\n  margin: 0;\n  border-radius: 0;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__message-livestream .str-chat__message-attachment-card--content {\n  background: rgba(255, 255, 255, 0.2);\n}\n.str-chat__message-livestream .str-chat__message-attachment-card--text {\n  display: none;\n}\n.str-chat__message-livestream .str-chat__message-attachment-card--url {\n  text-transform: lowercase;\n}\n.str-chat__message-livestream__thread-banner {\n  text-align: center;\n  font-size: 12px;\n  padding: 8px;\n  margin: 8px 10px 0 10px;\n  background: rgba(0, 108, 255, 0.1);\n  border-radius: 2px;\n  color: #404040;\n}\n.str-chat__message-livestream--error .str-chat__message-livestream-content p,\n.str-chat__message-livestream--failed .str-chat__message-livestream-content p {\n  color: red;\n}\n.str-chat__message-livestream--error\n  .str-chat__message-livestream-content\n  p\n  svg,\n.str-chat__message-livestream--failed\n  .str-chat__message-livestream-content\n  p\n  svg {\n  position: relative;\n  top: 2px;\n  margin-right: 4px;\n}\n.str-chat__message-livestream--failed .str-chat__message-livestream-content p {\n  cursor: pointer;\n}\n.str-chat__message-livestream--initial-message {\n  margin: 20px 10px 0;\n  width: auto;\n}\n\n.str-chat__list--thread .str-chat__message-livestream__actions {\n  min-width: 30px;\n}\n\n.str-chat__list--thread .str-chat__message-livestream-actions {\n  width: 110px;\n  min-width: unset;\n}\n.str-chat__list--thread\n  .str-chat__message-livestream-actions\n  .str-chat__message-actions-box {\n  top: initial;\n  bottom: initial;\n  bottom: -10px;\n}\n\n.livestream.dark.str-chat .str-chat__message-livestream {\n  color: #e6e6e6;\n}\n.livestream.dark.str-chat .str-chat__message-livestream:hover {\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.06);\n  border-radius: 6px;\n}\n.livestream.dark.str-chat\n  .str-chat__message-livestream\n  .str-chat__message-attachment-card {\n  background: rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n.livestream.dark.str-chat\n  .str-chat__message-livestream\n  .str-chat__message-attachment-card--content {\n  background: rgba(0, 0, 0, 0.1);\n}\n.livestream.dark.str-chat\n  .str-chat__message-livestream\n  .str-chat__message-attachment-card--url {\n  color: rgba(255, 255, 255, 0.79);\n}\n\n.livestream.dark.str-chat .str-chat__message-livestream-actions {\n  background: #1b1d20;\n  border: 1px solid rgba(224, 224, 224, 0.03);\n  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);\n}\n.livestream.dark.str-chat\n  .str-chat__message-livestream-actions\n  > span:not(:last-of-type) {\n  border-color: rgba(255, 255, 255, 0.04);\n}\n.livestream.dark.str-chat .str-chat__message-livestream-actions svg {\n  fill: #fff;\n}\n\n.livestream.dark.str-chat .str-chat__message-livestream-time {\n  color: #fff;\n  opacity: 0.5;\n}\n\n.str-chat__message-actions-box {\n  position: absolute;\n  display: none;\n  bottom: 20px;\n  left: 40px;\n  width: 120px;\n  border-radius: 16px 16px 16px 0;\n  background: #fff;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(255, 255, 255, 0.02) 0%,\n    rgba(0, 0, 0, 0.02) 100%\n  );\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08),\n    0 1px 8px 0 rgba(0, 0, 0, 0.05);\n  z-index: 999;\n}\n\n.str-chat__message-actions-box--open {\n  display: block;\n}\n\n.str-chat__message-actions-list {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.str-chat__message-actions-list-item {\n  padding: 8px 10px;\n  width: 100%;\n  margin: 0;\n}\n\n.str-chat__message-actions-list button {\n  background: none;\n  text-align: left;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  display: block;\n  width: 100%;\n  font-size: 12px;\n  color: black;\n  text-decoration: none;\n}\n\n.str-chat__message-actions-list button:hover {\n  color: #006cff;\n}\n\n.str-chat__message-actions-list button:not(:last-of-type) {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.07);\n}\n\n.str-chat__message-actions {\n  position: relative;\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 5px 10px;\n  cursor: pointer;\n}\n\n.str-chat__message-actions {\n  order: 2;\n}\n\n.str-chat__message--me .str-chat__message-actions {\n  order: -1;\n}\n\n.str-chat__message-actions-reactions,\n.str-chat__message-actions-options {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n}\n\n.str-chat__message-actions-reactions,\n.str-chat__message-actions-options svg {\n  fill: grey;\n  position: relative;\n}\n\n.str-chat__message-actions-reactions:hover,\n.str-chat__message-actions-options:hover svg {\n  fill: magenta;\n}\n\n.str-chat__message-reactions-box {\n  position: absolute;\n  visibility: hidden;\n  bottom: 30px;\n  left: -20px;\n  background: rgba(0, 0, 0, 0.81);\n  background-image: linear-gradient(\n    -180deg,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  border-radius: 50px;\n  padding: 16px;\n  z-index: 100;\n}\n\n.str-chat__message-reactions-box--open {\n  visibility: visible;\n}\n\n.str-chat__message-reactions-box::after {\n  top: 97%;\n  left: 30px;\n  content: url('data:image/svg+xml; utf8, <svg width=\"36\" height=\"19\" viewBox=\"0 0 36 19\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"100%\" id=\"b\"><stop stop-opacity=\"0\" offset=\"0%\"/><stop stop-opacity=\".5\" offset=\"100%\"/></linearGradient><path d=\"M35.284.378A15.125 15.125 0 0 0 22.81 6.946L14.55 19a14.422 14.422 0 0 0-2.223-12.786A14.456 14.456 0 0 0 .723.378h34.561z\" id=\"a\"/></defs><g fill-rule=\"nonzero\" fill=\"none\"><use fill=\"%231E1E1E\" xlink:href=\"%23a\"/><use fill=\"url(%23b)\" xlink:href=\"%23a\"/></g></svg>');\n  position: absolute;\n  z-index: 99;\n}\n\n.str-chat__modal {\n  background: black;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n  opacity: 0.89;\n  display: none;\n  align-items: center;\n  justify-content: center;\n}\n.str-chat__modal--open {\n  display: flex;\n}\n.str-chat__modal__inner {\n  max-width: 667px;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n}\n.str-chat__modal__close-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 20px;\n  font-size: 14px;\n  line-height: 10px;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n.str-chat__modal__close-button svg {\n  position: relative;\n  top: 1px;\n  margin-left: 10px;\n  fill: white;\n}\n.str-chat__modal__close-button:hover {\n  opacity: 0.79;\n}\n.str-chat__modal .str-chat__edit-message-form {\n  min-width: 300px;\n}\n.str-chat__modal .str-chat__input-emojiselect,\n.str-chat__modal .str-chat__input-fileupload {\n  position: relative;\n  top: unset;\n  right: unset;\n}\n\n.str-chat.dark.messaging .str-chat__modal__inner {\n  border: 2px solid white;\n  background: black;\n}\n\n.str-chat__new-channel--header {\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__new-channel--header__title {\n  flex: 1;\n  text-align: center;\n  color: #006cff;\n  font-weight: 700;\n  margin-right: 45px;\n}\n\n.str-chat__new-channel--name {\n  padding: 0 0 0 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  display: flex;\n  align-items: center;\n}\n.str-chat__new-channel--name label {\n  font-size: 14px;\n  margin-right: 5px;\n}\n.str-chat__new-channel--name input {\n  font-size: 14px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  flex: 1;\n  width: 100%;\n  padding: 15px 0 15px 5px;\n  background: #fff;\n  border: none;\n  outline: none;\n}\n.str-chat__new-channel--name input:focus {\n  background: white;\n  box-shadow: inset 0 0 0 1px #006cff, inset 0 0 0 2px rgba(0, 108, 255, 0.36);\n}\n\n.str-chat__modal-image__wrapper {\n  line-height: 0;\n  position: relative;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.str-chat__modal-image__image {\n  max-height: 100vh;\n  max-width: 100%;\n}\n\n.str-chat__message .str-chat__reaction-list,\n.str-chat__message-commerce .str-chat__reaction-list {\n  position: absolute;\n  right: 15px;\n  top: -28px;\n  z-index: 99;\n  height: 33px;\n  width: initial;\n  background-position: 0 -66px;\n  background-repeat: repeat-x;\n}\n.str-chat__message .str-chat__reaction-list ul,\n.str-chat__message-commerce .str-chat__reaction-list ul {\n  position: relative;\n  list-style-type: none;\n  padding: 0;\n  font-size: 15px;\n  line-height: 26px;\n  display: flex;\n  justify-content: center;\n  margin: -1px -15px 0 0;\n  z-index: 888;\n}\n.str-chat__message .str-chat__reaction-list .emoji-mart-emoji,\n.str-chat__message-commerce .str-chat__reaction-list .emoji-mart-emoji {\n  display: flex;\n}\n.str-chat__message .str-chat__reaction-list::after,\n.str-chat__message .str-chat__reaction-list::before,\n.str-chat__message-commerce .str-chat__reaction-list::after,\n.str-chat__message-commerce .str-chat__reaction-list::before {\n  position: absolute;\n  content: '';\n  top: 0;\n  height: 33px;\n}\n.str-chat__message .str-chat__reaction-list::after,\n.str-chat__message-commerce .str-chat__reaction-list::after {\n  right: -26px;\n  width: 26px;\n  background-position: -33px -33px;\n}\n.str-chat__message .str-chat__reaction-list::before,\n.str-chat__message-commerce .str-chat__reaction-list::before {\n  left: -13px;\n  width: 13px;\n  background-position: -0 -33px;\n}\n.str-chat__message .str-chat__reaction-list--reverse,\n.str-chat__message-commerce .str-chat__reaction-list--reverse {\n  right: initial;\n  left: 15px;\n  position: absolute;\n}\n.str-chat__message .str-chat__reaction-list--reverse ul,\n.str-chat__message-commerce .str-chat__reaction-list--reverse ul {\n  margin: -1px -5px 0 -15px;\n}\n.str-chat__message .str-chat__reaction-list--reverse::after,\n.str-chat__message-commerce .str-chat__reaction-list--reverse::after {\n  right: -13px;\n  width: 13px;\n  background-position: -46px 0;\n}\n.str-chat__message .str-chat__reaction-list--reverse::before,\n.str-chat__message-commerce .str-chat__reaction-list--reverse::before {\n  left: -26px;\n  width: 26px;\n  background-position: -0 0;\n}\n.str-chat__message .str-chat__reaction-list li,\n.str-chat__message-commerce .str-chat__reaction-list li {\n  display: flex;\n  align-items: center;\n}\n.str-chat__message .str-chat__reaction-list li button,\n.str-chat__message-commerce .str-chat__reaction-list li button {\n  padding: 0;\n}\n.str-chat__message .str-chat__reaction-list--counter,\n.str-chat__message-commerce .str-chat__reaction-list--counter {\n  color: white;\n  font-size: 12px;\n}\n\n.str-chat__message--me\n  .str-chat__message-commerce-inner\n  > .str-chat__reaction-list,\n.str-chat__message--right\n  .str-chat__message-commerce-inner\n  > .str-chat__reaction-list,\n.str-chat__message-commerce--me\n  .str-chat__message-commerce-inner\n  > .str-chat__reaction-list,\n.str-chat__message-commerce--right\n  .str-chat__message-commerce-inner\n  > .str-chat__reaction-list {\n  left: 46px;\n}\n\n.str-chat__message--me .str-chat__reaction-list,\n.str-chat__message--right .str-chat__reaction-list,\n.str-chat__message-commerce--me .str-chat__reaction-list,\n.str-chat__message-commerce--right .str-chat__reaction-list {\n  right: initial;\n  left: 16px;\n}\n.str-chat__message--me .str-chat__reaction-list ul,\n.str-chat__message--right .str-chat__reaction-list ul,\n.str-chat__message-commerce--me .str-chat__reaction-list ul,\n.str-chat__message-commerce--right .str-chat__reaction-list ul {\n  margin: -1px 0 0 -15px;\n}\n.str-chat__message--me .str-chat__reaction-list::after,\n.str-chat__message--right .str-chat__reaction-list::after,\n.str-chat__message-commerce--me .str-chat__reaction-list::after,\n.str-chat__message-commerce--right .str-chat__reaction-list::after {\n  right: -13px;\n  width: 13px;\n  background-position: -46px 0;\n}\n.str-chat__message--me .str-chat__reaction-list::before,\n.str-chat__message--right .str-chat__reaction-list::before,\n.str-chat__message-commerce--me .str-chat__reaction-list::before,\n.str-chat__message-commerce--right .str-chat__reaction-list::before {\n  left: -26px;\n  width: 26px;\n  background-position: -0 0;\n}\n.str-chat__message--me .str-chat__reaction-list--reverse,\n.str-chat__message--right .str-chat__reaction-list--reverse,\n.str-chat__message-commerce--me .str-chat__reaction-list--reverse,\n.str-chat__message-commerce--right .str-chat__reaction-list--reverse {\n  right: 15px;\n  left: initial;\n}\n.str-chat__message--me .str-chat__reaction-list--reverse ul,\n.str-chat__message--right .str-chat__reaction-list--reverse ul,\n.str-chat__message-commerce--me .str-chat__reaction-list--reverse ul,\n.str-chat__message-commerce--right .str-chat__reaction-list--reverse ul {\n  margin: -1px -15px 0 0;\n}\n.str-chat__message--me .str-chat__reaction-list--reverse::after,\n.str-chat__message--right .str-chat__reaction-list--reverse::after,\n.str-chat__message-commerce--me .str-chat__reaction-list--reverse::after,\n.str-chat__message-commerce--right .str-chat__reaction-list--reverse::after {\n  right: -26px;\n  width: 26px;\n  background-position: -33px -33px;\n}\n.str-chat__message--me .str-chat__reaction-list--reverse::before,\n.str-chat__message--right .str-chat__reaction-list--reverse::before,\n.str-chat__message-commerce--me .str-chat__reaction-list--reverse::before,\n.str-chat__message-commerce--right .str-chat__reaction-list--reverse::before {\n  left: -13px;\n  width: 13px;\n  background-position: -0 -33px;\n}\n\n.str-chat__message-commerce-inner > .str-chat__reaction-list {\n  left: unset;\n  right: 46px;\n}\n\n.str-chat__message-commerce--right\n  .str-chat__message-commerce-inner\n  > .str-chat__reaction-list {\n  right: unset;\n  left: 46px;\n}\n\n.str-chat__read-state {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin: -56px 10px 0 40px;\n}\n\n.str-chat__message-reactions-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n}\n\n.str-chat__message-reactions-list-item {\n  font-size: 20px;\n  margin: 0 5px;\n  position: relative;\n  line-height: 0;\n}\n.str-chat__message-reactions-list-item button {\n  padding: 0;\n}\n.str-chat__message-reactions-list-item span[role='img'] {\n  position: relative;\n  display: block;\n  top: -2px;\n  transform: scalce(1);\n  transition: transform 100ms ease;\n}\n.str-chat__message-reactions-list-item span[role='img']:hover {\n  transform: scale(1.4);\n}\n.str-chat__message-reactions-list-item__count {\n  position: absolute;\n  top: 28px;\n  font-size: 10px;\n  color: #fff;\n  font-weight: 700;\n  left: 6px;\n}\n.str-chat__message-reactions-list-item .str-chat__avarar {\n  margin: 0;\n  visibility: visible;\n}\n.str-chat__message-reactions-list-item .latest-user {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: -24px;\n  left: 0;\n}\n.str-chat__message-reactions-list-item .latest-user-tooltip {\n  display: none;\n  text-align: center;\n  position: absolute;\n  bottom: calc(100% + 5px);\n  left: 50%;\n  transform: translate(-50%, 0);\n  background: rgba(0, 0, 0, 0.81);\n  border-radius: 5px;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  max-width: 237px;\n  padding: 4px 8px;\n  font-size: 13px;\n  color: white;\n}\n.str-chat__message-reactions-list-item .latest-user-tooltip::after {\n  content: '';\n  position: absolute;\n  top: calc(100% - 4px);\n  left: 50%;\n  transform: translate(-50%, 0) rotate(45deg);\n  width: 7px;\n  height: 7px;\n  background-color: #1a1a1a;\n}\n.str-chat__message-reactions-list-item .latest-user-not-found {\n  border: 1.5px solid #fff;\n  border-radius: 50%;\n  background-color: magenta;\n  width: inherit;\n  height: inherit;\n}\n.str-chat__message-reactions-list-item .latest-user img {\n  border: 1.5px solid #fff;\n  border-radius: 50%;\n  object-fit: cover;\n  width: inherit;\n  height: inherit;\n}\n.str-chat__message-reactions-list-item .latest-user:hover .latest-user-tooltip {\n  display: block;\n}\n\n.str-chat__reaction-selector {\n  z-index: 999;\n  height: 60px;\n  position: absolute;\n  width: initial;\n  background: rgba(24, 25, 28, 0.98);\n  background-image: linear-gradient(\n    -180deg,\n    rgba(0, 0, 0, 0) 50%,\n    rgba(0, 0, 0, 0.05) 100%\n  );\n  border: 1px solid rgba(224, 224, 224, 0.03);\n  box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.07), 0 11px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 30px;\n  display: flex;\n  align-items: center;\n}\n.str-chat__reaction-selector ul {\n  position: relative;\n  z-index: 1000;\n  margin: 0 16px;\n}\n.str-chat__reaction-selector-tooltip {\n  position: absolute;\n  bottom: calc(100% + 15px);\n  background: rgba(0, 0, 0, 0.81);\n  border-radius: 5px;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  min-width: 85px;\n  min-height: 24px;\n  max-width: 100%;\n  padding: 4px 8px;\n  font-size: 13px;\n  color: white;\n  text-align: center;\n}\n.str-chat__reaction-selector-tooltip .arrow {\n  position: absolute;\n  top: calc(100% - 4px);\n  left: 50%;\n  transform: translate(-50%, 0) rotate(45deg);\n  width: 7px;\n  height: 7px;\n  background-color: #1a1a1a;\n}\n.str-chat__reaction-selector .emoji-mart-emoji:hover {\n  transition: 0.1s;\n  transform: scale(1.2);\n  cursor: pointer;\n}\n\n.str-chat__message .str-chat__reaction-selector,\n.str-chat__message-team .str-chat__reaction-selector,\n.str-chat__message-simple .str-chat__reaction-selector,\n.str-chat__message-commerce .str-chat__reaction-selector,\n.str-chat__message-livestream .str-chat__reaction-selector {\n  top: -65px;\n  left: 0;\n}\n\n.str-chat__message-commerce--right .str-chat__reaction-selector {\n  left: unset;\n  right: 0;\n}\n\n.str-chat__message-livestream .str-chat__reaction-selector {\n  left: unset;\n  top: -70px;\n  right: 0;\n}\n\n.str-chat__message-team .str-chat__reaction-selector {\n  left: unset;\n  top: -60px;\n  right: 0;\n}\n\n.str-chat__message-simple .str-chat__reaction-selector {\n  right: unset;\n  left: 0;\n}\n.str-chat__message-simple .str-chat__reaction-selector--reverse {\n  right: 0;\n  left: unset;\n}\n\n.str-chat__message-simple--me .str-chat__reaction-selector {\n  left: unset;\n  right: 0;\n}\n.str-chat__message-simple--me .str-chat__reaction-selector--reverse {\n  right: unset;\n  left: 0;\n}\n\n.str-chat__send-button {\n  margin-left: 10px;\n  border: 0;\n  background: 0;\n  outline: 0;\n}\n@media screen and (min-width: 768px) {\n  .str-chat__send-button {\n    display: none;\n  }\n}\n\n.str-chat__simple-reactions-list {\n  list-style-type: none;\n  padding: 4px 4px 2px 4px;\n  display: inline-flex;\n  margin: 8px 0 0 0;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  line-height: 1;\n  position: relative;\n}\n.str-chat__simple-reactions-list-tooltip {\n  position: absolute;\n  bottom: calc(100% + 10px);\n  left: 50%;\n  transform: translate(-50%, 0);\n  background: rgba(0, 0, 0, 0.81);\n  border-radius: 5px;\n  background-image: linear-gradient(\n    -180deg,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  min-height: 24px;\n  width: auto;\n  max-width: 275px;\n  padding: 4px 8px;\n  font-size: 13px;\n  color: white;\n  text-align: center;\n}\n.str-chat__simple-reactions-list-tooltip > .arrow {\n  position: absolute;\n  top: calc(100%);\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid rgba(0, 0, 0, 0.81);\n}\n.str-chat__simple-reactions-list-item {\n  margin: 0 0;\n  cursor: pointer;\n}\n.str-chat__simple-reactions-list-item > span {\n  line-height: 1;\n}\n.str-chat__simple-reactions-list-item .emoji-mart-emoji:hover {\n  transition: transform 0.2s ease-in-out;\n  transform: scale(1.2);\n}\n.str-chat__simple-reactions-list-item--last-number {\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  color: black;\n}\n\n.dark.str-chat .str-chat__simple-reactions-list {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n.dark.str-chat .str-chat__simple-reactions-list-item--last-number {\n  color: #fff;\n}\n\n.str-chat__thread {\n  background: #f1f1f3;\n  flex: 1 0 300px;\n  min-width: 300px;\n  max-width: 300px;\n  overflow-y: hidden;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  overflow: hidden;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n.str-chat__thread--full {\n  max-width: 100%;\n}\n.str-chat__thread-header {\n  position: relative;\n  width: 100%;\n  background: #f1f1f3;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14);\n  height: 70px;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n.str-chat__thread-header-details {\n  font-size: 14px;\n}\n.str-chat__thread-header-details small {\n  display: block;\n  font-size: 12px;\n}\n.str-chat__thread-start {\n  border-radius: 4px;\n  margin: 10px 10px 0 10px;\n  padding: 8px;\n  background: rgba(153, 196, 255, 0.1);\n  text-align: center;\n  font-size: 12px;\n}\n.str-chat__thread-list {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  padding-top: 20px;\n}\n.str-chat__thread-list .str-chat__list {\n  padding: 0;\n}\n\n.messaging.str-chat .str-chat__thread {\n  margin-right: 10px;\n  margin-top: 20px;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n  background: white;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-top: 0px;\n}\n.messaging.str-chat .str-chat__thread.str-chat__thread--full {\n  margin: 0;\n}\n.messaging.str-chat .str-chat__thread .str-chat__gallery {\n  justify-content: flex-end;\n  border-radius: 0;\n}\n.messaging.str-chat .str-chat__thread .str-chat__gallery-image,\n.messaging.str-chat .str-chat__thread .str-chat__gallery-placeholder {\n  width: 100px;\n  height: 100px;\n}\n\n.messaging.str-chat .str-chat__thread-list {\n  padding: 20px 10px 0 10px;\n}\n.messaging.str-chat .str-chat__thread-list > .str-chat__list {\n  background: transparent;\n  padding: 0;\n}\n.messaging.str-chat\n  .str-chat__thread-list\n  > .str-chat__list\n  .str-chat__list--thread {\n  padding: 0;\n}\n\n.messaging.str-chat .str-chat__thread-header {\n  border: none;\n  box-shadow: none;\n  background: white;\n}\n\n.messaging.str-chat .str-chat__thread-start {\n  margin-top: 20px;\n}\n\n@media screen and (max-width: 960px) {\n  .messaging.str-chat .str-chat__thread {\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    background: white;\n    z-index: 1000;\n    margin: 0;\n    width: 100vw;\n    max-width: 100%;\n  }\n}\n\n.messaging.str-chat.dark .str-chat__thread {\n  background: rgba(255, 255, 255, 0.04);\n}\n.messaging.str-chat.dark .str-chat__thread-header {\n  background: rgba(46, 48, 51, 0.98);\n  box-shadow: 0 7px 9px 0 rgba(0, 0, 0, 0.03), 0 1px 0 0 rgba(0, 0, 0, 0.03);\n  color: white;\n}\n.messaging.str-chat.dark .str-chat__thread-start {\n  color: white;\n}\n\n@media screen and (max-width: 960px) {\n  .messaging.str-chat.dark .str-chat__thread {\n    background: #282a2d;\n  }\n}\n\n.team.str-chat .str-chat__thread {\n  background: white;\n}\n\n@media screen and (max-width: 960px) {\n  .team.str-chat .str-chat__thread {\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    background: white;\n    z-index: 1000;\n    margin: 0;\n    width: 100vw;\n    max-width: 100%;\n  }\n}\n\n.team.str-chat .str-chat__thread-header {\n  height: 80px;\n}\n\n.team.str-chat.dark .str-chat__thread {\n  background: #1d1f22;\n}\n\n.livestream.str-chat .str-chat__thread,\n.str-chat .str-chat__thread {\n  background: transparent;\n}\n.livestream.str-chat .str-chat__thread-header,\n.str-chat .str-chat__thread-header {\n  background: rgba(255, 255, 255, 0.29);\n}\n\n.livestream.str-chat .str-chat__list--thread,\n.str-chat .str-chat__list--thread {\n  padding: 0 10px;\n}\n\n.livestream.str-chat.dark .str-chat__thread,\n.str-chat.dark .str-chat__thread {\n  background: #1a1a1a;\n}\n.livestream.str-chat.dark .str-chat__thread-header,\n.str-chat.dark .str-chat__thread-header {\n  background: rgba(255, 255, 255, 0.03);\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.34);\n  color: white;\n}\n.livestream.str-chat.dark .str-chat__thread-start,\n.str-chat.dark .str-chat__thread-start {\n  background: rgba(153, 196, 255, 0.1);\n  border-radius: 4px;\n  color: white;\n}\n\n.str-chat__small-message-input {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 10px;\n  position: relative;\n  z-index: 1000;\n}\n.str-chat__small-message-input .rfu-file-previewer {\n  flex: 1 1 100%;\n}\n.str-chat__small-message-input .rfu-image-previewer {\n  flex: 1 1 100%;\n}\n.str-chat__small-message-input__wrapper {\n  position: relative;\n  z-index: 0;\n  width: 100%;\n}\n.str-chat__small-message-input-emojiselect {\n  bottom: 10px;\n  right: 6px;\n}\n.str-chat__small-message-input .rfu-file-upload-button {\n  bottom: 9px;\n  right: 26px;\n}\n.str-chat__small-message-input--textarea-wrapper {\n  flex-wrap: wrap;\n  flex: 1 0;\n  position: relative;\n}\n.str-chat__small-message-input-emojiselect,\n.str-chat__small-message-input .rfu-file-upload-button {\n  position: absolute;\n  cursor: pointer;\n  width: 22px;\n  height: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-size: 44px 44px;\n  fill: rgba(0, 0, 0, 0.6);\n}\n.str-chat__small-message-input-emojiselect:hover,\n.str-chat__small-message-input .rfu-file-upload-button:hover {\n  fill: black;\n}\n.str-chat__small-message-input-emojipicker {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  transform: scale(0.8);\n  transform-origin: 100% 100%;\n}\n.str-chat__small-message-input--send-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex: 0 1;\n  outline: 0;\n}\n.str-chat__small-message-input--send-button:hover {\n  opacity: 0.69;\n}\n@media screen and (min-width: 768px) {\n  .str-chat__small-message-input--send-button {\n    display: none;\n  }\n}\n.str-chat__small-message-input textarea {\n  background: transparent;\n  min-height: 36px;\n  font-size: 13px;\n  padding: 10px 44px 8px 8px;\n}\n.str-chat__small-message-input textarea:focus {\n  height: 36px;\n}\n.str-chat__small-message-input .str-chat__emojisearch {\n  bottom: 100%;\n}\n.str-chat__small-message-input .str-chat__user-item {\n  font-size: 14px;\n}\n.str-chat__small-message-input .rfu-file-upload-button {\n  position: absolute;\n  cursor: pointer;\n  right: 28px;\n}\n.str-chat__small-message-input .rfu-dropzone .rfu-dropzone__notifier {\n  z-index: 1000;\n}\n\n.dark.str-chat .str-chat__small-message-input textarea {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.21);\n  border-radius: 6px;\n  color: white;\n}\n\n.dark.str-chat .str-chat__small-message-input .rfu-file-upload-button svg,\n.dark.str-chat\n  .str-chat__small-message-input\n  .str-chat__small-message-input-emojiselect\n  svg {\n  fill: white;\n}\n\n.str-chat__typing-indicator {\n  display: flex;\n  visibility: hidden;\n  align-items: center;\n}\n.str-chat__typing-indicator--typing {\n  visibility: visible;\n}\n.str-chat__typing-indicator__avatars {\n  display: flex;\n}\n.str-chat__typing-indicator__avatars .str-chat__avatar {\n  border: 2px solid white;\n  margin-right: -14px;\n}\n.str-chat__typing-indicator__avatars .str-chat__avatar:last-of-type {\n  margin-right: 14px;\n}\n.str-chat__typing-indicator__dots {\n  position: relative;\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  padding: 7px;\n  border-radius: 16px 16px 16px 2px;\n}\n.str-chat__typing-indicator__dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 3px;\n  background: #006cff;\n  animation: wave 1.1s linear infinite;\n}\n.str-chat__typing-indicator__dot:nth-child(2) {\n  animation-delay: -0.9s;\n  opacity: 0.5;\n}\n.str-chat__typing-indicator__dot:nth-child(3) {\n  animation-delay: -0.8s;\n  opacity: 0.2;\n}\n\n.dark.str-chat .str-chat__typing-indicator__avatars .str-chat__avatar {\n  border-color: #282a2d;\n}\n\n.dark.str-chat .str-chat__typing-indicator__dots {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n@keyframes wave {\n  0%,\n  60%,\n  100% {\n    transform: initial;\n  }\n  30% {\n    transform: translateY(-8px);\n  }\n}\n\n.str-chat__tooltip {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 10px);\n  display: flex;\n  background: #000;\n  border-radius: 4px;\n  padding: 3px 7px;\n  color: white;\n  font-size: 11px;\n  max-width: 300px;\n}\n.str-chat__tooltip button {\n  outline: none;\n  outline: 0;\n  background: none;\n  color: #006cff;\n  font-size: 11px;\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  border: none;\n}\n.str-chat__tooltip a {\n  color: #006cff;\n  text-decoration: none;\n}\n.str-chat__tooltip::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  right: 5px;\n  width: 5px;\n  height: 5px;\n  background: #000;\n  transform: rotate(45deg);\n}\n\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15;\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff;\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px;\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9;\n}\n\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0;\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color 0.1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none;\n}\n\n.emoji-mart-anchor:focus {\n  outline: 0;\n}\n\n.emoji-mart-anchor:hover,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor-selected {\n  color: #464646;\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0;\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #464646;\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px;\n}\n\n.emoji-mart-anchors svg,\n.emoji-mart-anchors img {\n  fill: currentColor;\n  height: 18px;\n  width: 18px;\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 270px;\n  padding: 0 6px 6px 6px;\n  will-change: transform;\n  /* avoids \"repaints on scroll\" in mobile Chrome */\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative;\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0;\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  /* remove webkit/blink styles for <input type=\"search\">\n   * via https://stackoverflow.com/a/9422689 */\n  -webkit-appearance: none;\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none;\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default;\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%;\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, 0.95);\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0;\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block;\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n}\n\n.emoji-mart-emoji-native {\n  font-family: 'Segoe UI Emoji', 'Segoe UI Symbol', 'Segoe UI',\n    'Apple Color Emoji', 'Twemoji Mozilla', 'Noto Color Emoji', 'Android Emoji';\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585;\n}\n\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%;\n}\n\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none;\n}\n\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: 0.2em;\n}\n\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none;\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px;\n}\n\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-data,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px;\n}\n\n.emoji-mart-preview-data {\n  left: 68px;\n  right: 12px;\n  word-break: break-all;\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right;\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right;\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px;\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888;\n}\n\n.emoji-mart-preview-shortname + .emoji-mart-preview-shortname,\n.emoji-mart-preview-shortname + .emoji-mart-preview-emoticon,\n.emoji-mart-preview-emoticon + .emoji-mart-preview-emoticon {\n  margin-left: 0.5em;\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb;\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0;\n}\n\n.emoji-mart-title-label {\n  color: #999a9c;\n  font-size: 26px;\n  font-weight: 300;\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: 0.75;\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out;\n}\n\n.emoji-mart-skin-swatch:nth-child(1) {\n  transition-delay: 0s;\n}\n\n.emoji-mart-skin-swatch:nth-child(2) {\n  transition-delay: 0.03s;\n}\n\n.emoji-mart-skin-swatch:nth-child(3) {\n  transition-delay: 0.06s;\n}\n\n.emoji-mart-skin-swatch:nth-child(4) {\n  transition-delay: 0.09s;\n}\n\n.emoji-mart-skin-swatch:nth-child(5) {\n  transition-delay: 0.12s;\n}\n\n.emoji-mart-skin-swatch:nth-child(6) {\n  transition-delay: 0.15s;\n}\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px;\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-out;\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: 0.125s;\n  transition-timing-function: ease-out;\n  cursor: default;\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: '';\n  width: 0;\n  height: 0;\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%;\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0;\n}\n\n.emoji-mart-skin-swatches.custom.opened\n  .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: 0.75;\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff;\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%;\n}\n\n.emoji-mart-skin-tone-1 {\n  background-color: #ffc93a;\n}\n\n.emoji-mart-skin-tone-2 {\n  background-color: #fadcbc;\n}\n\n.emoji-mart-skin-tone-3 {\n  background-color: #e0bb95;\n}\n\n.emoji-mart-skin-tone-4 {\n  background-color: #bf8f68;\n}\n\n.emoji-mart-skin-tone-5 {\n  background-color: #9b643d;\n}\n\n.emoji-mart-skin-tone-6 {\n  background-color: #594539;\n}\n\n/* For screenreaders only, via https://stackoverflow.com/a/19758620 */\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/*\n * Dark mode styles\n */\n.emoji-mart-dark {\n  color: #fff;\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453;\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f;\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444;\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff;\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222;\n}\n\n.emoji-mart-dark .emoji-mart-anchor:hover,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor-selected {\n  color: #bfbfbf;\n}\n\n.str-chat__message-commerce {\n  display: flex;\n  /* inline-flex if you don't want the  */\n  justify-content: flex-start;\n  align-items: flex-end;\n  padding: 0 0 0 0;\n  position: relative;\n  margin: 1px 0;\n  /* deleted messages */\n  /* error messages */\n}\n.str-chat__message-commerce-inner {\n  position: relative;\n  /* flex: 1 if you want the messagebubbles to be the same width- */\n}\n.str-chat__message-commerce-inner > .str-chat__message-commerce__actions {\n  min-height: 10px;\n  min-width: 30px;\n  float: right;\n}\n.str-chat__message-commerce-inner\n  > .str-chat__message-commerce__actions\n  .str-chat__reaction-list {\n  left: unset;\n  right: 46px;\n}\n.str-chat__message-commerce .str-chat__avatar {\n  margin-right: 8px;\n}\n.str-chat__message-commerce .str-chat__message-attachment-card--content {\n  margin: 0;\n  padding: 6px 8px;\n}\n.str-chat__message-commerce--top,\n.str-chat__message-commerce--middle {\n  margin-left: 40px;\n}\n.str-chat__message-commerce--top .str-chat__message-commerce-data,\n.str-chat__message-commerce--middle .str-chat__message-commerce-data {\n  display: none;\n}\n.str-chat__message-commerce--top .str-chat__message-commerce-text-inner {\n  border-radius: 16px 16px 4px 4px;\n}\n.str-chat__message-commerce--bottom .str-chat__message-commerce-text-inner {\n  border-radius: 4px 4px 16px 0;\n}\n.str-chat__message-commerce--single .str-chat__message-commerce-text-inner {\n  border-radius: 16px 16px 16px 0;\n}\n.str-chat__message-commerce--single\n  .str-chat__message-commerce-text-inner--has-attachment {\n  border-radius: 4px 4px 16px 0;\n}\n.str-chat__message-commerce--middle .str-chat__message-commerce-text-inner {\n  border-radius: 4px 4px 4px 4px;\n}\n.str-chat__message-commerce-text {\n  display: flex;\n  padding: 0 0 0 0;\n  position: relative;\n}\n.str-chat__message-commerce-text-inner {\n  position: relative;\n  display: block;\n  min-height: 32px;\n  padding: 5px 10px;\n  font-size: 15px;\n  /* variables */\n  color: black;\n  /* variables */\n  border-radius: 16px 16px 16px 0;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  margin-left: 0;\n  max-width: 345px;\n}\n.str-chat__message-commerce-text-inner p {\n  margin: 0;\n  white-space: pre-line;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n.str-chat__message-commerce-text-inner p:not(:first-of-type) {\n  margin: 16px 0 0;\n}\n.str-chat__message-commerce-text-inner--has-attachment {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__message-commerce-text-inner--is-emoji {\n  background: transparent;\n  border: 1px solid transparent;\n  font-size: 32px;\n  line-height: 48px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.str-chat__message-commerce-attachment--img {\n  width: 100%;\n  max-width: 480px;\n  display: block;\n  height: inherit;\n  cursor: -moz-zoom-in;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n.str-chat__message-commerce-data {\n  margin-top: 5px;\n  width: 100%;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.str-chat__message-commerce-name {\n  font-weight: 700;\n  margin-right: 5px;\n}\n.str-chat__message-commerce p {\n  margin: 0;\n  line-height: 20px;\n}\n.str-chat__message-commerce--with-reactions {\n  margin-top: 30px;\n}\n.str-chat__message-commerce--with-reactions\n  .str-chat__message-commerce__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-commerce-link {\n  color: magenta;\n  font-weight: 700;\n  text-decoration: none;\n}\n.str-chat__message-commerce-mention {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: magenta;\n  font-weight: 700;\n}\n.str-chat__message-commerce--inner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.str-chat__message-commerce--deleted {\n  background: #f0f0f0;\n  float: left;\n  padding: 8px 16px;\n  border-radius: 16px;\n  font-size: 12px;\n  color: #a4a4a4;\n  margin: 0 0 0 42px;\n}\n.str-chat__message-commerce--error {\n  margin: 0 0 32px 0;\n  font-size: 12px;\n}\n.str-chat__message-commerce--error .str-chat__message-text-inner {\n  background: rgba(208, 2, 27, 0.1);\n  border: 1px solid rgba(208, 2, 27, 0.1);\n}\n.str-chat__message-commerce--right.str-chat__message-commerce {\n  justify-content: flex-end;\n  margin-left: 0;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce__actions {\n  justify-content: flex-end;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-inner\n  > .str-chat__message-commerce__actions {\n  float: left;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-inner\n  > .str-chat__message-commerce__actions\n  .str-chat__reaction-list {\n  left: 46px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-inner\n  > .str-chat__message-commerce-reply-button {\n  display: flex;\n  justify-content: flex-end;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-inner\n  > .str-chat__message-commerce-reply-button\n  .str-chat__message-replies-count-button {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-inner\n  > .str-chat__message-commerce-reply-button\n  .str-chat__message-replies-count-button\n  svg {\n  transform: scaleX(-1);\n  margin-left: 5px;\n  margin-bottom: 4px;\n  margin-right: 0;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-text-inner {\n  background: #ebebeb;\n  border-width: 0px;\n  margin-top: 2px;\n  border-color: transparent;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-text-inner\n  p {\n  text-align: right;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  > .str-chat__avatar {\n  display: none;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-attachment {\n  margin: 0 auto 0 30px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-attachment--img {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-attachment-card {\n  border-radius: 16px 16px 4px 16px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce--bottom,\n.str-chat__message-commerce--right.str-chat__message-commerce--single {\n  margin-right: 0;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce--single\n  .str-chat__message-commerce-text-inner {\n  border-radius: 16px 16px 4px 16px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce--single\n  .str-chat__message-commerce-text-inner--has-attachment {\n  border-radius: 16px 4px 4px 16px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce--bottom\n  .str-chat__message-commerce-text-inner {\n  border-radius: 4px 4px 4px 16px;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__avatar {\n  order: 1;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-text {\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-text-inner {\n  flex: unset;\n}\n.str-chat__message-commerce--right.str-chat__message-commerce\n  .str-chat__message-commerce-data {\n  text-align: right;\n}\n.str-chat__message-commerce--has-text\n  .str-chat__message-commerce-inner\n  .str-chat__message-attachment {\n  width: 100%;\n  height: auto;\n  margin: 4px auto;\n}\n\n.str-chat__message-commerce {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.str-chat__message-commerce__actions {\n  display: flex;\n  margin-top: 5px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  min-width: 30px;\n}\n.str-chat__message-commerce__actions__action {\n  margin: 5px;\n  display: flex;\n  align-items: center;\n  height: 10px;\n  cursor: pointer;\n}\n.str-chat__message-commerce__actions__action svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__message-commerce__actions__action:hover svg {\n  opacity: 1;\n}\n.str-chat__message-commerce__actions__action--thread,\n.str-chat__message-commerce__actions__action--reactions {\n  display: none;\n}\n.str-chat__message-commerce__actions__action--options {\n  position: relative;\n  display: none;\n}\n.str-chat__message-commerce__actions__action--options\n  .str-chat__message-actions-box {\n  bottom: 10px;\n  left: unset;\n  right: 100%;\n  width: 120px;\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__message-commerce.str-chat__message--with-reactions\n  .str-chat__message-commerce__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-commerce:hover\n  .str-chat__message-commerce__actions__action--thread {\n  display: flex;\n}\n.str-chat__message-commerce:hover\n  .str-chat__message-commerce__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-commerce-text {\n  display: flex;\n  padding: 0 0 0 0;\n  position: relative;\n}\n.str-chat__message-commerce-text-inner {\n  text-align: left;\n}\n.str-chat__message-commerce-text-inner.str-chat__message-commerce-text-inner--is-emoji {\n  margin: 5px 0;\n  background: transparent;\n}\n.str-chat__message-commerce-text-inner p {\n  text-align: left;\n}\n.str-chat__message-commerce-text-inner a {\n  color: #006cff;\n  font-weight: 700;\n  text-decoration: none;\n}\n.str-chat__message-commerce-text-inner blockquote {\n  margin: 0 0 0 5px;\n  font-style: italic;\n  padding-left: 20px;\n  position: relative;\n}\n.str-chat__message-commerce-text-inner blockquote::before {\n  font-size: 25px;\n  content: '\\201C';\n  font-style: italic;\n  position: absolute;\n  opacity: 0.5;\n  top: 2px;\n  left: -5px;\n}\n.str-chat__message-commerce:hover\n  .str-chat__message-commerce__actions__action--options {\n  display: flex;\n}\n.str-chat__message-commerce:hover\n  .str-chat__message-commerce__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-commerce:hover\n  .str-chat__message-commerce__actions__action--thread {\n  display: flex;\n}\n\n.str-chat__commerce-message--error-message {\n  text-align: left;\n  text-transform: uppercase;\n  font-size: 11px;\n  opacity: 0.5;\n}\n\n.str-chat__message-commerce-status {\n  margin: 10px 0px 10px 10px;\n  order: 3;\n  position: absolute;\n  left: 100%;\n  bottom: 0;\n  line-height: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  z-index: 11;\n}\n.str-chat__message-commerce-status-number {\n  font-size: 10px;\n  margin-left: 4px;\n  position: absolute;\n  left: 100%;\n  color: rgba(0, 0, 0, 0.6);\n}\n.str-chat__message-commerce-status > .str-chat__avatar {\n  align-self: flex-end;\n  margin-right: 0;\n}\n.str-chat__message-commerce-status > .str-chat__tooltip {\n  display: none;\n  max-width: 300px;\n  min-width: 100px;\n  text-align: center;\n}\n.str-chat__message-commerce-status:hover > .str-chat__tooltip {\n  display: block;\n}\n.str-chat__message-commerce-status::after {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  content: ' ';\n  width: 15px;\n  height: 15px;\n}\n\n.str-chat__message-commerce .str-chat__message-attachment {\n  width: calc(100% - 30px);\n  max-width: unset;\n  border-radius: unset;\n  margin: 0 auto 0 0;\n}\n\n.str-chat__message-commerce .str-chat__message-attachment-card {\n  margin: 0;\n  border-radius: 4px 16px 4px 4px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__message-commerce .str-chat__message-attachment-card--content {\n  background: #ebebeb;\n}\n.str-chat__message-commerce .str-chat__message-attachment-card--text {\n  display: none;\n}\n\n.str-chat__list--thread .str-chat__message-commerce__actions {\n  width: 30px;\n}\n\n.str-chat__list--thread\n  .str-chat__message-commerce__actions__action--options\n  .str-chat__message-actions-box {\n  right: unset;\n  left: 100%;\n  border-radius: 16px 16px 16px 2px;\n}\n\n.str-chat.dark .str-chat__message-commerce-data {\n  color: white;\n  opacity: 0.5;\n}\n\n.str-chat.dark .str-chat__message-commerce-text-inner {\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n}\n\n.str-chat.dark .str-chat__message-commerce__actions svg {\n  fill: white;\n}\n\n.str-chat.dark .str-chat__message-commerce .str-chat__message-attachment-card {\n  background: rgba(0, 0, 0, 0.2);\n}\n.str-chat.dark\n  .str-chat__message-commerce\n  .str-chat__message-attachment-card--content {\n  background: rgba(0, 0, 0, 0.2);\n}\n.str-chat.dark\n  .str-chat__message-commerce\n  .str-chat__message-attachment-card--title {\n  color: white;\n}\n.str-chat.dark\n  .str-chat__message-commerce\n  .str-chat__message-attachment-card--url {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.str-chat.dark\n  .str-chat__message-commerce--right\n  .str-chat__message-commerce-text-inner {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.str-chat.dark\n  .str-chat__message-commerce--right\n  .str-chat__message-commerce\n  .str-chat__message-attachment-card {\n  background: rgba(0, 0, 0, 0.2);\n}\n.str-chat.dark\n  .str-chat__message-commerce--right\n  .str-chat__message-commerce\n  .str-chat__message-attachment-card--content {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.str-chat {\n  /* .str-chat__message */\n}\n.str-chat__message {\n  /* .str-chat__message-team */\n}\n.str-chat__message-team {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  position: relative;\n  display: flex;\n  padding: 5px 40px;\n}\n.str-chat__message-team .str-chat__avatar {\n  margin-right: 0;\n}\n.str-chat__message-team-actions {\n  position: absolute;\n  top: -12px;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 88px;\n  height: 24px;\n  border-radius: 100px;\n  background: white;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);\n  z-index: 10;\n  visibility: hidden;\n}\n.str-chat__message-team-actions > span {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n  cursor: pointer;\n}\n.str-chat__message-team-actions > span > span {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  text-align: center;\n}\n.str-chat__message-team-actions > span svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__message-team-actions > span:hover svg {\n  opacity: 1;\n}\n.str-chat__message-team-actions .str-chat__message-actions-box {\n  bottom: initial;\n  left: initial;\n  visibility: hidden;\n  right: 100%;\n  top: -10px;\n  border-radius: 7px;\n}\n.str-chat__message-team-actions .str-chat__message-actions-box--open {\n  visibility: visible;\n}\n.str-chat__message-team-group {\n  position: relative;\n  width: 100%;\n}\n.str-chat__message-team-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  min-width: 50px;\n  padding: 0 10px 0 0;\n  justify-content: space-between;\n}\n.str-chat__message-team-meta time {\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 10px;\n  margin-bottom: 5px;\n  text-align: right;\n  visibility: hidden;\n}\n.str-chat__message-team-author {\n  font-size: 15px;\n  text-transform: capitalize;\n  line-height: 40px;\n  margin-left: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.str-chat__message-team-content {\n  width: 100%;\n  padding-left: 10px;\n  color: #404040;\n  font-size: 15px;\n  line-height: 22px;\n  font-weight: 400;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n  position: relative;\n  margin: 0 0;\n}\n.str-chat__message-team-content--image {\n  padding-left: 0;\n  border-left-color: transparent;\n}\n.str-chat__message-team-content p {\n  margin: 0;\n  white-space: pre-line;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n.str-chat__message-team-content p:not(:first-of-type) {\n  margin: 16px 0 0;\n}\n.str-chat__message-team-content p a {\n  color: #006cff;\n  font-weight: bold;\n  text-decoration: none;\n}\n.str-chat__message-team-content p code {\n  background-color: #f8f8f8;\n  border: 1px solid rgba(208, 2, 27, 0.1);\n  border-radius: 3px;\n  padding: 2px;\n}\n.str-chat__message-team-content pre,\n.str-chat__message-team-content code {\n  font-family: Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',\n    'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono',\n    'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier,\n    monospace;\n  line-height: inherit;\n  font-size: 12px;\n  font-weight: 700;\n}\n.str-chat__message-team-content pre {\n  margin: 0 5px 0 0;\n  border-radius: 4px;\n  background-color: #f8f8f8;\n  border: 1px solid #d3d3d3;\n  padding: 10px;\n}\n.str-chat__message-team-content code {\n  width: inherit;\n  white-space: pre-wrap;\n  word-break: break-all;\n}\n.str-chat__message-team-content ul {\n  margin: 0;\n}\n.str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,\n.str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(-135deg) translateX(1px);\n  transform-origin: 0;\n  width: 5px;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.str-chat__message-team-content--top {\n  margin: 5px 0 0;\n}\n.str-chat__message-team-content--single {\n  margin: 5px 0 0;\n}\n.str-chat__message-team-content--middle {\n  margin: 0 0 0;\n}\n.str-chat__message-team-content--bottom {\n  margin: 0 0 0;\n}\n.str-chat__message-team-text--is-emoji {\n  font-size: 33px;\n  line-height: 42px;\n}\n.str-chat__message-team-status {\n  position: absolute;\n  left: 100%;\n  bottom: 1px;\n  line-height: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  z-index: 11;\n}\n.str-chat__message-team-status-number {\n  font-size: 10px;\n  margin-left: 4px;\n  position: absolute;\n  left: 100%;\n  color: rgba(0, 0, 0, 0.6);\n}\n.str-chat__message-team-status > .str-chat__avatar {\n  align-self: flex-end;\n  margin-right: 0;\n}\n.str-chat__message-team-status > .str-chat__tooltip {\n  display: none;\n  max-width: 300px;\n  min-width: 100px;\n  text-align: center;\n}\n.str-chat__message-team-status:hover > .str-chat__tooltip {\n  display: block;\n}\n.str-chat__message-team-status::after {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  content: ' ';\n  width: 15px;\n  height: 15px;\n}\n.str-chat__message-team-failed {\n  border: 0;\n  background: none;\n  display: flex;\n  align-items: center;\n  color: #ea152f;\n  cursor: pointer;\n  margin: 5px 0;\n  font-size: 12px;\n  padding: 0;\n}\n.str-chat__message-team-failed svg {\n  margin-right: 7px;\n}\n.str-chat__message-team-form-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0 5px;\n}\n.str-chat__message-team--bottom .str-chat__message-team-meta time,\n.str-chat__message-team--single .str-chat__message-team-meta time {\n  visibility: visible;\n}\n.str-chat__message-team--editing {\n  padding: 10px;\n  background: #edf4ff;\n  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.06), inset 0 1px 0 0 #006cff,\n    inset 0 -1px 0 0 #006cff;\n  z-index: 1;\n}\n.str-chat__message-team:hover {\n  /* .-team:hover */\n}\n.str-chat__message-team:hover {\n  /* .str-chat__message-attachment, */\n}\n.str-chat__message-team:hover .str-chat__message-team-content {\n  background: rgba(0, 0, 0, 0.03);\n}\n.str-chat__message-team:hover .str-chat__message-team-meta time {\n  visibility: visible;\n}\n.str-chat__message-team:hover .str-chat__message-team-actions {\n  visibility: visible;\n}\n.str-chat__message-team--error {\n  /* .str-chat__message-team--error */\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.str-chat__message-team--error .str-chat__message-team-status {\n  display: none;\n}\n.str-chat__message-team--error .str-chat__message-team-content {\n  background: transparent;\n  border-width: 2px;\n  border-color: #d0021b;\n  /* error */\n}\n.str-chat__message-team--error .str-chat__message-team-content p {\n  opacity: 0.5;\n}\n.str-chat__message-team--error .str-chat__message-team-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform: rotate(-135deg) translateX(1px);\n  transform-origin: 0;\n  width: 5px;\n  height: 2px;\n  background-color: #d0021b;\n  /* error */\n}\n.str-chat__message-team--ephemeral .str-chat__message-team-status {\n  display: none;\n}\n.str-chat__message-team--failed .str-chat__message-team-content--text {\n  border-color: #d0021b;\n}\n.str-chat__message-team--failed .str-chat__message-team-content--text p {\n  opacity: 0.5;\n}\n.str-chat__message-team .str-chat__message-attachment--img {\n  border-radius: 0;\n  padding-left: 5px;\n  border-left: 1px solid rgba(0, 0, 0, 0.1);\n}\n.str-chat__message-team .str-chat__message-attachment-card {\n  margin: 0;\n  border-radius: 4px 4px 4px 4px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__message-team .str-chat__message-attachment-card--content {\n  background: #ebebeb;\n}\n.str-chat__message-team .str-chat__message-attachment-card--text {\n  display: none;\n}\n.str-chat__message-team .str-chat__input-emojiselect,\n.str-chat__message-team .str-chat__input-fileupload {\n  position: static;\n  top: initial;\n}\n\n/* .str-chat */\n.str-chat__message-team-error-header {\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.4);\n  font-style: italic;\n  text-transform: none;\n}\n\n.str-chat__thread-list .str-chat__message-simple__actions {\n  min-width: 30px;\n}\n\n.str-chat__thread-list .str-chat__message-team {\n  padding: 5px 10px;\n}\n.str-chat__thread-list .str-chat__message-team-actions {\n  width: 60px;\n  min-width: unset;\n}\n.str-chat__thread-list\n  .str-chat__message-team-actions\n  .str-chat__message-actions-box {\n  top: initial;\n  bottom: initial;\n  bottom: -10px;\n}\n\n.str-chat blockquote {\n  margin: 0 0 0 5px;\n  font-style: italic;\n  padding-left: 20px;\n  position: relative;\n}\n.str-chat blockquote::before {\n  font-size: 25px;\n  content: '\\201C';\n  font-style: italic;\n  position: absolute;\n  opacity: 0.5;\n  top: 2px;\n  left: -5px;\n}\n\n.str-chat.dark .str-chat__message-team-error-header {\n  color: rgba(255, 255, 255, 0.5);\n  opacity: 1;\n}\n\n.str-chat.dark .str-chat__message-team-author {\n  color: white;\n}\n\n.str-chat.dark .str-chat__message-team-meta time {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.str-chat.dark .str-chat__message-team-content,\n.str-chat.dark .str-chat__message-team .str-chat__message-attachment {\n  border-color: rgba(0, 0, 0, 0.4);\n  color: white;\n}\n.str-chat.dark\n  .str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,\n.str-chat.dark\n  .str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment--top:not(.str-chat__message-team-content--image)::before,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment--single:not(.str-chat__message-team-content--image)::before {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.str-chat.dark .str-chat__message-team-content--image,\n.str-chat.dark .str-chat__message-team .str-chat__message-attachment--image {\n  border-color: transparent;\n}\n.str-chat.dark .str-chat__message-team-content p code,\n.str-chat.dark .str-chat__message-team .str-chat__message-attachment p code {\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n.str-chat.dark .str-chat__message-team-content pre,\n.str-chat.dark .str-chat__message-team .str-chat__message-attachment pre {\n  background-color: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-file--item,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-file--item {\n  border-color: rgba(0, 0, 0, 0.4);\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-file--item\n  a,\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-file--item\n  span,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-file--item\n  a,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-file--item\n  span {\n  color: white;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-file--item\n  span,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-file--item\n  span {\n  opacity: 0.4;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-file--item:hover,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-file--item:hover {\n  background: transparent;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment--file\n  a,\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment--file\n  span,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment--file\n  a,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment--file\n  span {\n  color: white;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment--file\n  span,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment--file\n  span {\n  opacity: 0.4;\n}\n\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-card,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-card {\n  background: transparent;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-card--content,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-card--content {\n  background: rgba(0, 0, 0, 0.1);\n  min-height: 58px;\n  margin: 0;\n  padding: 0px 16px;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-card--title,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-card--title {\n  color: white;\n}\n.str-chat.dark\n  .str-chat__message-team-content\n  .str-chat__message-attachment-card--url,\n.str-chat.dark\n  .str-chat__message-team\n  .str-chat__message-attachment\n  .str-chat__message-attachment-card--url {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.str-chat.dark .str-chat__message-team-actions {\n  background: #1b1d20;\n  border: 1px solid rgba(224, 224, 224, 0.03);\n  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.07);\n  border-radius: 12px;\n}\n.str-chat.dark .str-chat__message-team-actions .str-chat__message-actions-box {\n  background: #6a6b6d;\n}\n.str-chat.dark .str-chat__message-team-actions > span {\n  border-color: rgba(0, 0, 0, 0.04);\n}\n.str-chat.dark .str-chat__message-team-actions > span svg {\n  fill: #fff;\n}\n\n.str-chat.dark .str-chat__message-team--error .str-chat__message-team-content {\n  border-color: red;\n  border-width: 1px;\n}\n.str-chat.dark\n  .str-chat__message-team--error\n  .str-chat__message-team-content\n  p {\n  color: rgba(255, 255, 255, 0.5);\n  opacity: 1;\n}\n.str-chat.dark\n  .str-chat__message-team--error\n  .str-chat__message-team-content--top:not(.str-chat__message-team-content--image)::before,\n.str-chat.dark\n  .str-chat__message-team--error\n  .str-chat__message-team-content--single:not(.str-chat__message-team-content--image)::before {\n  background-color: red;\n  height: 1px;\n}\n\n.str-chat.dark .str-chat__message-team--editing {\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.06),\n    inset 0 1px 0 0 rgba(0, 108, 255, 0.1),\n    inset 0 -1px 0 0 rgba(0, 108, 255, 0.1);\n  z-index: 1;\n}\n\n.str-chat__li {\n  display: block;\n  position: relative;\n  /* group styling */\n}\n.str-chat__li--top,\n.str-chat__li--single {\n  margin: 20px 0 0;\n}\n.str-chat__li--top .str-chat__message-attachment--img,\n.str-chat__li--top .str-chat__message-attachment-card,\n.str-chat__li--top .str-chat__message .str-chat__gallery,\n.str-chat__li--single .str-chat__message-attachment--img,\n.str-chat__li--single .str-chat__message-attachment-card,\n.str-chat__li--single .str-chat__message .str-chat__gallery {\n  border-radius: 16px 16px 16px 2px;\n}\n.str-chat__li--top\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--top\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--single\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--single\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card {\n  border-radius: 16px 16px 16px 2px;\n}\n.str-chat__li--top .str-chat__message--me,\n.str-chat__li--single .str-chat__message--me {\n  text-align: right;\n}\n.str-chat__li--top .str-chat__message--me .str-chat__message-attachment--img,\n.str-chat__li--top .str-chat__message--me .str-chat__message-attachment-card,\n.str-chat__li--single .str-chat__message--me .str-chat__message-attachment--img,\n.str-chat__li--single\n  .str-chat__message--me\n  .str-chat__message-attachment-card {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--top\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--top\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--single\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--single\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--top .str-chat__message--me .str-chat__gallery,\n.str-chat__li--single .str-chat__message--me .str-chat__gallery {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--top\n  .str-chat__message--me.str-chat__message--has-text\n  .str-chat__gallery,\n.str-chat__li--single\n  .str-chat__message--me.str-chat__message--has-text\n  .str-chat__gallery {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--middle {\n  margin: 0;\n}\n.str-chat__li--middle .str-chat__message-attachment--img,\n.str-chat__li--middle .str-chat__message-attachment-card,\n.str-chat__li--middle .str-chat__message .str-chat__gallery {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--middle\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--middle\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--middle\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__gallery {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--middle .str-chat__message--me .str-chat__message-attachment--img,\n.str-chat__li--middle .str-chat__message--me .str-chat__message-attachment-card,\n.str-chat__li--middle\n  .str-chat__message--me\n  .str-chat__message\n  .str-chat__gallery {\n  border-radius: 16px 2px 2px 16px;\n}\n.str-chat__li--middle\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--middle\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--middle\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__gallery {\n  border-top-left-radius: 2px;\n}\n.str-chat__li--bottom {\n  margin: 0 0 20px;\n}\n.str-chat__li--bottom .str-chat__message-attachment--img,\n.str-chat__li--bottom .str-chat__message-attachment-card,\n.str-chat__li--bottom .str-chat__message .str-chat__gallery {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--bottom\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--bottom\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--bottom\n  .str-chat__message.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__gallery {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment--img,\n.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment-card,\n.str-chat__li--bottom\n  .str-chat__message--me\n  .str-chat__message\n  .str-chat__gallery {\n  border-radius: 16px 2px 2px 16px;\n}\n.str-chat__li--bottom\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment--img,\n.str-chat__li--bottom\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__message-attachment-card,\n.str-chat__li--bottom\n  .str-chat__message--me.str-chat__message--has-text.str-chat__message--has-attachment\n  .str-chat__gallery {\n  border-top-left-radius: 2px;\n}\n.str-chat__li--single {\n  margin-bottom: 20px;\n}\n.str-chat__li--top .str-chat__message-data,\n.str-chat__li--middle .str-chat__message-data {\n  display: none;\n}\n.str-chat__li--top .str-chat__message-text-inner {\n  border-radius: 16px 16px 16px 2px;\n}\n.str-chat__li--top .str-chat__message--me .str-chat__message-text-inner {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--single .str-chat__message-text-inner {\n  border-radius: 16px 16px 16px 2px;\n}\n.str-chat__li--single .str-chat__message-text-inner--has-attachment {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--single .str-chat__message--me .str-chat__message-text-inner {\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__li--single\n  .str-chat__message--me\n  .str-chat__message-text-inner--has-attachment {\n  border-radius: 16px 2px 2px 16px;\n}\n.str-chat__li--bottom .str-chat__message-text-inner,\n.str-chat__li--middle .str-chat__message-text-inner {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__li--bottom .str-chat__message--me .str-chat__message-text-inner,\n.str-chat__li--middle .str-chat__message--me .str-chat__message-text-inner {\n  border-radius: 16px 2px 2px 16px;\n}\n.str-chat__li--bottom\n  .str-chat__message--me\n  .str-chat__message-text-inner--has-attachment,\n.str-chat__li--middle\n  .str-chat__message--me\n  .str-chat__message-text-inner--has-attachment {\n  margin: 0;\n}\n.str-chat__li--bottom .str-chat__message--me .str-chat__message-attachment-card,\n.str-chat__li--middle\n  .str-chat__message--me\n  .str-chat__message-attachment-card {\n  margin: 0;\n  padding: 0;\n  border-radius: 16px 2px 2px 16px;\n}\n\n.str-chat__message,\n.str-chat__message-simple {\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  padding: 0 0 0 0;\n  position: relative;\n  margin: 1px 0;\n  /* me */\n  /* deleted messages */\n  /* error messages */\n}\n.str-chat__message--system,\n.str-chat__message-simple--system {\n  text-align: center;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  padding: 0 40px;\n  margin: 40px 0;\n  font-size: 10px;\n}\n.str-chat__message--system__text,\n.str-chat__message-simple--system__text {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.str-chat__message--system__text p,\n.str-chat__message-simple--system__text p {\n  margin: 0 25px;\n  color: rgba(0, 0, 0, 0.5);\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.str-chat__message--system__line,\n.str-chat__message-simple--system__line {\n  flex: 1;\n  height: 1px;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.str-chat__message--system__date,\n.str-chat__message-simple--system__date {\n  margin-top: 3px;\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.5);\n}\n.str-chat__message-inner,\n.str-chat__message-simple-inner {\n  position: relative;\n}\n@media screen and (min-width: 420px) {\n  .str-chat__message-inner,\n  .str-chat__message-simple-inner {\n    margin-right: 90px;\n    margin-left: unset;\n  }\n}\n.str-chat__message-inner > .str-chat__message-simple__actions,\n.str-chat__message-simple-inner > .str-chat__message-simple__actions {\n  position: absolute;\n  top: 5px;\n  left: 100%;\n}\n.str-chat__message-attachment-container,\n.str-chat__message-simple-attachment-container {\n  display: flex;\n  flex-direction: column;\n}\n.str-chat__message-text,\n.str-chat__message-simple-text {\n  display: inline-flex;\n  justify-content: flex-start;\n  padding: 0 0 0 0;\n  position: relative;\n  width: 100%;\n}\n.str-chat__message-text-inner,\n.str-chat__message-simple-text-inner {\n  position: relative;\n  flex: 1;\n  display: block;\n  min-height: 32px;\n  padding: 5px 10px;\n  font-size: 15px;\n  /* variables */\n  color: black;\n  /* variables */\n  border-radius: 16px 16px 16px 0;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  margin-left: 0;\n  /* set spacing when unfocused */\n  /* if text consists is focused */\n  /* if text consists of just one emoji */\n}\n.str-chat__message-text-inner p,\n.str-chat__message-simple-text-inner p {\n  /* Make sure really long urls and words don't break out.\n        ** https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/ */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  /* Adds a hyphen where the word breaks, if supported (No Blink) */\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto;\n}\n.str-chat__message-text-inner--focused,\n.str-chat__message-simple-text-inner--focused {\n  background: #bcd8ff;\n  border: 1px solid #006cff;\n  margin-right: 0;\n  margin-left: 0;\n  /* set spacing when focused */\n}\n.str-chat__message-text-inner--has-attachment,\n.str-chat__message-simple-text-inner--has-attachment {\n  border-radius: 2px 16px 16px 2px;\n}\n.str-chat__message-text-inner--is-emoji,\n.str-chat__message-simple-text-inner--is-emoji {\n  background: transparent;\n  border: 1px solid transparent;\n  font-size: 32px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.str-chat__message-attachment--img,\n.str-chat__message-simple-attachment--img {\n  width: 100%;\n  max-width: 480px;\n  display: block;\n  height: inherit;\n  cursor: -moz-zoom-in;\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n}\n.str-chat__message-data,\n.str-chat__message-simple-data {\n  margin-top: 5px;\n  width: 100%;\n  font-size: 11px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.str-chat__message-name,\n.str-chat__message-simple-name {\n  font-weight: 700;\n  margin-right: 5px;\n}\n.str-chat__message p,\n.str-chat__message-simple p {\n  margin: 0;\n  white-space: pre-line;\n  line-height: 20px;\n}\n.str-chat__message p:not(:first-of-type),\n.str-chat__message-simple p:not(:first-of-type) {\n  margin: 16px 0 0;\n}\n.str-chat__message--me,\n.str-chat__message-simple--me {\n  display: flex;\n  margin: 4px 0;\n  justify-content: flex-end;\n}\n.str-chat__message--me .str-chat__message-text,\n.str-chat__message-simple--me .str-chat__message-text {\n  display: flex;\n  justify-content: flex-end;\n}\n.str-chat__message--me .str-chat__message-attachment-container,\n.str-chat__message-simple--me .str-chat__message-attachment-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.str-chat__message--me .str-chat__message-inner,\n.str-chat__message-simple--me .str-chat__message-inner {\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n@media screen and (min-width: 420px) {\n  .str-chat__message--me .str-chat__message-inner,\n  .str-chat__message-simple--me .str-chat__message-inner {\n    margin-right: unset;\n    margin-left: 90px;\n  }\n}\n.str-chat__message--me\n  .str-chat__message-inner\n  > .str-chat__message-simple__actions,\n.str-chat__message-simple--me\n  .str-chat__message-inner\n  > .str-chat__message-simple__actions {\n  position: absolute;\n  top: 5px;\n  left: unset;\n  right: 100%;\n}\n.str-chat__message--me .str-chat__message-text-inner,\n.str-chat__message-simple--me .str-chat__message-text-inner {\n  flex: initial;\n  background: #ebebeb;\n  border-color: transparent;\n  text-align: right;\n  border-radius: 16px 16px 2px 16px;\n  margin-right: 0;\n  /* set spacing when unfocused */\n}\n.str-chat__message--me .str-chat__message-text-inner--focused,\n.str-chat__message-simple--me .str-chat__message-text-inner--focused {\n  background: #bcd8ff;\n  border: 1px solid #006cff;\n  margin-left: 0;\n  margin-right: 0;\n  /* set spacing when focused */\n}\n.str-chat__message--me .str-chat__message-text-inner--has-attachment,\n.str-chat__message-simple--me .str-chat__message-text-inner--has-attachment {\n  border-radius: 16px 2px 2px 16px;\n}\n.str-chat__message--me .str-chat__message-text-inner--is-emoji,\n.str-chat__message-simple--me .str-chat__message-text-inner--is-emoji {\n  background: transparent;\n  border: 1px solid transparent;\n  font-size: 32px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.str-chat__message--me .str-chat__message-text-inner--is-emoji p,\n.str-chat__message-simple--me .str-chat__message-text-inner--is-emoji p {\n  line-height: 48px;\n}\n.str-chat__message--me .str-chat__message-attachment--img,\n.str-chat__message-simple--me .str-chat__message-attachment--img {\n  width: 100%;\n  max-width: 480px;\n  display: block;\n  height: inherit;\n  object-fit: cover;\n  border: none;\n}\n.str-chat__message--me .str-chat__message-data,\n.str-chat__message-simple--me .str-chat__message-data {\n  text-align: right;\n}\n.str-chat__message--with-reactions,\n.str-chat__message-simple--with-reactions {\n  margin-top: 30px;\n}\n.str-chat__message-link,\n.str-chat__message-simple-link {\n  color: magenta;\n  font-weight: 700;\n  text-decoration: none;\n}\n.str-chat__message-mention,\n.str-chat__message-simple-mention {\n  margin: 0;\n  padding: 0;\n  background: none;\n  border: none;\n  font-size: 16px;\n  color: magenta;\n  font-weight: 700;\n}\n.str-chat__message--inner,\n.str-chat__message-simple--inner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.str-chat__message--deleted,\n.str-chat__message-simple--deleted {\n  margin: 0 0 0 42px;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.str-chat__message--deleted-inner,\n.str-chat__message-simple--deleted-inner {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px 16px;\n  border-radius: 16px;\n  font-size: 12px;\n  color: #a4a4a4;\n}\n.str-chat__message--me.str-chat__message--deleted,\n.str-chat__message-simple--me.str-chat__message--deleted {\n  margin: 0 42px 0 0;\n  align-items: flex-end;\n}\n.str-chat__message--me.str-chat__message--deleted-inner,\n.str-chat__message-simple--me.str-chat__message--deleted-inner {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 8px 16px;\n  border-radius: 16px;\n  font-size: 12px;\n  color: #a4a4a4;\n}\n.str-chat__message--error,\n.str-chat__message--failed,\n.str-chat__message-simple--error,\n.str-chat__message-simple--failed {\n  margin: 0 0 32px 42px;\n  font-size: 12px;\n  padding: 4px 0;\n}\n.str-chat__message--error .str-chat__message-text-inner,\n.str-chat__message--failed .str-chat__message-text-inner,\n.str-chat__message-simple--error .str-chat__message-text-inner,\n.str-chat__message-simple--failed .str-chat__message-text-inner {\n  background: rgba(208, 2, 27, 0.1);\n  border: 1px solid rgba(208, 2, 27, 0.1);\n}\n.str-chat__message--me.str-chat__message--error,\n.str-chat__message--me.str-chat__message--failed,\n.str-chat__message-simple--me.str-chat__message--error,\n.str-chat__message-simple--me.str-chat__message--failed {\n  border-left: initial;\n  margin-right: 42px;\n}\n.str-chat__message .str-chat__message-attachment-file--item:hover,\n.str-chat__message-simple .str-chat__message-attachment-file--item:hover {\n  background: transparent;\n}\n\n.messaging.str-chat .str-chat {\n  /* __li*/\n}\n.messaging.str-chat .str-chat__message,\n.messaging.str-chat .str-chat__message--me {\n  margin: 1px 0;\n}\n.messaging.str-chat .str-chat__message--with-reactions,\n.messaging.str-chat .str-chat__message--me--with-reactions {\n  margin-top: 30px;\n}\n.messaging.str-chat .str-chat__message-attachment--image {\n  margin: 1px 0;\n  max-width: 480px;\n}\n.messaging.str-chat .str-chat__message-attachment--card {\n  margin: 1px 0;\n  line-height: normal;\n}\n.messaging.str-chat .str-chat__message-attachment-card {\n  margin: 1px auto;\n  line-height: normal;\n}\n.messaging.str-chat .str-chat__message-attachment-card--title {\n  color: #006cff;\n}\n.messaging.str-chat .str-chat__message-attachment-card--text {\n  display: none;\n}\n.messaging.str-chat .str-chat__message-attachment-card--url {\n  text-transform: lowercase;\n}\n.messaging.str-chat .str-chat__message--deleted {\n  margin: 0 42px;\n}\n.messaging.str-chat\n  .str-chat__li--middle\n  .str-chat__message\n  .str-chat__message-attachment--card,\n.messaging.str-chat\n  .str-chat__li--middle\n  .str-chat__message\n  .str-chat__message-attachment--image {\n  border-top-left-radius: 2px;\n}\n\n.str-chat__message-simple {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\n.str-chat__message-simple__actions {\n  display: flex;\n  margin-top: 5px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  min-width: 90px;\n}\n.str-chat__message-simple__actions__action {\n  margin: 5px;\n  display: flex;\n  align-items: center;\n  height: 10px;\n  cursor: pointer;\n}\n.str-chat__message-simple__actions__action svg {\n  fill: #000;\n  opacity: 0.5;\n}\n.str-chat__message-simple__actions__action:hover svg {\n  opacity: 1;\n}\n.str-chat__message-simple__actions__action--thread,\n.str-chat__message-simple__actions__action--reactions {\n  display: none;\n}\n.str-chat__message-simple__actions__action--options {\n  position: relative;\n  display: none;\n}\n.str-chat__message-simple.str-chat__message--with-reactions\n  .str-chat__message-simple__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-simple:hover\n  .str-chat__message-simple__actions__action--thread {\n  display: flex;\n}\n.str-chat__message-simple:hover\n  .str-chat__message-simple__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-simple-text {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 0 0 0;\n  position: relative;\n}\n.str-chat__message-simple-text-inner {\n  text-align: left;\n  max-width: 460px;\n}\n.str-chat__message-simple-text-inner.str-chat__message-simple-text-inner--is-emoji {\n  margin: 5px 0;\n  background: transparent;\n}\n.str-chat__message-simple-text-inner.str-chat__message-simple-text-inner--is-emoji\n  p {\n  line-height: 48px;\n}\n.str-chat__message-simple-text-inner p {\n  text-align: left;\n}\n.str-chat__message-simple-text-inner a {\n  color: #006cff;\n  font-weight: 700;\n  text-decoration: none;\n}\n.str-chat__message-simple-text-inner blockquote {\n  margin: 0 0 0 5px;\n  font-style: italic;\n  padding-left: 20px;\n  position: relative;\n}\n.str-chat__message-simple-text-inner blockquote::before {\n  font-size: 25px;\n  content: '\\201C';\n  font-style: italic;\n  position: absolute;\n  opacity: 0.5;\n  top: 2px;\n  left: -5px;\n}\n.str-chat__message-simple--me .str-chat__message-simple-reply-button {\n  display: flex;\n  justify-content: flex-end;\n}\n.str-chat__message-simple--me\n  .str-chat__message-simple-reply-button\n  .str-chat__message-replies-count-button {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.str-chat__message-simple--me\n  .str-chat__message-simple-reply-button\n  .str-chat__message-replies-count-button\n  svg {\n  transform: scaleX(-1);\n  margin-left: 5px;\n  margin-bottom: 4px;\n  margin-right: 0;\n}\n.str-chat__message-simple--me .str-chat__message-simple__actions {\n  justify-content: flex-end;\n}\n.str-chat__message-simple--me .str-chat__message-attachment--image {\n  max-width: 460px;\n}\n.str-chat__message-simple--me-text-inner--is-emoji {\n  background-color: transparent;\n  line-height: 32px;\n}\n.str-chat__message-simple--me .str-chat__message-simple__actions {\n  order: -1;\n}\n.str-chat__message-simple:hover\n  .str-chat__message-simple__actions__action--options {\n  display: flex;\n}\n.str-chat__message-simple:hover\n  .str-chat__message-simple__actions__action--reactions {\n  display: flex;\n}\n.str-chat__message-simple:hover\n  .str-chat__message-simple__actions__action--thread {\n  display: flex;\n}\n\n.str-chat__simple-message--error-message {\n  text-align: left;\n  text-transform: uppercase;\n  font-size: 11px;\n  opacity: 0.5;\n}\n\n.str-chat__message-simple-status {\n  margin: 10px 0px 10px 10px;\n  order: 3;\n  position: absolute;\n  left: 100%;\n  bottom: 0;\n  line-height: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  z-index: 1;\n}\n.str-chat__message-simple-status-number {\n  font-size: 10px;\n  margin-left: 4px;\n  position: absolute;\n  left: 100%;\n  color: rgba(0, 0, 0, 0.6);\n}\n.str-chat__message-simple-status > .str-chat__avatar {\n  align-self: flex-end;\n  margin-right: 0;\n}\n.str-chat__message-simple-status > .str-chat__tooltip {\n  display: none;\n  max-width: 300px;\n  min-width: 100px;\n  text-align: center;\n}\n.str-chat__message-simple-status:hover > .str-chat__tooltip {\n  display: block;\n}\n.str-chat__message-simple-status::after {\n  position: absolute;\n  bottom: 100%;\n  right: 0;\n  content: ' ';\n  width: 15px;\n  height: 15px;\n}\n\n.str-chat__message-simple .str-chat__message-attachment-card {\n  margin: 0;\n  border-radius: 4px 16px 4px 4px;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n.str-chat__message-simple .str-chat__message-attachment-card--content {\n  background: #ebebeb;\n}\n.str-chat__message-simple .str-chat__message-attachment-card--text {\n  display: none;\n}\n\n.str-chat__message-simple .str-chat__message-attachment--file {\n  margin: 0;\n  background: white;\n  border-color: transparent;\n  border: 1px solid #ebebeb;\n  border-radius: 0;\n}\n.str-chat__message-simple\n  .str-chat__message-attachment--file\n  .str-chat__message-attachment-file--item {\n  border-color: transparent;\n  padding: 0 10px;\n}\n.str-chat__message-simple .str-chat__message-attachment--file:first-of-type {\n  border-radius: 16px 16px 0 0;\n  border-bottom: transparent;\n}\n.str-chat__message-simple .str-chat__message-attachment--file:last-of-type {\n  border-top-color: transparent;\n  border-radius: 0 0 16px 2px;\n}\n.str-chat__message-simple\n  .str-chat__message-attachment--file:last-of-type:first-of-type {\n  border-bottom: 1px solid #ebebeb;\n  border-top: 1px solid #ebebeb;\n  border-radius: 16px 16px 16px 2px;\n}\n\n.str-chat__message-simple .str-chat__message-attachment-file--item {\n  border-radius: 0;\n}\n\n.str-chat__message-simple--me .str-chat__message-attachment-card {\n  border-radius: 16px 4px 4px 4px;\n}\n\n.str-chat__message-simple--me .str-chat__message-attachment--file {\n  background: #ebebeb;\n}\n.str-chat__message-simple--me .str-chat__message-attachment--file:last-of-type {\n  border-radius: 0 0 2px 16px;\n}\n.str-chat__message-simple--me\n  .str-chat__message-attachment--file:last-of-type:first-of-type {\n  border-radius: 16px 16px 2px 16px;\n}\n\n.str-chat__list--thread .str-chat__message-simple__actions {\n  width: 30px;\n}\n\n.str-chat__list--thread\n  .str-chat__message-simple__actions__action--options\n  .str-chat__message-actions-box {\n  right: unset;\n  left: 100%;\n  border-radius: 16px 16px 16px 2px;\n}\n\n.livestream.str-chat .str-chat__li--single {\n  margin: 0px 0;\n}\n\n@media screen and (max-width: 960px) {\n  .str-chat__message-simple-text-inner {\n    max-width: 218px;\n  }\n  .str-chat__message-simple-status {\n    left: unset;\n    right: 8px;\n    bottom: 30px;\n  }\n}\n\n.dark.str-chat .str-chat__message-simple-text-inner {\n  background: rgba(255, 255, 255, 0.05);\n  color: white;\n}\n.dark.str-chat .str-chat__message-simple-text-inner--is-emoji {\n  background: transparent;\n}\n\n.dark.str-chat .str-chat__message-simple__actions svg {\n  fill: white;\n}\n\n.dark.str-chat .str-chat__message-simple-data {\n  color: white;\n  opacity: 0.5;\n}\n\n.dark.str-chat .str-chat__message-simple .str-chat__message-attachment-card {\n  background: transparent;\n}\n.dark.str-chat\n  .str-chat__message-simple\n  .str-chat__message-attachment-card--content {\n  background: rgba(255, 255, 255, 0.05);\n}\n.dark.str-chat\n  .str-chat__message-simple\n  .str-chat__message-attachment-card--url {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file {\n  border-color: transparent;\n  background: rgba(255, 255, 255, 0.05);\n}\n.dark.str-chat .str-chat__message-simple .str-chat__message-attachment--file a,\n.dark.str-chat\n  .str-chat__message-simple\n  .str-chat__message-attachment--file\n  span {\n  color: white;\n}\n.dark.str-chat\n  .str-chat__message-simple\n  .str-chat__message-attachment--file\n  span {\n  opacity: 0.5;\n}\n\n.dark.str-chat\n  .str-chat__message-simple\n  .str-chat__message-simple-status-number {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.dark.str-chat\n  .str-chat__message-simple--me\n  .str-chat__message-simple-text-inner {\n  background: rgba(0, 0, 0, 0.2);\n}\n.dark.str-chat\n  .str-chat__message-simple--me\n  .str-chat__message-simple-text-inner--is-emoji {\n  background: transparent;\n}\n\n.dark.str-chat\n  .str-chat__message-simple--me\n  .str-chat__message-simple\n  .str-chat__message-attachment-card--content {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.dark.str-chat\n  .str-chat__message-simple--me\n  .str-chat__message-simple\n  .str-chat__message-attachment--file {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.dark.str-chat\n  .str-chat__message-simple__actions__action--options\n  .str-chat__actions-box {\n  background: #67686a;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.22), 0 1px 0 0 rgba(0, 0, 0, 0.08),\n    0 1px 8px 0 rgba(0, 0, 0, 0.05);\n}\n\n.dark.str-chat .str-chat__message--error .str-chat__message-simple-text-inner,\n.dark.str-chat .str-chat__message--failed .str-chat__message-simple-text-inner {\n  background: rgba(208, 2, 27, 0.1);\n  border: 1px solid rgba(208, 2, 27, 0.1);\n}\n\n.str-chat__message\n  .str-chat__message-simple__actions__action--options\n  .str-chat__message-actions-box {\n  left: 100%;\n  right: unset;\n}\n.str-chat__message\n  .str-chat__message-simple__actions__action--options\n  .str-chat__message-actions-box--reverse {\n  right: 100%;\n  left: unset;\n  border-radius: 16px 16px 2px 16px;\n}\n\n.str-chat__message\n  .str-chat__message-simple__actions__action--options\n  .str-chat__message-actions-box--mine {\n  right: 100%;\n  left: unset;\n  border-radius: 16px 16px 2px 16px;\n}\n.str-chat__message\n  .str-chat__message-simple__actions__action--options\n  .str-chat__message-actions-box--mine.str-chat__message-actions-box--reverse {\n  left: 100%;\n  right: unset;\n  border-radius: 16px 16px 16px 2px;\n}\n\n.str-chat__message a[href^='mailto:'] {\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  hyphens: none;\n}\n\n@media screen and (max-width: 375px) {\n  .str-chat__message .str-chat__message-attachment--img {\n    max-width: 235px;\n  }\n}\n\n@media screen and (max-width: 414px) {\n  .str-chat__message .str-chat__message-attachment--img {\n    max-width: 274px;\n  }\n}\n\n@media only screen and (device-width: 375px) and (-webkit-device-pixel-ratio: 3) {\n  .str-chat__message .str-chat__message-attachment--img {\n    max-width: 240px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
